import common from './jwys/common_en';
import footer from './jwys/system/footer_en';
import waybillFill from './jwys/send/waybillFill_en';
import emptyVanBook from './jwys/send/emptyVanBook_en';
import transportStatistics from "./jwys/order/transportStatistics_en";

//按照菜单顺序从左到右，子菜单从上到下排序
export default {
  //公共部分
  common,

  //TODO 首页


  //TODO 首页end


  //TODO 发送业务

  //TODO 发送业务end


  //TODO 到达业务
  emptyVanBook,//铁路箱预定
  waybillFill,//自备箱发货
  //TODO 到达业务end
  arrivalBusiness: {
    cxtj: 'Submit it again',
    sfjz: 'Whether to enter the station',
    wjz: 'Not in station',
    yjz: 'Pulled in',
    sczt: 'Deletion status',
    ysc: 'Deleted',
    wsc: 'Not deleted',
    pdr: 'Dispatcher',
    ygq: 'Expired',
    yscz: 'Canceled',
  },

  //TODO 货运服务

  //TODO 货运服务end


  //TODO 办理指南

  //TODO 办理指南end


  //TODO 联系我们

  //TODO 联系我们end


  //TODO 我的订单
  transportStatistics,
  //TODO 我的订单end


  //TODO 系统设置
  footer,
  //TODO 系统设置end
  jzxyz: {
    hxzt: 'Container return status',
    cmrq: 'Door exit date',
    sscz: 'Affiliated station',
    hxsq: 'Application for container return',
    hxqr: 'Confirmation of container return',
    jkh: 'Container truck No.',
    qrm: 'Confirmation code',
    yqrhx: 'Container return confirmed'
  },
  roleManagement: {
    czlx: 'Operation type',
    czjg: 'Operation results',
    cznr: 'Operation contents:',
    // bbh:'版本号',
    // bbmc:'版本名称',
    // bbxt:'版本系统',
    // gxtsy:'更新提示语',
    // sfqz:'是否强制',
    // bxy:'不需要',
    // xy:'需要',

    czsj: 'Operation time:',
    jsmc: 'Role name',
    ms: 'describe',
    czysl: 'Number of operators',
    cjsj: 'Creation time:',
    jsxx: 'Role information',
    qxxx: 'permissions information',
    zs1: 'Please enter a role name with no more than 50 characters',
    zs2: 'Please enter a description with no more than 50 words',
    czyh: 'Operator number',
    czyxm: 'Operator Name',
    czylx: 'Operator type',
    tlj: 'Railway Bureau',
    qsrtlj: 'Please enter Railway Bureau',
    zm: 'Station name',
    qsrzm: 'Please enter the station name',
    tjsj: 'Add time:',
    mmcz: 'Password Reset',
    zhxx: 'account information',
    ssj: 'Subordinate Bureau',
    ssz: 'Affiliated station',
    zcyjs: 'OPER role',
    qtxx: 'Other information',
    sjh: 'cell-phone number',
    sfzhm: 'ID card No',


  },
  index: {
    jzxYz: 'Container operation',
    zwhx: 'Container return outside the station',
    sy: 'Homepage',
    ysfw: 'transportation services',
    smjy: 'business transaction',
    tsyjy: 'Complaints and suggestions',
    gjfw: 'International services',
    tlxyd: 'Railway container reservation',
    tlxydllys: 'Railway container booking—cold-chain transport',
    glydtx: 'Fill in the international through transport waybill',
    rxqtx: 'Fill in the daily demand',
    gjfw1: 'Providing you with“',
    gjfw2: 'fast, reliable and stable',
    gjfw3: '”high-quality and cross-border railway transportation services',
    gnfw: '”high-quality and exclusive railway transportation services in Laos.',
    zbxfh: 'Using self-provided containers',
    zbxfhllys: 'Shippment with self-owned containers—cold chain transport',
    gnfwt: 'Domestic services',
    lyfwp: '”High-quality railway cold-chain transportation services.',
    lyfwt: 'Domestic services',

    title: 'Laos-China Railway International Logistics',
    hello: 'Hello',
    grsz: 'personal settings',
    yhxxwh: 'User information maintenance',
    shxx: 'Receiving information',
    fhxx: 'Delivery information',
    hz_hdbd: 'Owner/freight forwarder binding',
    jbrgl: 'Manage handlers',
    xgmm: 'Change Password',
    tcdl: 'Log out',
    fsyw: 'Delivery business',
    gjly: 'International intermodal transport',
    gnys: 'Domestic transport',
    yxqtb: 'Monthly demand submission',
    rxqtb: 'Daily demand submission',
    glydtb: 'Fill in the international through rail waybill',
    zx: 'Refill box No',
    ddyw: 'Arrival service',
    yylx: 'Appointment for pick-up',
    yyhx: 'Appointment for return of containers ',
    hyfw: 'Freight service',
    hwzz: 'Cargo tracking',
    glhwzz: 'International through transport cargo tracking',
    gnhwzz: 'Domestic cargo tracking',
    ddyc: 'Arrival prediction',
    zxcxx: 'Loading and unloading information',
    yfcx: 'Freight query',
    hwlp: 'Goods claims',
    blzn: 'Guide',
    baox: 'Insurance',
    lxwm: 'Contact us',
    tsjy: 'Complaints and suggestions',
    myOrders: 'My order',
    ddzx: 'Order center',
    yxqlb: 'Monthly demand list',
    ydxlb: 'List of reserved containers',
    rxqlb: 'Daily demand list',
    glydlb: 'List of international through rail waybills',
    ydzf: 'Waybill invalidation',
    czyxglyd: "Valid international intermodal transport waybills are not allowed to be voided",
    hytj: 'Freight transport statistics',
    jqsddcx: 'Pick-up and delivery order query',
    jqsddcqr: 'Signing of the pick-up and delivery order',
    wdpj: 'My bills',
    yfkjymx: 'Breakdown of advance payment transaction',
    pjqr: 'Bill confirmation',
    qrtczh: 'Sure to log out the current account?',
    tis: 'Tips',
    qd: 'Confirmed',
    qx: 'Cancel',
    ydh_xh: 'Waybill number/Container No.',
    qsrydh_xh: 'Please enter the waybill/container number',
    sjhm: 'Mobile phone',
    yzm: 'Verification code',
    djhq: 'Click for acquisition',
    ljcx: 'Query immediately',
    wyfh: 'I want to deliver goods',
    wylh: 'I want to pick up goods',
    ywzd: 'Business guidance',
    czfw: 'Station service',
    xwzx: 'News',
    ckqb: 'View all',
    tzgg: 'Notice and announcement',
    xxcxblzn: 'Information query and handling guide',
    qsryzm: 'Please enter the verification code',
    appxz: 'App download',
    fwcx: 'Service query',
    fwrx: 'Service hotline',
    wtfk: 'Feedback',
    yyxz: 'Language selection',
    glydtbllys: 'Fill out the international through transport waybill - cold-chain transport',
    cxfy: 'Bill query',
    czxx: 'Station information',
    bllc: 'Handling process',
  },
  oneClickDelivery: {
    blhg: 'Records of going through customs and other administrative formalities',
    fhrsm: "Consignor's statement",
    tip255: 'Empty container',
    tip476: 'Loaded container',
    tip260: 'Empty/loaded status',
    qxzkhmc: 'Please select customer name',
    yjfh: 'One-click shipping',
    apxs: 'Number of containers arranged',
    fh: 'Delivery',
    kxxx: 'Empty container information',
    bjzz: 'Marked gross weight (KG)',
    tpinfo: 'The following information must be consistent with that on the customs declaration form. Please enter it carefully',
    ghhthm: 'Supply contract No.',
    ycyrwgxx: 'Information not related to the carrier',
    dpx: 'Container to be allocated',
    ypx: 'Container allocated',
    txw: 'Container allocation completed',
    lxtz: 'Container collection notice',
    jzyy: 'Reservation for station entry',
    jzxydh: 'Container booking No.',
    lxlx: 'Type of container to be collected',
    xxx: 'Container information',
    tzsj: 'Time of notice',
    qyyjz: 'Make a reservation for station entry',
    yylx: 'Type of reservation',
    yyjzrq: 'Reserved station entry date',
    cheh: 'Withdrawal',
    ckjzm: 'Check the station entry code',
    lx: 'Container collection',
    sx: 'Container return',
    jzlx: 'Arrival type',
    jzrq: 'Station entry date',
    xzxqd: 'Select the demand list',
    jqsdfw: 'Pick-up and delivery services',
    wlgs: 'Logistics company',
    qsdz: 'Pick-up and delivery addresses',
    kch: 'Truck No.',
    siji: 'Driver',
    xzmdzshqkkchhsj:'When door-to-CFS is selected, the truck No. and driver content will be cleared. Are you sure to continue?',
    txrqddrq: 'Container pick-up/arrival date',
    qxzcz: 'Please select the station',
    qwsjzyyxx: 'Please complete the details for station entry reservation',
    jzm: 'Station entry code',
    yxqx: 'Term of validity',
    lckm: 'Kilometrage (km)',
    ysrqts: 'Fill in if a shipping date has been determined.',
    dxxx: 'Booking information',
    dxxxts: 'Please enter the information after selecting the monthly demand',
    kxxxts: 'Display after acceptance by the station',
    ysxxts: 'Please enter the information after determining the shipping date',
    sfch: "Withdraw or not",
    bljd: "Processing progress",
    yjzlkx: "Has entered the station (empty container collection)",
    yczlkx: "Waiting for entering the station (loaded container delivery)",
    yjzszx: "Has entered the station (loaded container delivery)",
    yczszx: "Has entered the station (loaded container collection)",
    yjzlzx: "Has entered the station (loaded container collection)",
    yczlzx: "Waiting for entering the station (empty container delivery)",
    yjzskx: "Has entered the station (empty container delivery)",
    yczskx: "Has left the station (empty container delivery)",
  },
  accept: {
    tbsj: 'Reporting time',
    qxz: 'Please select',
    zt: 'State',
    dsl: 'Pending',
    sltg: 'Accepted',
    yzf: 'Voided',
    cx: 'Query',
    qk: 'empty',
    tjjy: 'Submit suggestions',
    dsltsjy: 'Complaints and suggestions to be accepted',
    t: 'strip',
    slsj: 'Acceptance time:',
    tszt: 'Complaint subject:',
    tsnr: 'Complaint content',
    fj: 'enclosure',
    ck: 'see',
    tsz: 'Complaint station',
    tsrxm: 'Name of complainant',
    tsrsfzhm: 'ID card number of the complainant',
    lxfs: 'contact information',
    yx: 'mailbox',
    yb: 'Zip code:',
    tsrdz: 'Address of the complainant',
    cz: 'Operation',
    slxq: 'Acceptance details',
    sl: 'Acceptance',
    zf: 'to void',
    slyj: 'Acceptance opinions',
    qx: 'Cancel',
    qd: 'determine',
    qsrnr: 'Please enter the content',
    jdxq: 'Progress details',
    sljg: 'Acceptance result',
    czy: 'operator',
    fjlb: 'Attachment list',
    zxyl: 'Online preview',
    xz: 'download',
    tsjy: 'Complaints and suggestions',
    jbxx: 'essential information',
    tsxx: 'Complaint information',
    scfj: 'Upload attachment',
    jwjtdcc: 'Drag the file here, or',
    djsc: 'Click upload',
    tj: 'Submit',
    fh: 'return',

  },
  backlog: {
    fhf: 'Shipper',
    shf: 'Consignee',
    hydl: 'Welcome to login',
    nscdlsjs: 'Your last login time is',
    dbsx: 'To do',
    zcsh: 'Registration review',
    qyxxxgsh: 'Enterprise information modification review',
    jdxqsl: 'Stage demand acceptance',
    rxqsl: 'Daily demand acceptance',
    zcxhtsh: 'Review of medium and long term outsourcing contracts',
    lpsl: 'Claim acceptance',
    tsjy: 'Complaints and suggestions',
    ycktx: 'Withdrawal of advance deposit',
    ltgl: 'Forum management',
    zxhf: 'Latest reply',
    htzs: 'Total number of topics',
    t: 'strip',
    xh: 'Serial number',
    tbsj: 'Reporting time',
    xm: 'full name',
    sfzh: 'ID number',
    js: 'role',
    qymc: 'Enterprise name:',
    cz: 'Operation',
    sh: 'to examine',
    yhmc: 'User name:',
    jdxqh: 'Stage demand No',
    hwpm: 'Name of goods',
    ds: 'Tonnage',
    tyf: 'Shipper',
    sl: 'Acceptance',
    rxqtbsl: 'Daily demand submission and acceptance',
    xqdh: 'Demand No.:',
    xqcs: 'Number of vehicles required',
    fz: 'Departure station',
    dz: 'arrive at a station',
    ddbgsl: 'Arrival change acceptance',
    cc: 'Train number',
    clzt: 'Vehicle status',
    bgdz: 'Change arrival',
    bgshf: 'Change receiver',
    hth: 'Contract No.:',
    tbqy: 'Submitting enterprise',
    ydh: 'Waybill No',
    ht: 'topic of conversation',
    xq: 'details',
    ycktxsh: 'Review of advance deposit withdrawal',
    txje: 'Withdrawal amount (yuan)',

  },
  containerDelate: {
    crumbs0: 'container',
    crumbs1: 'Void the waybill',
    xqdgl: 'Demand Management',
    ydzfts: 'Railway container cannot be invalidated after adding the container No.! Please return the container(en)',
    ydhw: 'The waybill No. is)',
    jdjhh: 'Stage plan No.',
    hyxhdsjbkzf: "Data containing container No. cannot be invalidated",
    xgjdjh: "Modify the stage plan",
    qxzxtydhsj: "Please select the same booking No. data"
  },
  freightInfo: {
    zfrq: 'Payment date',
    pjlx: 'Bill Type',
    zf: 'incidental',
    yf: 'freight',
    zt: 'Heterozygous regression',
    yt: 'Freight refund',
    zhuangt: 'State',
    yzf: 'Paid',
    dzf: 'To be paid',
    zfzt: 'Payment status',
    fkr: 'drawee',
    zfsj: 'Payment time',
    zhifu: 'payment',
    tk: 'refund',
    ytk: 'Refunded',
    plzf: 'Batch payment',
    fy: 'cost',
    yck: 'Advance deposit',
    xj: 'cash',
    bczf: 'This payment',
    yebz: 'Insufficient balance, please go to the pre deposit management interface to recharge!',

    hsxx: 'Verify information',
    he: 'Verify',
    jq: 'Receiving',
    sd: 'Delivery',
    nr: 'Contents',
    gxrq: 'Update date',
    qsrfplx: 'Please input invoice type',
    xxxxrxdz: 'Details are as follows, address',
    qsrtlj: 'Please input the railway administration',
    wjlqywd: 'In order to establish enterprise files and display enterprises on the trading platform, please fill in the enterprise profile in detail.',
    sczj: 'Upload certificate',
    shtg: 'Approved',
    swdjdz: 'Tax registration address',
    qygflj: 'Official link of enterprise',
    sh: 'Reviewed by',
    jymx: 'Transaction details',
    czje: 'Recharge amount',
    ydbs: 'Number of waybills',
    ydfy: 'Waybill fee',
    hzbs: 'Number of freight and general cargo transport',
    hzfy: 'Fee of freight and general cargo transport',
    tkbs: 'Number of refunds',
    tkfy: 'Refund fee',
    ckpz: 'View voucher',
    yfzf: 'Freight payment',
    tbr: 'Filled by',
    ptjl: 'General records',
    fhjbr: 'Delivery handler',
    fhjbrdh: 'Telephone number of delivery handler',
    xxxh: 'Container type and number',
    zj: 'Primary key',
    dfrq: 'Arrival and departure date',
    cljjd: 'Vehicle handover list',
    glyd: 'International through rail waybill',
    cljjdh: 'Vehicle handover list No.',
    nf: 'Year',
    gjzmc: 'Frontier station name',
    jfcyrmc: 'Name of delivery carrier',
    jscyrmc: 'Name of receiving carrier',
    zcs: 'Number of loaded cars',
    kcs: 'Number of empty cars',
    hwjjdh: 'Goods handover list No.',
    jjdmc: 'Handover station name',
    lccc: 'Train No.'
  },
  advancePayStation: {
    khmc: 'Customer Name',
    qsrkhmc: 'Please enter the customer name',
    yckye: 'Advance deposit balance',
    cz: 'Recharge',
    tx: 'Withdrawal',
    khxxsc: 'Customer information deletion',
    khmcxg: 'Customer name modification',
    khxxbd: 'Customer information binding',
    jymx: 'Transaction Details',
    jylx: 'Transaction Type',
    qxzxqlx: 'Please select a requirement type',
    jysj: 'Transaction time',
    jyls: 'Transaction flow',
    pjh: 'Bill No',
    dycz: 'Offset station',
    bz: 'currency',
    je: 'Amount (yuan)',
    fh: 'return',
    bjpz: 'Edit Voucher',
    czje: 'Recharge amount',
    qsrzcje: 'Please enter the recharge amount',
    qx: 'cancel',
    qd: 'determine',
    xdkhmc: 'New Customer Name',
    khbd: 'Customer binding',
    txje: 'Withdrawal amount',
    qsrtxje: 'Please enter the withdrawal amount',
    yckglyz: 'Pre deposit management verification',
    qsrmm: 'Please input a password',
    xgmm: 'Change Password',
    qsrymm: 'Please enter the original password',
    qsrxmm: 'Please enter the current password',
    qzcsrxmm: 'Please enter the current password again',
    jyxq: 'transaction details',
    czmc: 'Station name',
    rq: 'date',
    ydbs: 'Number of waybills',
    ydfy: 'Waybill cost',
    hzbs: 'Number of miscellaneous goods',
    hzfy: 'Miscellaneous expenses',
    tkbs: 'Number of refunds',
    tkfy: 'Refund fee',
    ckpz: 'View voucher',
  },
  login: {
    bgctext1: 'Transnational transport · global freight transport',
    sjh: 'cell-phone number',
    wyydty: 'I have read and agree',
    yhxy: 'User service agreement',
    he: 'and',
    ysqtk: 'Privacy policy',
    hmzh: 'Don\'t have an account',
    ljzc: 'Register now',
    qnydty: 'Please read and agree',
    xxts: 'Information prompt',
    xyhdwcyz: 'Swipe right to complete verification',

    title: 'Login',
    user: 'user name',
    pwd: 'password',
    code: 'Verification Code',
    jzw: 'Remember me',
    wjmm: 'Forget password',
    word1: 'China-Laos Railway',
    word2: 'Overview',

    word3: 'The Kunming (China) - Vientiane (Laos) Railway is an important construction project for infrastructure connectivity in South Asia and Southeast Asia under China\'s “Belt and Road” initiative. It marks the first overseas railway project invested, constructed, and operated by China directly connecting to the Chinese railway network, with China\'s technical standards and equipment adopted by the whole line.。',
    text1T: 'Kunming Yuxi Section (in operation)',
    text1: 'The main line is 88 km long, double track electrified railway, and the design speed is 200 kn/h。',
    text2T: 'Yuxi Mohan Section (Yumo Section)',
    text2: 'The total length of the line is 508.5km, national railway level, 160km/h electrified railway.',
    text3T: 'Boten Vientiane Section (Boten Vientiane Section)',
    text3: 'The total length of the line is 414.516km, with single track electrification, automatic interstation blocking and design speed of 160km/h.',

    logintip1: 'Registration review failed. Go to the registration page to modify your information?',
    logintip2: 'The account has been frozen. Please contact the administrator',
    logintip3: 'The account has been locked. Please contact the administrator',
    mmdl: 'PasswordLogin',
    dxdl: 'SMSLogin',
    lztlhy: "Laos-China Railway Freight Handling Platform"
  },
  forgetPW: {
    wjmm: 'Forget password',
    sjqjh: 'Mobile phone section number',
    sjh: 'cell-phone number',
    sjyzm: 'Mobile phone verification code ',
    xzmm: 'new password',
    qrmm: 'confirm password',
    qxz: 'Please select',
    qsr: 'Please enter',
    back: 'Return',
    next: 'Next',
    qd: 'confirm',
    qsrmm: 'Please enter password',
    qzcsrmm: 'Please enter password again',
    lcsrmmbyz: 'Two passwords do not match.',
    qsrsjhm: 'Please input phone number',
    qxzsjqh: 'Please select area code for mobile phone',
    qsrdxyzm: 'Please enter SMS verification code',
    hcxhq: 'Acquire again in s',
    hqyzm: 'Obtain the verification code',
    xgcg: 'Modified successfully',
    qdl: 'Go to login',
    qx: 'Cancel',
    mmxgsb: 'Password modification failed!',
  },
  dayDemandApply: {
    rxqtb: 'Daily demand submission',
    qxzysfs: 'Please select transportation mode',
    jzx: 'container',
    zc: 'Complete vehicle',
  },
  containerPreOrder: {
    shzt: "Audit status",
    zti: 'Self-pickup',
    crumbs0: 'container',
    crumbs1: 'Empty container booking',
    khxxt: 'guest',
    khxx: 'The customer information',
    ssqy: 'Affiliated companies',
    select: 'Please select a',
    fhxxt: 'hair',
    fhxx: 'delivery information',
    tyr: 'Shipper',
    fz: 'Departure station',
    fj: 'Set out',
    zcdd: 'Loading place',
    txz: 'Suitcase stand',
    txdz: 'communication address',
    jbr: 'agent',
    sfzh: 'Id number',
    jbrsj: 'Handler\'s phone',
    shxxt: 'closed',
    shxx: 'Receiving information',
    shr: 'consignee',
    dz: 'Arrive station',
    zdz: 'Into standing',
    dj: 'To the bureau',
    xcdd: 'Unloading location',
    bllx: 'Trains type',
    blcc: 'Trains on its',
    dxxxt: 'order',
    dxxx: 'Book case information',
    xl: 'Box class',
    xlmx: 'box class subsidiary',
    xx: 'A box',
    txrq: 'Date of suitcase',
    sfyx: 'Validity',
    yx: "Valid",
    wx: "Invalid",
    syxs: 'remaining container number',
    xs: 'Container number',
    hwmc: 'Item name',
    ysxxt: 'ship',
    ysxx: 'Transportation information',
    zzjgcl: 'Loading reinforcement material',
    cc: 'warehousing',
    lc: 'Cold storage (heat preservation)',
    bxys: 'Transportation insurance',
    jtxcd: 'Specific unloading point',
    jzsx: 'particulars',
    zfszt: 'the',
    zfsz: 'Payment Settings',
    zffs: 'Method of payment',
    yfk: 'Advance payment',
    xj: 'cash',
    zp: 'check',
    yhk: 'Bank card',
    hzzf: 'Collect payment',
    bzxz: 'Currency option',
    jp: 'kip',
    rmb: 'RMB',
    my: 'dollar',
    kydje: 'Bookable amount',
    ldwlt: 'two',
    ldwl: 'Both ends of the logistics',
    ldwlw: 'According to your needs, you can choose to input the delivery, delivery, warehousing and other logistics service information.',
    mdz: 'door station',
    zdm: 'Stand to the door',
    smqh: 'door pickup',
    smsh: 'Door to door delivery',
    licheng: 'mileage(km)',
    qianmi: 'Kilometer',
    shdd: 'Shipping address',
    dianhua: 'Telephone',
    lxrxm: 'Contact name',
    xqsm: 'Requirements description',
    qhdd: 'Pick up address',
    tyrqdjs: 'Number of pieces determined by the shipper',
    qhgsfy: 'Estimated pickup cost',
    tijiao: 'Submit',
    qink: 'empty',
    qkxzy: 'Empty container resources',
    qsrxs: 'Please fill in the number of containers',
    xsw: 'The number of containers is',
    syxsw: 'The number of remaining containers is',
    xsbjdysyxs: 'The number of containers cannot be larger than that of the remaining ones',
    ktxsbndy: 'The number of containers that can be picked up cannot be greater than',
    shxxts: 'For international through transport service, select “Boten (border)” as arrival station, and the actual arrival station as destination station, for example, "Wangjiayingxi".',
    qsrfj: 'Please enter the departure CR regional group',
    qsrtxz: 'Please enter the container pick-up station',
    qsrdj: 'Please enter the arrival CR regional group',
    qsrxshu: 'Please enter the number of containers',
    qxzhwmc: 'Please select cargo name',
    yjxmhjy: 'Only 9-digit numbers can be entered for the tariff item No.',
    khhjy: 'The bank of deposit cannot be null and must not exceed 85 Chinese characters or 170 characters',
    nsdzjy: 'The tax payment address cannot be null, and shall be less than 100 Chinese characters or 200 characters',
    qxzqsdz: 'Please select the starting address',
    qtxqsdz: 'Please enter the starting address, including the street, house number, and other details',
    xxdzcd: 'The detailed address length must be between 8 and 200 characters (one Chinese character is regarded as two characters).',
    qxzmddz: 'Please select the destination address',
    qtxmddz: 'Please enter the destination address, including the street, house number, and other details',
    fsdlxrxm: 'The contact name of the sending end cannot be null',
    fsdhbnwk: 'The telephone of the sending end cannot be null',
    qxzzffs: 'Please select the payment method',
    qxzbz: 'Please select currency',
    qtxjd: 'Please enter the detailed address, including the street, house number, and other details',
    qtxmdz: 'Please enter the door-to-CFS kilometrage information',
    mdzlcxx: 'Only numbers can be entered for door-to-CFS kilometrage information',
    qtxmdztyr: 'Please enter the number of items determined by the door-to-CFS consignor',
    mdztyr: 'Only numbers can be entered for the number of items determined by the door-to-CFS consignor',
    mdzqhfy: 'Only numbers can be entered for the estimated door-to-CFS pick-up cost',
    dddlxr: 'The contact name of the arrival end cannot be null',
    dddlxrcw: 'Wrong contact name of the arrival end',
    ddddh: 'The telephone of the arrival end cannot be null',
    qtxzdm: 'Please enter the CFS-to-door kilometrage information',
    zdmlcxx: 'Only numbers can be entered for CFS-to-door kilometrage information',
    qxzyxsfzj: 'Please select the valid ID document type',
    qtxyxsfzj: 'Please enter the valid ID document number',
    qtxtyrdm: 'Please enter the consignor is unified social credit code',
    qsrtydm: 'Please enter the correct unified social credit code',
    qxzdcrq: 'Please select the car booking date',
    qsrsjshr: 'Please enter the actual consignee name',
    qtxtyjbrxm: 'Please enter the consignment handler name',
    qtxtyjbrsfz: 'Please enter the ID card number of the consignment handler',
    qtxtyjbrsjh: 'Please enter the mobile phone number of the consignment handler',
    qtxshjbrxm: 'Please enter the receiving handler name',
    qtxshjbrsfz: 'Please enter the ID card number of the receiving handler',
    qtxshjbrsjh: 'Please enter the mobile phone number of the receiving handler',
    qsrxl: 'Please enter the container type',
    qsrxlmx: 'Please enter the details of container type',
    qsrxx: 'Please enter the container size',
    tyrthmmyz: 'Only six-digit number passwords can be entered',
    qsrtyrmc: 'Please enter the consignor name',
    qtxtyrqdjs: 'Please enter the number of items determined by the consignor',
    xxxsjy: 'The number of containers must be an even number if the container size is 20 feet',
    fdzbuxt: 'Departure and arrival stations cannot be the same station',
    qxzzfr: 'Please select the payer',
    zfr: 'Payer',
    qxxztyr: 'Please select the consignor first',
    yfkyebz: 'Insufficient balance of advance payment',
    zfrid: 'The payer ID cannot be null',
    dzmdzdz: 'Please select the destination station when the arrival station is Boten (border)',
    xhzzdy: 'The gross weight of containers and cargoes should be greater than cargo weight confirmed by carrier.',
    shenher: 'reviewed by',
    zt: 'State',

  },
  dailyTransportDemand: {
    qxzbgrxqhchec: 'Please select the daily demands or train number to be changed upon arrival',
    dtslrxqbg: 'Please select one accepted and approved daily demands before loading to be changed upon arrival',
    rxqbnbg: 'Daily demands to be accepted/rejected/unloaded/delivered cannot be changed upon arrival',
    dslrxq: 'Please select the daily demands to be accepted',
    td1: 'Demand is being accepted, and cancellation is not supported for now',
    td2: 'Please select the daily demands to be accepted for cancellaton',
    yqxtd: 'Canceled',
    yqx: "Cancelled",
    tdcg: 'Canceled successfully',
    sfqrtd: 'Do you confirm cancellation?',
    yjf: 'Delivered',
    yxc: 'Unloaded',
    yzc: 'Loaded',
    tb: 'Submission',
    xqgj: 'Requirement track',
    t: 'strip',
    qsr: 'Please enter',
    qxzqsrq: 'Please select a start date',
    qxzzzrq: 'Please select an end date',
    qxz: 'Please select',
    qb: 'Whole',
    zzjg: 'Loading reinforcement',
    bx: 'Insurance',
    cc: 'storage',
    gjly: 'International intermodal transport',
    ptys: 'General transportation',
    ytd: 'Unsubscribed',
    crumbs0: 'transportation services',
    crumbs1: 'Daily demand',
    ydlx: 'Waybill type',
    yyh: 'Reservation number',
    xqh: 'Demand number',
    jzxydh: 'Container booking No.',
    fz: 'Departure station',
    tyr: 'Shipper',
    zyrq: 'Date of shipment',
    wpmc: 'Item name',
    shr: 'Consignee',
    tbsj: 'Reporting time',
    rxqzt: 'DemandStatus',
    ckxq: 'View details',
    dsl: 'Pending',
    dddsl: 'Pending dispatch acceptance',
    sltg: 'Accepted and passed',
    yjj: 'Rejected',
    cx: 'Query',
    rxqxj: 'Daily demand new',
    wxts1: 'Warm tip: the submitted daily demand can be queried according to conditions',
    wxts2: 'To create a new one, click create daily demand',
    qsryyh: 'Please enter the reservation number',
    qsrxqh: 'Please enter the demand number',
    dcexcel: 'Export Excel',
    pldy: 'Batch printing',
    ck: 'see',
    drzj: 'Total of the day',
    zt: 'State',
    yslx: 'Transportation type',
    blzb: 'Handling type',
    qqlx: 'Request type',
    zcdd: 'Loading place',
    xcdd: 'Unloading location',
    hwmc: 'Item name',
    wptz: 'Article characteristics',
    xqcs_slcs: 'Number of vehicles required / accepted',
    xqds_slds: 'Demand tonnage / acceptance tonnage',
    cz: 'Vehicle type',
    ystz: 'Transportation characteristics',
    jzsx: 'Record items',
    caozuo: 'Operation',
    dslyyd: 'Multimodal',
    yszyyd: 'Transportation',
    td: 'Unsubscribe',
    zc: 'Complete vehicle',
    jzx: 'Container',
    zq: 'Please',
    bq: 'Supplementary application',
    drgj: 'Total for the day',
    ksrq: 'Start date',
    jsrq: 'End date',

    qsryxq: 'Input monthly demand number',
    qsrtyr: 'Input consignor',
    hztip: 'The owner cannot inquiry delivery status of the goods if his/her name is not filled in',
    qsrzmwjmc: 'Input title of the supporting document',
    qsczmwjtp: 'Upload pictures of the supporting document',
    qsrddgj: 'Input country of arrival',
    qsrkaz: 'Input port station',
    qsrshr: 'Input consignee',
  },
  dailyTransportDemandDetail: {
    gjz: 'Border station',
    ddgj: 'Arrival country',
    ysfw: 'transportation services',
    rysxq: 'Daily transportation demand',
    ysrq: 'Transportation date',
    yyh: 'Reservation number',
    yslx: 'Transportation type',
    xqxx: 'Details',
    hwxx: 'Cargo information',
    hwpm: 'Name of goods',
    hwtz: 'Cargo characteristics',
    ysfs: 'type of shipping',
    fhxx: 'Shipping Information',
    tyf: 'Shipper',
    fz: 'DS',
    fj: 'Development Bureau',
    txdz: 'postal address',
    jbr: 'Handler',
    zcdd: 'Loading place',
    sj: 'mobile phone',
    shxx: 'Receiving information',
    shf: 'Consignee',
    dz: 'arrive at a station',
    dj: 'To the Bureau',
    xcdd: 'Unloading location',
    jqsdxx: 'Receiving delivery information',
    mdz: 'Door to station',
    zdm: 'Stand to the door',
    ysxx: 'Transportation information',
    xqds: 'Demand tonnage',
    xqcs: 'Number of vehicles required',
    cz: 'Vehicle type',
    fw: 'service',
    jzsx: 'Record items',
    dzzfyhfzf: 'Who will pay the arrival fees',
    zffs: 'Payment method',
    bz: 'currency',
    yszyyd: 'Transportation resource reservation',
    w: 'nothing',
    zzsxx: 'VAT information',
    fplx: 'Invoice type',
    spfmc: 'Name of drawee',
    nsrsbh: 'Taxpayer identification number',
    zh: 'account number',
    khh: 'Bank of deposit',
    dh: 'Telephone',
    diz: 'address',
    fh: 'return'
  },
  dailyTransportDemandDetailNew: {
    mz: 'Name:',
    yjxqduns: 'Estimated demand tonnage',
    xqzjxqchec: 'The total amount of your demand this time is: demand train number:',
    qxzscsj: 'Please select data to be deleted',
    drwj: 'Import file',
    qsrcx: 'Please input model',
    hsds: 'Verify tonnage',
    qsrbxje: 'Please input the insurance amount',
    scfjgsbk: 'Upload attachment formats include: picture, PDF, word, excel, txt',
    zzwjsc: 'Uploading of qualification documents—no translation available',
    xxxxrx: 'Details are as follows, address',
    ksrq: 'Start date',
    jsrq: 'End date',
    jdxqdb: 'Stage demand report',
    jdqxh: 'Stage demand No',
    qsrjdxqh: 'Please enter the stage demand number',
    qsrhthyyxyxj: 'Entering the contract number has the following priority',
    qdzccxt: '1. Signing medium and long-term cooperation contracts can improve the priority of resource allocation;',
    qdsmjyht: '2. Sign business transaction contracts to ensure transportation services.',
    yddcx: 'Advance order query',
    ysrq: 'Transportation date',
    qxzzyrq: 'Please select shipment date',
    xqlx: 'Demand type',
    qxzxqlx: 'Please select demand type',
    gjly: 'International intermodal transport',
    ptys: 'General transportation',
    excelImp: 'Excel import',
    xzmb: 'Download template',
    lsxqImp: 'Historical demand import',
    impLsxq: 'Import historical requirements',
    send: 'send',
    fhxx: 'Shipping Information',
    cyfhr: 'Common shipper',
    tyr: 'Shipper',
    qsrtyf: 'Please enter the shipper',
    qsr: 'Please enter',
    fz: 'Departure station',
    fj: 'Development Bureau',
    dj: 'To the Bureau',
    zcdd: 'Loading place',
    zyx: 'Private line',
    tlhc: 'Railway freight yard',
    lxr: 'contacts',
    qsrlxr: 'Please enter contact',
    dh: 'Telephone',
    qsrdh: 'Please enter the phone number',
    txdz: 'mailing address',
    qsrtxdz: 'Please enter the mailing address',
    jbr: 'Handler',
    qsrjbr: 'Please enter the handler',
    sfz: 'ID',
    qsrsfz: 'Please enter your ID card',
    sj: 'mobile phone',
    qsrsj: 'Please enter your mobile phone',
    zffs: 'Payment method',
    collect: 'collect',
    shxx: 'Receiving information',
    cyshf: 'Common consignee',
    ddgj: 'Arrival country',
    gjz: 'Border station',
    qxzgjz: 'Please select a border station',
    shr: 'Consignee',
    qsrshf: 'Please enter the consignee',
    dz: 'arrive at a station',
    xcdd: 'Unloading location',
    goods: 'goods',
    hwxx: 'Cargo information',
    hwpm: 'Name of goods',
    qxzhwm: 'Please select the product name',
    hwtzfrl: 'Cargo characteristics:Calorific value (kcal / kg)',
    ps: 'Fear of dampness',
    bps: 'Not afraid of wet',
    sdz: 'Bulk loading',
    fsdz: 'Non bulk stacking',
    hwms: 'description of the goods',
    qsrhwms: 'Please enter the description of the goods',
    jzzx: 'Header type',
    qxzcx: 'Please select vehicle type',
    cx1: '20 foot 35 ton open top box',
    cx2: '20 foot universal standard box',
    cx3: '40 foot universal standard box',
    cx4: '20 foot 35 ton general purpose box',
    cx5: '45 foot 35 ton general purpose box',
    hwbz: 'Cargo packaging',
    maxzl: 'Maximum piece weight (kg)',
    bz: 'remarks',
    qsrbz: 'Please enter comments',
    yszyyd: 'Transportation resource reservation',
    yszycz: 'Transportation resource search',
    lcId: 'Train ID',
    sfzsfsj: 'Departure station / time',
    zdzzdsj: 'Terminal station / time',
    ls: 'Duration',
    hours: 'hours',
    min: 'minute',
    move: 'move',
    ysxx: 'Transportation information',
    syds: 'Remaining tonnage:',
    sycs: 'Number of vehicles remaining:',
    tbfs: 'Reporting method',
    anc: 'Press car',
    anD: 'By ton',
    zclc: 'Group train',
    xqcs: 'Number of vehicles required',
    qsrxqcs: 'Please enter the number of vehicles required',
    ds: 'Tonnage',
    qsrds: 'Please enter tonnage',
    cz: 'Vehicle type',
    qsrcz: 'Please select vehicle type',
    peng: 'shed',
    chang: 'open',
    ping: 'flat',
    guan: 'pot',
    jzx: 'Container',
    liangshi: 'foodstuff',
    cs: 'The number of cars',
    sqrcs: 'Please enter the number of cars',
    zzjg: 'Loading reinforcement',
    bx: 'Insurance',
    cc: 'storage',
    bxje: 'insurance amount',
    sqrbxje: 'Please enter the insurance amount',
    zyrq: 'Date of delivery',
    cx: 'The model',
    dzzfyhzf: 'Who will pay the bill',
    yfk: 'advance charge',
    mtype: 'currency',
    jp: 'Kip',
    rmb: 'RMB',
    my: 'dollar',
    jzsxxz: 'Notes to records',
    jzsx: 'Record items',
    qsrjzsx: 'Please enter the record items',
    duo: 'many',
    dsly: 'Multimodal transport',
    qxzlylb: 'Please select a combined transport category',
    tsly: 'Hot metal combined transport',
    ggndxqxzgyly: 'Choose multimodal transport according to your needs',
    ssjd: 'Affiliated base',
    qxzssjd: 'Please select the base',
    fglb: 'List of departure ports',
    qxzfglb: 'Please select departure port list',
    dglb: 'Arrival list',
    qxzdglb: 'Please select arrival list',
    cm: 'Ship name',
    cbdw: 'Ship tonnage',
    cblx: 'Ship type',
    fg: 'Departure port',
    dg: 'Arrival',
    hxlx: 'Route type',
    yj: 'Freight rate',
    zyqzrq: 'Start and end date of shipment',
    zzsxx: 'VAT information',
    zen: 'increase',
    fplx: 'Invoice type',
    qxzfplx: 'Please select invoice type',
    ptfp: 'Ordinary invoice',
    zyfp: 'special invoice',
    spfmc: 'Name of drawee',
    qsrspfmc: 'Please enter the name of the drawee',
    khh: 'Bank of deposit',
    qsrkhhmc: 'Please enter the name of the deposit bank',
    nsrsbh: 'Taxpayer identification number',
    qsrnsrsbh: 'Please enter taxpayer identification number',
    khhzh: 'account number',
    qsrkhhzh: 'Please enter account number of deposit bank',
    zcdz: 'Company Registered Address',
    qsrzcdiz: 'Please enter your registered address',
    lxdh: 'contact number',
    qsrlxdh: 'Please enter the contact number',
    jie: 'meet',
    jqsdxx: 'Receiving delivery information',
    mdz: 'Door to station',
    cyjqxx: 'Common access information',
    address: 'address',
    qxzsheng: 'Please select Province',
    qsrsheng: 'Please enter Province',
    qxzshi: 'Please select a city',
    qsrshi: 'Please enter city',
    qxzq: 'Please select area',
    qsrq: 'Please enter the field',
    qsrxxdz: 'Please enter the detailed address',
    lc: 'mileage',
    smzc: 'Door to door loading',
    xqsm: 'Requirement description',
    tyrqdjs: 'Number of pieces determined by the shipper',
    qhfygs: 'Pick up cost estimation',
    zdm: 'Stand to the door',
    cysdxx: 'Common delivery information',
    fyss: 'Freight trial',
    bc: 'preservation',
    qk: 'empty',
    glyjyf: 'kilometers, estimated freight',
    yysjydwz: 'subject to the actual waybill',
    dtbxx: 'Information to be submitted',
    xqh: 'Demand number',
    yyh: 'Reservation number',
    hwmc: 'Item name',
    wptz: 'Article characteristics',
    xqcs_slcs: 'Number of vehicles / accepted',
    xqds_slds: 'Demand tonnage / acceptance tonnage',
    ystz: 'Transportation characteristics',
    hqhw: 'Cargo area and location',
    tbrq: 'Date of submission',
    xqly: 'Source of demand',
    qt: 'other',
    xg: 'modify',
    sc: 'delete',
    ckxq: 'View details',
    tj: 'Submit',
    dc: 'export',
    plsc: 'Batch delete',
    fh: 'return',
    ydd: 'Advance order',
    jdxqh: 'Stage demand No',
    chax: 'Query',
    yslx: 'Transportation type',
    zhi: 'to',
    wccs: 'Number of completed vehicles',
    tbsj: 'Reporting time',
    operation: 'Operation',
    sl: 'Acceptance',
    cyjqdz: 'Common access address',
    sheng: 'province',
    shi: 'city',
    qu: 'area',
    cysddz: 'Common delivery address',
    yddh: 'Mobile phone',
    jbrsfz: 'ID card of handler',
    jbrsjhm: 'Mobile phone number of handler',
    zzl: 'Total weight',
    hlbj: 'Haole Baoji',
    zwsj: 'No data',
    pyyyrdhwxx: 'For goods with an escort, the name of the escort and the name and number of supporting documents shall be indicated',
    hg: 'container',
    wxpl: 'Dangerous goods',
    wxxhwystyrzzzh: 'Shipper\'s Qualification Certificate No., handler\'s ID card No. and Training Certificate No. for transport of dangerous goods',
    wxz: 'Vientiane railway station',
    mdj: 'Modin (environment)',
    tbrxq: 'Daily demand',
    rxqsltg: 'Daily demand acceptance passed',
    rxqyzc: 'Daily demand loaded',
    rxqyfc: 'Daily demand departure',
    rxqzt: 'DemandStatus',
    rqxydd: 'Daily demand has arrived',
    rxqyxc: 'Daily demand unloaded',
    rxqyjf: 'Daily demand delivered',
    rxqyjj: 'Daily demand rejected',
    rxqytd: 'Daily demand unsubscribed',
    yfc: 'Departure',
    ydz: 'Arrived',
    qsrhscs: 'Please enter the number of verification vehicles',
    qsrhsyy: 'Please enter the reason for verification',
    qsrhsds: 'Please enter the verified tonnage',
    qxzjzxx: 'Please select header type',
    ghsjgsbzq: 'Incorrect format of fixed line or mobile phone number',
    qsryhm: 'enter one user name',
    qyzyhm: 'Please verify the user name',
    qxzysrq: 'Please select the transportation date',
    qxzhwpm: 'Please select the product name',
    qxz: 'Please select',
    qsrcs: 'Please enter the number of cars',
    xqcsbw0: 'The number of required vehicles cannot be 0',
    xqdsbmcg9999: 'The required tonnage cannot exceed 9999',
    qsrbjje: 'Please enter the insured amount',
    qxzfz: 'Please select the departure station',
    qsrzcdd: 'Please enter the loading location',
    qsrzcddszjy: 'Please enter 2-400 loading locations',
    qsrzqsfzhm: 'Please enter a 15 or 18 digit ID number',
    qsrdhhm: 'Please enter the phone number',
    qxzdz: 'Please select the destination',
    qsrxcdd: 'Please enter the unloading location',
    qsrxcddszjy: 'Please enter 2-400 unloading locations',
    qsrtyrqdjs: 'Please enter the number of pieces determined by the shipper',
    qsrqhfygs: 'Please enter the pickup cost estimate',
    qsrsjhm: 'Please enter your mobile phone number',
    qsrlc: 'Please enter mileage',
    qsrxqsm: 'Please enter the requirement description',
    qsrmc: 'Please enter your name',
    qsrkhh: 'Please enter the Bank of deposit',
    qsrzh: 'Please enter the account number',
    qsrdz: 'Please enter the address',
    lj: 'Luji',
    d6700: '6700 tons',
    buxian: 'unlimited',
    cj_nh: 'Yangtze River inland river',
    jztlslymtcpjd: 'Jingzhou iron water intermodal coal storage and distribution base',
    bjhhyxgs: 'Beijing navigation Co., Ltd',
    tjg_shg: 'Tianjin Port - Shanghai Port',
    day1: '1 day',
    gzhhyxgs: 'Guangzhou navigation Co., Ltd',
    acad: 'By vehicle by ton',
    qxzrxq: 'Please select daily demand',
    qxzsrzy: 'Please select transportation resources',
    qdsfsc: 'This operation will permanently delete the data. Do you want to continue?',
    ts: 'Tips',
    qd: 'determine',
    qx: 'cancel',
    sccg: 'Deleted successfully',
    yqxsc: 'Deletion cancelled',
    qxztjxqsq: 'Please select the demand to be submitted to delete',
    tqcg: 'Submitted successfully',
    qxztjqqjxtj: 'Please select the requirements to be submitted to submit',
    qdjzxmktb: 'Please report to the container module',
    czcg: 'Operation successful',
    czsb: 'Operation failed',
    wxts: 'reminder',
    sctpjy1: 'The size of the uploaded picture cannot exceed 2MB',
    sctpjy2: 'The file already exists',
    sctpjy3: 'The total number of uploaded files cannot exceed 20m',
    sctpjy4: 'Currently, 3 files are limited to be selected, and this time',
    sctpjy5: ' files selected ',
    sctpjy6: 'files',
    qnqdtbxxtj: 'Please submit the information to be submitted！',
    drcg: 'Import succeeded',
    rxq: 'Daily demand',
    dtblbzdyz: 'The list to be submitted can save up to 20 pieces of data. Please process the existing data before submitting',
    xgcg: 'Modified successfully',
    xjcg: 'New successfully',
    xqlx_gjly_ptys: 'Demand type 0 - international intermodal transport 1 - general transport',
    qsrtbrxx: 'Please enter the informant information。',
    qyzyhxx: 'Please verify user information',
    fzxxyz1: 'The default departure station is not this station, please fill in the departure station information again',
    fzxxyz2: 'The default departure station is not under the jurisdiction of the Bureau. Please fill in the departure station information again',
    dbxqyz1: 'Prompt: only the sending station can be the demand of this station',
    dbxqyz2: 'Prompt: you can only report the needs of the bureau to which the sending station belongs',
    dbxqyz3: 'The entered tonnage cannot be greater than the remaining tonnage required in this stage',
    dbxqyz4: 'The number of vehicles input cannot be greater than the remaining number of vehicles demanded at this phase',
    qxzfzzd: 'Please select the origin site',
    zyydyz1: 'The scheduled origin and destination sites of resources cannot be the same',
    qxzdzzd: 'Please select arrival station',
    zyydyz2: 'Transport resource not found',
    qxzscnr: 'Please select the content to delete',
    yhxxyz1: 'The user information is incorrect. Please check it before reporting',
    yhxxyz2: 'Please import the contract after checking the user information',
    yhxxyz3: 'Please check the user information and import the historical demand',
    hscs: 'Verify the number of cars',
    hsyy: 'Verify Reasons',
    yfss: 'Freight trial',
    ty: 'Agree',
    jj: 'Rejected',

    ybtrxq: 'Submitted daily demand',
    fhr: 'Shipper',
    kydcs: 'Number of vehicles available for booking',
  },
  dailyTransportDemandDetailRes: {
    crumbs0: 'transportation services',
    crumbs1: 'Daily demand',
    crumbs2: 'Daily demand creation result'
  },
  multimodalTransport: {
    yxfhrq: 'Selected: Delivery date ',
    crumbs0: 'transportation services',
    crumbs1: 'Daily demand',
    crumbs2: 'Multimodal transport reservation',
    crumbs3: 'My demand list',
    qxz: 'Please select',
    fhrq: 'the date of issuance',
    fz: 'Departure station',
    dz: 'arrive at a station',
    hwpm: 'Name of goods',
    zzl: 'Total weight',
    tyf: 'Shipper',
    shf: 'Consignee',
    yyh: 'Reservation number',
    xqh: 'Demand number',
    lylb: 'Intermodal transport category:',
    thly: 'Hot metal combined transport',
    ssjd: 'Affiliated base:',
    fg: 'Departure port:',
    dg: 'Arrival:',
    cx: 'Query',
    yd: 'Determined',
    lx: 'type',
    cc: 'Train number',
    yjfhsj: 'Estimated departure time',
    yjddsj: 'Estimated time of arrival',
    ls: 'Duration',
    sfz_sfsj: 'Departure station / time',
    zdz_zdsj: 'Terminal station / time',
    cz: 'Vehicle type',
    bc: 'preservation',
    zx: 'Station sequence',
    zm: 'Station name',
    dzsj: 'Arrival Time',
    czsj: 'Outbound time',
    tlsj: 'residence time',
    dtjlylb: 'List of intermodal transport to be submitted',
    tj: 'Submit',
    xg: 'modify',
    sc: 'delete',
    fh: 'return',
  },
  arriveChangeInput: {
    crumbs0: 'transportation services',
    crumbs1: 'Daily transportation demand',
    crumbs2: 'Details',
    xqdh: 'Demand doc No',
    cc: 'Train number',
    huo: 'goods',
    hwxx: 'Cargo information',
    hwpm: 'Name of goods',
    hwtz: 'Cargo characteristics',
    frl: 'Calorific value',
    bz: 'remarks',
    yun: 'transport',
    ysxx: 'Transportation information',
    ds: 'Tonnage',
    fw: 'service',
    zzjgcl: 'Loading reinforcement materials',
    bjys: 'Insured transportation',
    cangchu: 'storage',
    wu: 'nothing',
    jzsx: 'Record items',
    cx: 'Model',
    cs: 'Number of cars',
    fa: 'send',
    fhxx: 'Shipping Information',
    tyf: 'Shipper',
    fz: 'Departure station',
    zcdd: 'Loading place',
    lxdh: 'contact number',
    txdz: 'mailing address',
    jbr: 'operator',
    jbrdh: 'Operator telephone number',
    jbrsfz: 'ID card of handler',
    sfz: 'ID',
    sj: 'mobile phone',
    bian: 'change',
    bgxx: 'Change information',
    cyshr: 'Common consignee',
    shf: 'Consignee',
    ysfw: 'transportation services',
    dz: 'arrive at a station',
    qsrdz: 'Please enter the destination',
    xcdd: 'Unloading location',
    tj: 'Submit',
    fh: 'return',
    cyshxx: 'Common receipt information'
  },
  dailygoodsOrder: {
    crumbs0: 'Cargo waybill',
    lztlyxgs: 'Laozhong Railway Co., Ltd',
    hwydlc: 'Freight bill (train)',
    xqh: 'Demand number',
    zyrq: 'Date of shipment',
    tuo: 'Trust',
    yun: 'transport',
    fan: 'square',
    fz: 'Departure station',
    zcd: 'Loading point',
    name: 'name',
    address: 'address',
    hwyd: 'Cargo waybill',
    dh: 'Telephone',
    jbrxm: 'attention line',
    sfz: 'ID',
    sj: 'mobile phone',
    shou: 'collect',
    huo: 'goods',
    dz: 'arrive at a station',
    xcd: 'Unloading point',
    hwpm: 'Name of goods',
    hwtz: 'Cargo characteristics',
    frl: 'Calorific value',
    ps: 'Fear of dampness',
    bps: 'Not afraid of wet',
    sdz: 'Bulk loading',
    fsdz: 'Non bulk stacking',
    beiz: 'remarks',
    ysfw: 'transportation services',
    zzdjcl: 'Loading reinforcement materials',
    bjys: 'Insured transportation',
    cangchu: 'storage',
    tyfjzsx: 'Shipper records',
    zzsfplx: 'VAT invoice type',
    ptfp: 'Ordinary invoice',
    zyfp: 'special invoice',
    spfmc: 'Name of drawee',
    nsrsbh: 'Taxpayer identification number',
    khhjzh: 'Account bank and account number',
    fyhej: 'Total expenses (yuan)',
    chec: 'Train number',
    cs: 'Number of cars',
    ds: 'Tonnage',
    ydmx: 'Waybill details',
    ydh: 'Waybill No',
    cx: 'Model',
    ch: 'license number',
    bz: 'Standard weight',
    zz: 'load',
    lc: 'mileage',
    zfy: 'Total cost (yuan)',
    fymx: 'Expense details',
    fh: 'return'
  },
  workbench: {
    crumbs0: 'transportation services',
    crumbs1: 'My workbench',
    dbsx: 'To do list',
    xq: 'demand',
    rxq: 'Daily demand',
    jdxq: 'Stage demand',
    sm: 'Commerce and trade',
    gdyd: 'Pending order',
    dxjy: 'Directional transaction',
    jmjm: 'Bidding',
    hetong: 'contract',
    smht: 'Commercial contract',
    xx: 'news',
    zyxx: 'Important news',
    jhxx: 'Interactive message',
    wdlyb: 'My message board',
    zxhf: 'Latest reply',
    yfbht: 'Published topics',
    tjfx: 'statistical analysis',
    ntj: 'annual statistics',
    ytj: 'Monthly statistics',
    dyzj: 'Total of current month',
    xqcs: 'Number of vehicles required',
    yscs: 'Number of transport vehicles',
    xqdxl: 'Demand fulfillment rate',
    nzj: 'Annual total',
    wfqd_cjl: 'I initiated it-Turnover',
    wcyd_cjl: 'I was involved-Turnover',
    yzj: 'Monthly total',
    cjl: 'Trading volume (ton)',
    cje: 'Turnover (yuan)',
    wfqd: 'I initiated it',
    wcyd: 'I was involved',
    qdgs: 'Number of signatures',
    zds: 'Gross tonnage (ton)',
    zhte: 'Total contract amount (yuan)',
    ysht: 'Contract of carriage',
    zzl: 'Total weight (ton)',
    tiao: 'strip',
    dtb: 'To be reported',
    dzf: 'To be paid',
    sm_gdyd: 'Commerce and trade-Pending order',
    dfb: 'To be released',
    dsl: 'Pending',
    sm_dxjy: 'Commerce and trade-Directional transaction',
    dqr: 'To be confirmed',
    sm_jmjm: 'Commerce and trade-Bidding',
    ht_smht: 'contract-Commercial contract',
    dqrsh: 'Receipt to be confirmed',
    lyb_zxhf: 'Message Board-Latest reply'
  },
  transportDetil: {
    crumbs0: 'transportation services',
    crumbs1: 'Haoji railway is a national "medium and long term railway network planning" project, a national railway investment and financing system reform demonstration project, and a new channel of the national "north coal to South" strategy. The railway passes through seven provinces and regions of Mongolia, Shaanxi, Shanxi, Henan, Hubei, Hunan and Jiangxi. The main line of the whole line is 1814 kilometers long. With a planned transportation capacity of more than 200 million tons / year and a planned investment estimate of 170 billion yuan, it is a large-scale coal transportation special line in China and a new national strategic transportation channel of "north coal transportation to the South". It is a collection and distribution line connecting many railway transportation lines such as Beijing Shanghai, Beijing Kowloon, Beijing Guangzhou and Jiaozhi, as well as coastal, Yangtze River and Beijing Hangzhou Canal waterway transportation lines. It is also the longest heavy haul railway in the world built at one time.',
    ysfaxz: 'Transportation scheme selection',
    jdxqtb: 'Stage demand submission',
    rxqtb: 'Daily demand submission',
    hwzz: 'Cargo tracking',
    xqtb: 'Demand submission',
    xqtb_text: 'It can be divided into stage transportation demand submission and daily transportation demand submission. Transportation demand submission is that customers submit transportation plans according to their own transportation needs, that is, daily transportation needs. After the demand is submitted, the customer can query the current status of each demand.',
    jdxqtb_text: 'Stage demand reporting is to report the coal transportation demand of the next month. The stage demand can be directly transformed into daily demand for transportation.',
    rxqtb_text: 'Daily demand submission is to submit the coal transportation demand on the specified date. The daily demand submitted before 12:00 on the same day can be delivered between 18:00 on the same day and 18:00 on the next day. In this process, transportation resources can be reserved and multimodal transport can be selected.',
    yszyyd: 'Transportation resource reservation',
    yszyyd_text: 'Transportation resource reservation is an efficient, safe and environment-friendly transportation mode adopted by Haoji railway freight. Through the principles of fixed time, fixed point, fixed line, fixed price and fixed train number, unified service standard, unified coordination platform, strengthened mechanism and equipment support, strive to improve the operation quality of Haoji railway transportation resources and ensure the punctual operation according to the map. Finally, it will open up the logistics bottleneck for customers, reduce logistics costs and obtain ideal benefits. Compared with traditional railway transportation, Haoji railway transportation resources have the following advantages: (1) service guarantee - Remote realization of unique priority rights: enjoy the advantages of priority allocation, priority loading, priority trailer, priority release and priority unloading; (2) Operation guarantee --- realize networked tracking and query remotely: enjoy the advantages of no stopping loading during loading, no limiting loading before full load, no refusal at railway boundary, no stopover during operation and no disassembly during operation; (3) Fast operation speed - the transportation resources of Haoji railway run on time according to the plan, which is efficient and convenient, and saves costs for customers as much as possible',
    ds: 'timing',
    sjgd: 'Fixed time',
    dd: 'fixed point',
    zchxczdgd: 'Fixing of loading and unloading stations',
    dx: 'Alignment',
    qcysxlgd: 'The whole transportation route is fixed',
    dj: 'price',
    ysjggd: 'Fixed transportation price',
    dcc: 'Fixed train number',
    ccgd: 'Fixed train number',
    gslyxz: 'Multimodal transport options',
    gslyxz_text: 'Multimodal transport means that based on the full improvement of railway transport services, Haoji railway clearly grasps the supply and demand of upstream and downstream enterprises and water transport and other information, and provides iron water transport scheme and selects transportation mode in combination with the actual data of coal transport. According to the ship source information released by the shipping enterprise on the multimodal transport platform and combined with their own needs, customers can select the ship source and route for daily demand submission. After submitting the report, the customer can query the logistics information of hot metal intermodal transportation in the cargo tracking.',
    hwzz_text: 'After the transportation demand is submitted, the production platform of Haoji railway will dispatch, allocate vehicles and ship. During the transportation of goods, customers can query the information of goods in transit, including the location of goods, the report information of each station and the estimated arrival time. The customer can make a plan in advance according to the transportation situation in order to receive the goods.'
  },
  workbenchInfo: {
    crumbs0: 'transportation services',
    crumbs1: 'My workbench',
    crumbs2: 'news',
    xxlz: 'Message type:',
    zyxl: 'Important news',
    jhxx: 'Interactive message',
    xlly: 'Source:',
    zt: 'State:',
    wd: 'Unread',
    yd: 'Read',
    xqdh: 'Demand doc No:',
    qsrxqdh: 'Please enter the demand doc No',
    shjyh: 'Business transaction No:',
    qsrsmjyh: 'Please enter the trade transaction number',
    tsksrq: 'Push start date:',
    xzrq: 'Select date',
    tsjsrq: 'Push end date:',
    cx: 'Query',
    qk: 'empty',
    qd: 'determine',
    bjyd: 'Mark read',
    sc: 'delete',
    fh: 'return'
  },
  LoadUnloadVehicleInfo: {
    crumbs0: 'transportation services',
    crumbs1: 'Loading and unloading information',
    zcxx: 'Loading information',
    xqdh: 'Demand doc No',
    qsr: 'Please enter',
    fz: 'Departure station',
    dz: 'Drrive at a station',
    zcrq: 'Loading date',
    zhi: 'to',
    ksrq: 'Start date',
    jsrq: 'End date',
    zcrqzndekzrq: 'Loading date refers to your loading date',
    zcz: 'Loading',
    ywc: 'Completed',
    cx: 'Query',
    dc: 'export',
    qxz: 'Please select',
    xcxx: 'Unloading information',
    xcrq: 'Unloading date',
    xcrqzndekxrq: 'Unloading date refers to your unloading date',
    xcz: 'Unloading',
    zt: 'State',
    kzsj: 'Opening time',
    zwsj: 'Loading completion time',
    hs: 'time consuming',
    hwpm: 'Name of goods',
    fz_dz: 'Departure arrival',
    tyf: 'Shipper',
    sgf: 'Consignee',
    jbr_jbrdh: 'Operator / operator telephone',
    zckb: 'Loading Kanban',
    gj: 'total',
    che: 'cars',
    yz: 'Installed:',
    ch: 'license number',
    jssj: 'End time',
    kxsj: 'Unloading time',
    xwsj: 'Unloading time',
    xckb: 'Unloading Kanban',
    yx: 'Unloaded'
  },
  cargoTracking: {
    crumbs0: 'transportation services',
    crumbs1: 'Cargo tracking',
    xqdh: 'Demand doc No',
    qsrxqdh: 'Please enter the demand doc No',
    cx: 'Query',
    fhyhlb: 'Return to shipment list',
    shi: 'beginning',
    zong: 'end',
    xh: 'Serial number',
    cz: 'station',
    dzsj: 'Arrival Time',
    czsj: 'Outbound time'
  },
  leagueOfNationsWaybill: {
    nwdsl: "Intranet to be accepted",
    qscjjddh: 'Please generate handover list number',
    sfzfctyd: 'Whether to cancel this waybill?',
    tjqfsfcg: ' is successfully submitted to unseal',
    tjqfsfsb: ' failed to submit to unseal',
    qsrnrhqd: 'Please input content and confirm',
    yxs: 'Displayed',
    qzsj: 'Start and end time',
    scjjddh: 'Generate handover order number',
    jzx1: 'Container 1',
    jzx2: 'Container 2',
    crumbs0: 'transportation services',
    crumbs1: 'Guolian transportation',
    crumbs2: 'Guolian transportation query',
    ph: 'Batch No.',
    yyh: 'Appointment No',
    gjydh: 'National through bill No',
    fz: 'Departure station',
    qsrfz: 'Please enter the departure station',
    fhr: 'Shipper',
    qsrfhf: 'Please enter shipper',
    tbrq: 'Date of submission',
    ksrq: 'Start date',
    jsrq: 'End date',
    zdz: 'Into standing',
    dz: 'Drrive at a station',
    qsrzdz: 'Please enter the destination',
    shr: 'consignee',
    qsrshf: 'Please enter ship to',
    ch: 'Vehicle number',
    xh: 'Serial number',
    ydzt: 'Waybill status',
    bllb: 'Handling category',
    qxz: 'Please select',
    cx: 'Query',
    qk: 'empty',
    xqxj: 'New requirement',
    qx: 'Select all',
    zt: 'State',
    // dsl: 'Pending',
    // ysl: 'Accepted',
    // yzc: 'Loaded',
    // yfc: 'Departure',
    // ydd: 'Arrived',
    // yxc: 'Unloaded',
    // yjf: 'Delivered',
    // lkzf: 'Fail (void)',
    // zccx: 'Loading cancellation',
    jgcx: 'Delivery cancellation',
    glydh: 'National through bill No',
    zc: 'Complete vehicle',
    jzx: 'container',
    fhrmc: 'Shipper name',
    fzzm: 'Name of departure station',
    shrmc: 'Consignee name',
    gjz: 'Border station',
    tbsj: 'Reporting time',
    fhrtxdz: 'Shipper  mailing address',
    shrtxdz: 'Mailing address of consignee',
    bcqd: 'Supplementary list (items)',
    xz: 'New',
    ck: 'check',
    swjl: 'Business records',
    clqd: 'Vehicle list',
    ckxq: 'View details',
    hwjjd: 'list of freight delivered and received',
    jzxqd: 'Container list',
    sfbg: 'Change or not',
    cz: 'Operation',
    bgdz: 'Change arrival',
    xzjcsdqfjl: 'Unsealing records during administrative inspection',
    ydzb: 'Original waybill',
    gshr: 'To consignee',
    gxshrjfhwdcyr: 'To the carrier delivering the goods to the consignee',
    qb: 'Whole',
    d1l: 'First copy',
    d2l: 'Second copy',
    d3l: 'Third copy',
    d4l: 'Fourth copy',
    d5l: 'Fifth page',
    d6l: 'Sixth sheet',
    dy: 'Print',
    bc: 'preserve',
    zf: 'Void',
    fh: 'return',
    tj: 'Submit',
    sc: 'delete',
    qxiao: 'cancel',
    qr: 'confirm',
    qd: 'confirm',
    hwysbgyqs: 'Cargo transportation change request',
    bgyqr: 'Change requestor',
    yz: 'seal',
    jbrsfzxx: 'Identity information of handler',
    ddmlh: 'Dispatching command No',
    khtj: 'Customer filling',
    bgsx: 'Changes',
    xdz: 'New arrival',
    xshr: 'New consignee',
    yhwydjzsx: 'Items recorded in the original cargo waybill',
    ydhm: 'Waybill No',
    tyr: 'Shipper',
    blzb: 'Handling type',
    czch: 'Vehicle type and number',
    hwmc: 'Item name',
    js: 'Number of pieces',
    zl: 'weight',
    cyrq: 'Date of shipment',
    bgyy: 'Reason for change',
    cyrtj: 'Filled by the carrier',
    jzsx: 'Recorded items',
    ydz: 'Original arrival station',
    yshr: 'Original consignee',
    wslyy: 'Reason for unacceptability',
    bgclz: 'Change processing station',
    jbr: 'Handled by',
    bgxxtx: 'Filling in of change information',
    xuh: 'Serial number',
    wpmc: 'Item name',
    bz: 'packing',
    tiji: 'volume',
    jg: 'price',
    beizhu: 'Remarks',
    congzhi: 'Reset',
    cyrjz: 'Carrier record',
    qsr: 'Please enter',
    dsl: 'To be accepted',
    ysl: 'Accepted',
    yzc: 'Loaded',
    yfc: 'Departed',
    ydd: 'Arrived',
    yxc: 'Unloaded ',
    yjf: 'Delivered',
    lkzf: 'Failed (canceled)',
    zccx: 'Cancellation of loading',
    jfcx: 'Cancellation of delivery',
    qxzcx: 'Please select the model',
    cyr: 'carrier',
    wwdtj: 'To be submitted',
    wwdsl: "To be accepted",
    luok: 'Failed',
    shjj: 'Review rejected',
    qxzdtjzt: 'Select the international through transport waybill in the status of "to be submitted" for submission',
    yxqh: 'Monthly demand number',
    cxcg: 'Query succeeded',
    xhbky: 'Container No. is not available',
    jzxbtx: 'Please enter all the information needed and click OK. All the entries except "Record of Carrier" are required to be filled out',
    zstxyt: 'Enter at least one piece of container information',
    jzxxhcx: 'The container number entered is not in this batch of container number information. Do you want to empty the list and enter the information again?',
    bltjyz: 'The international through transport waybill already submitted cannot be submitted again.',
    sfhycz: 'The seal number cannot be repeated',
  },
  LNWayBillAdd: {
    yqctts: 'The daily demand corresponding to the current international intermodal waybill has exceeded the submission time range. Please modify the waybill, select a new transportation date and submit again.',
    fkjs: "Payment notes",
    dyil: "First copy",
    derl: "Second copy",
    dsanl: "Third copy",
    dsil: "Fourth copy",
    dwul: "Fifth copy",
    dliul: "Sixth copy",
    qztitle: 'After submission, it will automatically sign for you. Please confirm',
    qxtxdygjzx: 'Please fill in the first container first',
    ccaozjyjscsj: 'This operation will permanently delete data',
    zdxqytsj: 'Select at most one piece of data',
    qsrhwmz: 'Please input the gross weight of the goods',
    qsrjzxxh: 'Please input container number',
    bcz: 'Saving...',
    qsrmbmc: 'Please input template name',
    qzssrygziz: 'Please input at least one dead weight',
    qzssrygzaizl: 'Please input at least one load capacity',
    qtxygjzxxh: 'Please fill in a container number',
    qlryghwxx: 'Please input goods information',
    qzssrygchelxxhm: 'Please input at least one vehicle information number',
    qsrdzmc: 'Please input the name of arrival station ',
    qxzddl: 'Please select railway of arrival',
    qsrfzmc: 'Please input name of departure station',
    sfscbtshuj: 'Delete the data or not?',
    crumbs0: 'transportation services',
    crumbs1: 'Guolian transportation',
    crumbs2: 'Guolian transportation NEW',
    fh: 'return',
    yyh: 'Appointment No',
    wdrxq: 'My daily needs',
    bllb: 'Handling type',
    jzx: 'container',
    zc: 'Complete vehicle',
    bgdz: 'Change arrival',
    ydzb: 'Original waybill',
    gshr: 'To consignee',
    wdmb: 'My templates',
    ts1: 'Tip: please save the contents before leaving the page for a long time to prevent information loss.',
    bcwmb: 'Save as template',
    mbmc: 'Template name',
    bzjs: 'Standard notes',
    qxz: 'Please select',
    qsr: 'Please enter',
    dtbxx: 'Information to be submitted',
    quanx: 'Select all',
    zt: 'State',
    qr: 'confirm',
    qd: 'confirm',
    dsl: 'Pending',
    ysl: 'Accepted',
    yzc: 'Loaded',
    yfc: 'Departure',
    ydd: 'Arrived',
    yxc: 'Unloaded',
    yjf: 'Delivered',
    lkzf: 'Fail (void)',
    zccx: 'Loading cancellation',
    jgcx: 'Delivery cancellation',
    glydh: 'National through bill No',
    xh: 'Serial number',
    hwzl: 'Item Weight',
    sfjh: 'Sealing mark',
    fhrmc: 'Shipper name',
    fzzm: 'Name of departure station',
    xcdd: 'Unloading location',
    shrmc: 'Consignee name',
    gjz: 'Border station',
    tbsj: 'Reporting time',
    xinzfhrdz: 'Add shipper address',
    cz: 'Operation',
    xg: 'modify',
    tj: 'Submit',
    plsc: 'Batch delete',
    scmb: 'Delete template',
    xzfhrdz: 'Select shipper address',
    xzfhr: 'Select shipper',
    dllb: 'dllb',
    qsrfhrmc: 'Please enter shipper name',
    cx: 'Query',
    szdq: 'Location',
    zg: 'China',
    lw: 'Laos',
    jdmc: 'Street name',
    dh: 'telephone',
    yx: 'mailbox',
    mail: 'mailbox',
    sh: 'apply',
    bj: 'edit',
    sc: 'delete',
    xz: ' New',
    qxzshrdz: 'Select consignee address',
    qsrshrmc: 'Please enter the consignee name',
    xinzshrdz: 'Add shipper address',
    xzyz: 'Select language',
    qxzyz: 'Please select a language',
    gmswxtsbm: 'Citizen tax system ID',
    qsrgmswxtsbm: 'Please enter citizen tax system ID',
    qxzszqy: 'Please select your region',
    xxdz: 'Detailed address',
    qsrgmxxdz: 'Please enter the detailed address of the citizen',
    csqh: 'City Code',
    qsrcsqh: ' Please enter the city area code',
    qsrdh: 'Please enter the phone number',
    chuanz: 'facsimile',
    qsrcz: 'Please enter a fax',
    qsryx: 'Please enter email',
    ts2: 'If the above information is not filled in as required, it may cause backlog during customs clearance.',
    bc: 'preserve',
    qx: 'cancel',
    xzshrdz: 'Add consignee address',
    bgxxtx: 'Filling in of change information',
    ydz: 'Original arrival station',
    yshr: 'Original consignee',
    ddmlh: 'Dispatching command No',
    bgyqr: 'Change requestor',
    xshr: 'New consignee',
    xdz: 'New arrival',
    bgyy: 'Reason for change',
    xzhwxx: 'New cargo information',
    xqdh: 'Demand doc No',
    xh1: 'Case No one',
    xh2: 'Case No two',
    jzxxh: 'Container model',
    jzxzz: 'Container deadweight (kg)',
    bjzz: ' Total marked weight (kg)',
    bxje: 'insurance amount',
    sffbhsl: 'Sealing / tarpaulin No. and quantity',
    sffbhjh: 'Sealing / tarpaulin number mark',
    xnhw: 'Cargo in box',
    zwmc: 'Chinese name',
    qsrhwmc: 'Please enter the name of the goods',
    zghgbm: 'China Customs Code (hscode)',
    wwmc: 'Foreign language name',
    tyhwpmbm: 'General cargo name code',
    tyyjhwtjbm: 'Unified freight statistics code (ET)',
    ptp: 'Common products',
    wxp: 'Dangerous goods',
    wxhwbm: 'Dangerous goods code (ET)',
    bz: 'Remarks',
    bzlx: 'Package type',
    bzmc: 'Package name',
    bzdm: 'Package code',
    js: 'Number of pieces',
    dz: 'Stacking',
    sz: 'bulk',
    gz: 'Canned',
    hwzzl: 'Total weight of goods',
    hwmz: 'Gross weight of goods (including packaging) ps: kg',
    ysyj: 'Conveyance',
    ysyjmc: 'Name of delivery equipment',
    ysyjsl: 'Number of delivery appliances',
    ysyjzl: 'Weight of transport equipment (kg)',
    ysyjsm: 'Description of transportation equipment',
    rxqh: 'Daily demand No',
    ysrq: 'Date of shipment',
    blzb: 'Handling type',
    tyf: ' Shipper',
    shf: 'Ship to',
    fz: 'Departure station',
    daoz: 'Drrive at a station',
    hwpm: 'Name of goods',
    xqcs_slcs: 'Number of vehicles required / accepted',
    xqds_slds: 'Demand tonnage / acceptance tonnage',
    bjfhrdz: 'Edit shipper address',
    xzjck: 'Select import and export',
    qxzjck: ' Please select import and export',
    ck: ' Export',
    jk: ' Import',
    qtxzqdxh: 'Please fill in the correct container number',
    sfsl: 'Sealing quantity',
    zzh: 'Gross weight (kg)',
    xzjzxxx: 'Add container information',
    bjjzxxx: 'Edit container information',

    fhrqz: 'Consignor seal',
    czqz: 'Station seal',
    zjxsz: "Increase the number of containers to",
    cczjscytxsj: 'This operation will delete the filled data. Are you sure to continue?',
    zengjia: 'Add',
    zdkzjzxh: 'The maximum number of containers has been exceeded',
    zjxsxdydqxs: "The number of containers added must be greater than the current number of containers"
  },
  phaseTransportDemand: {
    crumbs0: 'transportation services',
    crumbs1: 'Stage requirements',
    crumbs2: 'Monthly demand',
    jdxqh: 'Stage demand No',
    qsrjdxqh: 'Please enter the stage demand number',
    hwpm: 'Name of goods',
    qsr: 'Please enter',
    ysrq: 'Date of shipment',
    qxzqsrq: 'Please select a start date',
    qxzzzrq: 'Please select an end date',
    fz: 'Departure station',
    tyr: 'Shipper',
    qsrtyf: 'Please enter shipper',
    tbsj: 'Reporting time',
    dz: 'Drrive at a station',
    shr: 'Ship to',
    qsrshf: 'Please enter ship to',
    ydlx: 'Waybill type',
    qb: 'Whole',
    gjly: 'International combined transport',
    ptys: 'General transportation',
    zt: 'State',
    dsl: 'Pending',
    sltg: 'Acceptance passed',
    btg: 'Fail',
    yzf: 'Voided',
    chax: 'Query',
    jdxqxj: 'New stage requirement',
    ts1: 'Tips: submitted stage requirements can be queried according to conditions',
    dcexcel: 'Export Excel',
    pldy: 'Batch printing',
    dyzj: 'Total of current month:',
    tiao: 'strip',
    yslx: 'Transport type',
    blzb: 'Handling type',
    zhenc: 'Complete vehicle',
    jzx: 'Container',
    slh: 'Acceptance No',
    zhi: 'to',
    zcdd: 'Loading place',
    xcdd: 'Unloading location',
    xqcs_wccs: 'Number of vehicles required / completed',
    xqds_slds: 'Demand tonnage / acceptance tonnage',
    chez: 'Vehicle type',
    cz: 'Operation',
    ckxq: 'View details',
    xg: 'modify',

    yxqh: 'Monthly demand number',
    jbr_lxdh: 'Handler/contact telephone number',
    xqxs_wcxs: 'Number of boxes required / Number of box completed',
    xx_xl: 'Container size/type',
    xs: 'Container ownership',
    td: 'Reservation cancellation',
    tdyy: 'Reasons for cancellation',
    jzxyd: 'Container waybill',
    xyb: 'Next',
    rxqtb: 'Daily demand submission',
    pltj: 'Submit in batch',
  },
  phaseTransportDemandResult: {
    crumbs0: 'transportation services',
    crumbs1: 'Stage requirements',
    crumbs2: 'New requirement result'
  },
  phaseTransportDemandDetail: {
    crumbs0: 'transportation services',
    crumbs1: 'Stage requirements',
    crumbs2: 'Details',
    ysrq: 'Date of shipment',
    zhi: 'to',
    hwxx: 'Cargo information',
    hwpm: 'Name of goods',
    hwtz: 'Cargo characteristics',
    frl: 'calorific value(kcal/kg)',
    hwms: 'description of the goods',
    jxxx: 'Header type',
    ysfs: 'type of shipping',
    zhenc: 'Complete vehicle',
    jzx: 'Container',
    beiz: 'remarks',
    ysxx: 'Transportation information',
    dunshu: 'Tonnage',
    chex: 'Model',
    ches: 'Number of cars',
    fuw: 'service',
    zzjgcl: 'Loading reinforcement materials',
    bjys: 'Insured transportation',
    cangchu: 'storage',
    wu: 'nothing',
    jzsx: 'Recorded items',
    fhxx: 'Shipping Information',
    tyr: 'Shipper',
    faz: 'Departure station',
    faju: 'Development Bureau',
    zcdd: 'Loading place',
    lxdh: 'contact number',
    txdz: 'mailing address',
    shxx: 'Receiving information',
    ddgj: 'Country of arrival',
    jwz: 'Overseas station',
    daoz: 'Drrive at a station',
    shr: 'Consignee',
    xcdd: 'Unloading location',
    zzsxx: 'VAT information',
    fplx: 'Invoice type',
    spfmc: 'Name of drawee',
    nsrsbh: 'Taxpayer identification number',
    zhangh: 'account number',
    khh: 'Bank of deposit',
    dianh: 'Telephone',
    dizhi: 'address',
    fh: 'return',

    yxqh: 'Monthly demand No.',
    jbr_lxdh: 'Handler/contact telephone number',
    xqxs_wcxs: 'Number of boxes required / Number of box completed',
    xx_xl: 'Container size/type',
    xs: 'Container ownership',
    td: 'Reservation cancellation',
    tdyy: 'Reasons for cancellation',
    jzxyd: 'Container waybill',
    xyb: 'Next',
    rxqtb: 'Daily demand submission',
    pltj: 'Batch submission',
    bytb: 'Submitted in the current month',
    byysxq: 'Transport demand of the current month',
  },
  phaseTransportDemandNew: {
    jdxqtb: 'The tonnage range submitted by phase demand is 100,000 tons to 500,000 tons',
    xqdsbnw0: 'The number of cars demanded cannot be 0',
    crumbs0: 'transportation services',
    crumbs1: 'Stage requirements',
    crumbs2: 'New requirement',
    jie: 'rank',
    jdxqlx: 'Stage demand type',
    xqlx: 'Demand type',
    qxzxqlx: 'Please select demand type',
    gjly: 'International combined transport',
    ptys: 'General transportation',
    ysyf: 'Transportation Month',
    qxzyf: 'Please select a month',
    tjrq: 'Submission date',
    ysrq: 'Date of shipment',
    ksrq: 'Start date',
    jsrq: 'End date',
    tis: 'Prompt: please submit the international freight bill before the 20th of this month',
    huo: 'goods',
    hwxx: 'Cargo information',
    hwpm: 'Name of goods',
    qxzhwpm: 'Please select the product name',
    hwpmtis: 'there is no such goods name',
    blzb: 'Handling type',
    zhenc: 'Complete vehicle',
    jzx: 'Container',
    pashi: 'Fear of dampness',
    bupashi: 'Not afraid of dampness',
    sdz: 'Bulk loading',
    fsdz: 'Non bulk stacking',
    hwbz: 'Packing of goods',
    qsr: 'Please enter',
    qxz: 'Please select',
    zdjzl: 'Maximum piece weight(kg)',
    jxxx: 'Header type',
    qxzcx: 'Please select vehicle type',
    jxxx1: '20 foot universal standard box',
    jxxx2: '20 foot dry bulk container',
    jxxx3: '20 foot liquid tank',
    jxxx4: '20 foot cement tank',
    jxxx5: '20 foot petroleum asphalt tank',
    jxxx6: '20 foot 35 ton universal box',
    jxxx7: '20 foot 35 ton open top box',
    jxxx8: '20 foot 35 ton dry bulk container',
    jxxx9: '20 foot 35 ton liquid tank',
    jxxx10: '20ft 35t insulation box',
    jxxx11: '20 foot 35 ton lithium battery refrigerator',
    jxxx12: '20 foot 35 ton gantry coil box',
    jxxx13: '20 foot other standard box',
    jxxx14: '20ft other non-standard boxes',
    jxxx15: '40 foot universal standard box',
    jxxx16: '40 foot diesel electric refrigerator',
    jxxx17: '40 foot powered refrigerator',
    jxxx18: '40 foot generator box',
    jxxx19: '40 foot 35 ton universal box',
    jxxx20: '40 foot 35 ton insulation box',
    jxxx21: '40 foot 35 ton lithium battery refrigerator',
    jxxx22: '40 foot other standard box',
    jxxx23: '40 foot other non-standard boxes',
    jxxx24: '45 foot universal standard box',
    jxxx25: '45 foot diesel electric refrigerator',
    jxxx26: '45 foot 35 ton universal box',
    jxxx27: '45 foot 35 ton lithium battery refrigerator',
    jxxx28: '45 foot other standard box',
    jxxx29: '45 foot other non-standard boxes',
    yun: 'transport',
    ysxx: 'Transportation information',
    dunshu: 'Tonnage',
    qsrdunshu: 'Please enter tonnage',
    chez: 'Vehicle type',
    ches: 'Number of cars',
    chests: 'Please enter tonnage and select vehicle type',
    chuk: 'Export',
    zzjgcl: 'Loading reinforcement materials',
    gnbx: 'Domestic insurance',
    cangchu: 'storage',
    bjys: 'Insured transportation',
    jzsx: 'Recorded items',
    qsrjzsx: 'Please enter the record',
    tbfs: 'Reporting method',
    anche: 'Press car',
    andun: 'By ton',
    fa: 'send',
    fhxx: 'Shipping Information',
    cyfhxx: 'Common shipment information',
    tyr: 'Shipper',
    faz: 'Departure station',
    jbr: 'Handler',
    qsrfz: 'Please enter the departure station',
    faju: 'Development Bureau',
    zcdd: 'Loading place',
    zyx: 'Private line',
    tlhc: 'Railway freight yard',
    lxdh: 'contact number',
    qsrfhrdh: 'Please enter shipper phone number ',
    txdz: 'mailing address',
    qsrfhrdz: 'Please enter shipper address',
    shou: 'collect',
    shxx: 'Receiving information',
    cyshxx: 'Common receipt information',
    ddgj: 'Country of arrival',
    gjz: 'Border station',
    qxzgjz: 'Please select a border station',
    shr: 'Consignee',
    daoz: 'Drrive at a station',
    qsrdz: 'Please enter the destination',
    xcdd: 'Unloading location',
    qsrtxdz: 'Please enter the mailing address',
    zzsxx: 'VAT information',
    zeng: 'increase',
    fplx: 'Invoice type',
    qxzfplx: 'Please select invoice type',
    ptfp: 'Ordinary invoice',
    zyfp: 'special invoice',
    spfmc: 'Name of drawee',
    qsrspfmc: 'Please enter the name of the drawee',
    khh: 'Bank of deposit',
    qsrkhhmc: 'Please enter the name of the deposit bank',
    nsrsbh: 'Taxpayer identification number',
    qsrnsrsbh: 'Please enter taxpayer identification number',
    zhanhao: 'account number',
    qsrzhhzh: 'Please enter the account number of the deposit bank',
    dizhi: 'address',
    qsrzcdz: 'Please enter the registered address',
    dianhua: 'Telephone',
    qsrlxdh: 'Please enter the contact number',
    bc: 'preservation',
    qk: 'empty',
    dtbxx: 'Information to be submitted',
    yyh: 'Appointment No',
    qzrq: 'Start and end date',
    zhi: 'to',
    hwtz: 'Cargo characteristics',
    tbds: 'Reported tonnage',
    tbcs: 'Number of vehicles submitted',
    bxys: 'Insurance transportation',
    mdj: 'Boten (environment)',
    dz_xcdd: 'Arrival / unloading location',
    lxdh_txdz: 'Tel. / mailing address',
    fz_zcdd: 'Departure station / loading place',
    zzs: 'value added tax',
    cz: 'Operation',
    xg: 'modify',
    sc: 'delete',
    qlsc: 'Batch delete',
    fh: 'return',
    tj: 'Submit',
    daochu: 'export',
    lsxq: 'Historical demand',
    cyfhr: 'Common shippers',
    cyshr: 'Common consignee',
    qxzchez: 'Please select type of vehicle',
    qxzksrq: 'Please select the start date',
    qxzjsrq: 'Please select the end date',

    ybtyxq: 'Monthly demand submitted',
    ljck: 'View now',
    jbrzjh: 'ID document No. of the handler',
    qhdz: 'Pick up address',
    zcdz: 'Loading address',
    xiangs: 'Container number',
    hwjz_mx: 'Value of goods (per case)',
    hwjz_mc: 'Value of goods (per vehicle)',
    qt: 'other',
    bggs: 'Customs broker\n',
    cfl: 'Departure route',
    ddl: 'Arrival route',
  },
  phaseDemandInfoSupple: {
    crumbs0: 'transportation services',
    crumbs1: 'Stage requirements',
    crumbs2: 'Stage requirement modification',
    xqlx: 'Demand type',
    qxzxqlx: 'Please select demand type',
    gjly: 'International combined transport',
    ptys: 'General transportation',
    ysyf: 'Transportation Month',
    qxzyf: 'Please select a month',
    tjrq: 'Submission date',
    ysrq: 'Date of shipment',
    ksrq: 'Start date',
    jsrq: 'End date',
    tis: 'Prompt: please submit the international freight bill before the 15th of this month',
    huo: 'goods',
    hwxx: 'Cargo information',
    hwpm: 'Name of goods',
    qxzhwpm: 'Please select the product name',
    hwts: 'There is no such product name',
    blzb: 'Handling type',
    qxz: 'Please select',
    zhenc: 'Complete vehicle',
    jzx: 'Container',
    pashi: 'Fear of dampness',
    bups: 'Not afraid of dampness',
    sdz: 'Bulk loading',
    fsdz: 'Non bulk stacking',
    hwbz: 'Packing of goods',
    qsr: 'Please enter',
    zdjzl: 'Maximum piece weight(kg)',
    jxxx: 'Header type',
    qxzcx: 'Please select vehicle type',
    jxxx1: '20 foot universal standard box',
    jxxx2: '20 foot dry bulk container',
    jxxx3: '20 foot liquid tank',
    jxxx4: '20 foot cement tank',
    jxxx5: '20 foot petroleum asphalt tank',
    jxxx6: '20 foot 35 ton universal box',
    jxxx7: '20 foot 35 ton open top box',
    jxxx8: '20 foot 35 ton dry bulk container',
    jxxx9: '20 foot 35 ton liquid tank',
    jxxx10: '20ft 35t insulation box',
    jxxx11: '20 foot 35 ton lithium battery refrigerator',
    jxxx12: '20 foot 35 ton gantry coil box',
    jxxx13: '20 foot other standard box',
    jxxx14: '20ft other non-standard boxes',
    jxxx15: '40 foot universal standard box',
    jxxx16: '40 foot diesel electric refrigerator',
    jxxx17: '40 foot powered refrigerator',
    jxxx18: '40 foot generator box',
    jxxx19: '40 foot 35 ton universal box',
    jxxx20: '40 foot 35 ton insulation box',
    jxxx21: '40 foot 35 ton lithium battery refrigerator',
    jxxx22: '40 foot other standard box',
    jxxx23: '40 foot other non-standard boxes',
    jxxx24: '45 foot universal standard box',
    jxxx25: '45 foot diesel electric refrigerator',
    jxxx26: '45 foot 35 ton universal box',
    jxxx27: '45 foot 35 ton lithium battery refrigerator',
    jxxx28: '45 foot other standard box',
    jxxx29: '45 foot other non-standard boxes',
    yun: 'transport',
    ysxx: 'Transportation information',
    dunshu: 'Tonnage',
    qsrds: 'Please enter tonnage',
    chez: 'Vehicle type',
    ches: 'Number of cars',
    chests: 'Please enter tonnage and select vehicle type',
    chuk: 'Export',
    zzjgcl: 'Loading reinforcement materials',
    gnbx: 'Domestic insurance',
    gjys: 'Insured transportation',
    cangchu: 'storage',
    jzsx: 'Recorded items',
    qsrjzsx: 'Please enter the record',
    tbfs: 'Reporting method',
    anche: 'Press car',
    andun: 'By ton',
    fa: 'send',
    fhxx: 'Shipping Information',
    cyfhxx: 'Common shipment information',
    tyf: 'Shipper',
    faz: 'Departure station',
    qsrfz: 'Please enter the departure station',
    faj: 'Development Bureau',
    zcdd: 'Loading place',
    zyx: 'Private line',
    tlhc: 'Railway freight yard',
    lxdh: 'contact number',
    qsrfhrdh: 'Please enter shipper phone number',
    txdz: 'mailing address',
    qsrtxdz: 'Please enter the mailing address',
    shou: 'collect',
    shxx: 'Receiving information',
    cyshxx: 'Common receipt information',
    ddgj: 'Country of arrival',
    gjz: 'Border station',
    qxzgjz: 'Please select a border station',
    shr: 'Consignee',
    daoz: 'Drrive at a station',
    qsrdz: 'Please enter the destination',
    xcdd: 'Unloading location',
    zeng: 'increase',
    zzsxx: 'VAT information',
    fplx: 'Invoice type',
    qxzfplx: 'Please select invoice type',
    ptfp: 'Ordinary invoice',
    zyfp: 'Name of special drawer and receiver',
    spfmc: 'Name of drawee',
    qsrspfmc: 'Please enter the name of the drawee',
    khh: 'Bank of deposit',
    qsrkhhmc: 'Please enter the name of the deposit bank',
    nsrsbh: 'Taxpayer identification number',
    qsrnsrsbh: 'Please enter taxpayer identification number',
    zhanh: 'account number',
    qsrkhhzh: 'Please enter the account number of the deposit bank',
    dizhi: 'address',
    qsrzcdd: 'Please enter the registered address',
    dianh: 'Telephone',
    qsrlxrdh: 'Please enter the contact number',
    fanhui: 'return',
    tijiao: 'Submit',
    cyfhr: 'Common shippers',
    cyshr: 'Common consignee'
  },
  wayBillInfo: {
    jlsxsb: ' Failure record',
    jlsxcg: ' Successful record',
    yyhbyz: 'The appointment numbers are inconsistent!',
    bgxqbyz: 'Inconsistent change demands!',
    bgsb: ' Change failed',
    bgcg: ' Changed',
    crumbs0: 'transportation services',
    crumbs1: 'Waybill management',
    hph: 'Cargo ticket No',
    qsr: 'Please enter',
    xqh: 'Demand No',
    hwmc: 'Item name',
    zcrq: 'Loading date',
    ksrq: 'Start date',
    jsrq: 'End date',
    tyf: 'Shipper',
    tyr: 'Shipper',
    qsrshf: 'Please enter ship to',
    faz: 'Departure station',
    tbrq: 'Date of submission',
    shf: 'Ship to',
    shr: 'consignee',
    daoz: 'Drrive at a station',
    ztai: 'State',
    dsl: 'Pending',
    sltc: 'Acceptance passed',
    yzc: 'Loaded',
    yfc: 'Departure',
    ydd: 'Arrived',
    yxc: 'Unloaded',
    yjf: 'Delivered',
    chax: 'Query',
    qink: 'empty',
    ydzt: 'Waybill status',
    xqdh: 'Demand doc No',
    cheh: 'license number',
    chengz: 'Group',
    fou: 'no',
    hwpm: 'Name of goods',
    hqhw: 'Cargo space',
    yunf: 'freight',
    zaf: 'incidental',
    xcrq: 'Unloading date',
    jfrq: 'Delivery date',
    hwyd: 'Cargo waybill',
    hwzz: 'Cargo tracking',
    gjck: 'Track view',
    sfbg: 'Change or not',
    ybg: 'Changed',
    bgdz: 'Change arrival',
    pldyyd: 'Batch print waybill',
    back: 'return',
    huoq: 'Cargo area',
    huow: 'Location',
    tbsx: 'Item filling',
    hwdcsj: 'Arrival time of goods',
    qued: 'determine',
    chak: 'see',
    ydaoz: 'Original arrival station',
    yshr: 'Original consignee',
    bgxxtx: 'Filling in of change information',
    ddmlh: 'Dispatching command No',
    bgyqr: 'Change requestor',
    xshr: 'New consignee',
    xdaoz: 'New arrival',
    bgyy: 'Reason for change',
    sctp: 'Upload pictures',
    hwysbgqqs: 'Cargo transportation change request',
    zhangy: 'seal',
    jbrsfxx: 'Identity information of handler',
    khtj: 'Customer filling',
    bgsx: 'Changes',
    yhwydjzsx: 'Items recorded in the original cargo waybill',
    ydhm: 'Waybill No',
    blzb: 'Handling type',
    czch: 'Vehicle type and number',
    jianshu: 'number',
    zhongliang: 'weight',
    cyrq: 'Date of shipment',
    cyrtj: 'Filled by the carrier',
    jzsx: 'Recorded items',
    wslyy: 'Reason for unacceptability',
    bgclz: 'Change processing station',
    jbr: 'Handled by',
    chez: 'station',
    dzsj: 'Arrival Time',
    czsj: 'Outbound time',
    xxxl: 'Container type and category',
  },
  myboard: {
    crumbs0: 'transportation services',
    crumbs1: 'My workbench',
    crumbs2: 'My message board',
    htzs: 'Total topics',
    htlx: 'Topic type',
    qxzhtlx: 'Please select topic type',
    mtgj: 'Coal supply',
    mtxq: 'Coal demand',
    wuliu: 'logistics',
    qit: 'other',
    sous: 'search',
    xjht: 'New topic',
    huati: 'topic of conversation',
    qsrht: 'Please enter a topic',
    htnr: 'Topic content',
    qsrhtnr: 'Please enter the topic content',
    fjlb: 'Attachment list',
    scfj: 'Upload attachments',
    jwjcdcc: 'Drag the file here, or',
    djsc: 'Click upload',
    qx: 'cancel',
    fabu: 'release',
    huifu: 'reply',
    gkl: 'Viewing volume',
    tshu: '10 articles / page'
  },
  msgboardetail: {
    crumbs0: 'transportation services',
    crumbs1: 'Message Board',
    crumbs2: 'Message board details',
    huif: 'reply',
    shanchu: 'delete',
    louzhu: 'Landlord',
    xiazai: 'download',
    gkl: 'Viewing volume',
    tshu: '10 articles / page',
    qygw: 'Enterprise official website',
    sqhf: 'Collapse reply',
    oneLou: '1st floor',
    qsrhfnr: 'Please enter the reply',
    fabu: 'release',
    ckgd: 'See more',
    tiao_ye: 'articles / page',
    fbhf: 'Post reply',
    scfj: 'Upload attachments',
    jwjcdcc: 'Drag the file here, or',
    djsc: 'Click upload',
    xght: 'Related topics'
  },
  msgboard: {
    crumbs0: 'transportation services',
    crumbs1: 'Message Board',
    htlx: 'Topic type',
    qxzhtlx: 'Please select topic type',
    mtgj: 'Coal supply',
    mtxq: 'Coal demand',
    wuliu: 'logistics',
    qita: 'other',
    quanbu: 'Whole',
    qsrgjcss: 'Please enter keyword search',
    sousuo: 'search',
    xjht: 'New topic',
    huati: 'topic of conversation',
    qsrht: 'Please enter a topic',
    htnr: 'Topic content',
    qsrhtnr: 'Please enter the topic content',
    fjlb: 'Attachment list',
    scfj: 'Upload attachments',
    jwjcdcc: 'Drag the file here, or',
    djsc: 'Click upload',
    quxiao: 'cancel',
    fabu: 'release',
    zuixin: 'newest',
    remen: 'Hot',
    whf: 'No reply',
    htzs: 'Total topics',
    huif: 'reply',
    gkl: 'Viewing volume',
    tiaoshu: '10 articles / page'
  },
  complaintsSuggestions: {
    tjsb: 'Submission failed',
    tjcgcx: 'Successfully submitted. Please check the historical complaint and suggestion!',
    dqxzsc20: 'The total size of uploaded files is greater than 20M, please check and re-upload',
    dqxzsc5: 'A maximum of 5 files can be uploaded',
    tsjy: 'complaints and suggestions',
    lstsjycx: 'historical complaint suggestion query',
    tsz: 'complaint station',
    zt: 'status:',
    fx: 'Query',
    fh: 'return',
    zxyl: 'online preview',
    xz: 'download',
    qxz: 'please select',
    scsj: 'upload time',
    fjlx: 'attachment type',
    wjmc: 'file name',
    cz: 'Operation',
    fjlb: 'attachment list',
    sljg: 'acceptance result',
    tsrxm: 'name of the complainant',
    yxfs: 'contact information',
    yx: 'mailbox',
    yb: 'postal code',
    tsrsfzh: 'complainant\'s ID number',
    tssj: 'Complaint time',
    fj: 'Annex',
    tsrdz: 'address of the complainant',
    tszt: 'complaint subject',
    tsnr: 'complaint content',
    scfj: 'upload attachment',
    tj: 'submit',
    qk: 'empty',
    jbxx: 'basic information',
    tsxx: 'complaint information'
  },
  cargoService: {
     lhmtx: 'Please keep it properly and use it during pick-up',
    hxsj: 'Container return time',
    ddh: 'Order No.',
    dlr: 'Agent',
    ddyw: 'Arrival service',
    yylx: 'Appointment for pick-up',
    xcsj: 'Unloading time',
    plyy: 'Batch reservation',
    lhsj: 'Pick-up time',
    qxzlhsj: 'Select the pick-up time',
    lhm: 'Pick-up code ',
    sclhm: 'Generate pick-up code ',
    qdjsclhm: 'Click to generate a pick-up code ',
    sclhmm: 'Generate 6-digit pick-up password',
    fhdwdh: 'Telephone number of consignor',
    czjwfm: 'Stations are busy in this period',
    qggyysj: 'The station is too busy. Please change the appointment time',
    qxzytsj: 'Select at least one piece of data for operation',
    yyhx: 'Appointment for return of containers ',
    hxz: 'Container return station',
    jcmdh: 'Entering and leaving ticket No.',
    qxnts: 'Number of days within the term',
    lhrq: 'Pick-up date',
    hxm: 'Container return code',
    schxm: 'Generate container return code',
    qdjschxm: 'Please click to generate a container return code',
    schxmm: 'Generate a 6-digit container return password',
    sysl: 'Quantity used',
    fzzxf: 'Loading and unloading charges of departure station',
    bxf: 'Insurance premium',
    jzxsyf: 'Container usage fee',
    jcfyhj: 'Total basic costs ',
    bzzdys: 'Remarks (maximum tonnage and volume transported)',
    hwlp: 'Goods claims',
    tpjd: 'Claim progress',
    lpxqh: 'Claim demand No.',
    hsxs: 'Number of damaged containers',
    fqlp: 'Initiate claim',
    pllp: 'Batch claim ',
    slcz: 'Acceptance station',
    ssxh: 'Damaged container No.',
    ssxs: 'Number of damaged containers',
    hwssqk: 'Loss of goods',
    yqpcje: 'Amount of compensation claim ',
    slz: 'Acceptance station',
    czslyj: 'Acceptance comments of station',
    czslr: 'Station handler',
    czslsj: 'Station acceptance time',
    lpsqs: 'Claim application form',
    swjldc: 'Export of business records',
    hyjldc: 'Export of freight records',
    wanc: 'Completed',
    lpsq: 'Claim application',
    qxzzsyt: 'Please select at least one record',
    qxzzsyt1: "Please select at least one record to be submitted",
    hwjz: 'Cargo value',
    mxbxje: '(Insurance Amount per Carton of Goods)',
    jdxqxzts: "Please select the monthly demand for the month in which the shipping date is located. If the container is picked up at the end of the current month and the shipping date is at the beginning of the next month, you need to select the monthly demand for the next month. If you choose the wrong one, you will not be able to submit a daily demand",
    qfh: 'To shipment',
    sfszbx: 'Self-owned container or not',
    hwzlkg: 'Weight of cargo (kg)',
    dxzdzz: 'Maximum capacity of a single container (t)',
    sscs: 'Quantity of damaged cars',
    ssch: 'Damaged car No.',
    hwlpxq: 'Cargo claim settlement details',
    hyjllb: 'Freight record list',
    swjllb: 'Business record list',
    yyjl: 'Booking record',
    qxzhxsj: 'Please select the container return time',
    qsrch: 'Please enter the train No.',
    qsrssxh: 'Please enter the number of damaged containers',
    qsrhwssqk: 'Please enter the cargo loss information',
    qscfj: 'Please upload the attachment',
  },
  myOrders: {
    dqye: 'Current balance',
    kyye: 'Balance available',
    cjje: 'Late payment amount',
    djye: 'Frozen amount',
    fylx: 'Type of fees',
    jyje: 'Transaction amount',
    pzh: 'Voucher No.',
    range7d: 'Recent 7 days',
    range10d: 'Recent 10 days',
    range30d: 'Recent 30 days',
    periodfirst: 'First 10 days',
    periodsecond: 'Middle 10 days',
    periodthird: 'Last 10 days',
    zxje: 'Minimum amount',
    zdje: 'Maximum amount',
    yzn: 'Select year',
    jylsh: 'Transaction serial No.',
    loading: 'Loading',
  },
  processMap: {
    crumbs0: 'Guide',
    crumbs1: 'Business process',
    crumbs2: 'Vehicle information',
    czjbxx: 'Basic information of station',
    jzxxx: 'Container information',
    yjfl: 'Tariff rate',
    yunf: 'Freight',
    zaf: 'Miscellaneous fees',
    flfgjxgwj: 'Laws, regulations and related documents',
    tbxz: 'Insurance instructions',
    bxtk: 'Insurance clauses',
    hyblwt: 'Issues on freight handling',
    fhlc: 'Delivery process',
    lhlc: 'Pick-up process',
    sfych: 'Whether there is a forklift',
    fwdh: 'Service phone',
    yysj: 'Business hours',
    xzpl: 'Restricted categories',
    dz: 'Address',
    qtyq: 'Other requirements',
    zfzl: 'Maximum load (t)',
    hc: 'Converted length',
    rj: 'Volume (m³)',
    zht: 'Dead weight (t)',
    fb: 'Fee category',
    fblx: 'Type of fee category',
    tdjb: 'Gradient level',
    fjbd: 'Additional changes',
    wjm: 'Document title',
    fbdw: 'Issuing unit',
    wt: 'Question',
    xwzx: 'News consultation',
    xwbt: 'Headline',
    xwxq: 'News details',
    ggbt: 'Announcement title',
    ggxq: 'Announcement details',
    meiyou: 'None',
    you: 'Available',
    yjlx: 'Tariff type',
    bzyj: 'Standard tariff',
    tzyj: 'Adjust the tariff',
    tfmx: 'Gradient details',
    tddj: 'Gradient',
    tdks: 'Start of gradient',
    tdjs: 'End of gradient',
    sfatdjs: 'Calculated by gradient or not',
    jfgz: 'Charging rules',
    tddw: 'Gradient unit',
    bzqh: 'Switch currency',
    wtd: 'No gradient',
    wtxqym: 'Page of problem details',
    zwxz: 'Text download',
    fjxz: 'Annex download',
    bjzzt: 'Marked load capacity (t)',
    nbcc: 'Internal dimensions (length × width × height) (mm)',
    wbcc: 'External dimensions (length × width × height) (mm)',
    qtcz: 'Other car types',
    cncc: 'Internal (length × width × height) (mm)',
    ctcz: 'Carbody material',
    zxjzxj: 'Distance between bogie pivot centers (mm)',
    dmzgmgd: 'Height from ground to rail surface (mm)',
    kczxgd: 'Height of gravity center of empty car (mm)',
    cmcc: 'Door dimensions (width × height) (mm)',
    gtcc: 'Tank dimensions (length × diameter) (mm)',
    ytu: 'Purpose',
    ted: 'Characteristics',
    syss: 'Commercial speed (km/h)',
    clzdkg: 'Maximum car (width × height) (mm)',
    mianj: 'Area (m²)',
  },
  settings: {
    ysmm: 'original password',
    xz: 'add',
    dxdz: 'SMS customization',
    dzqz: 'electronic signature usbkey',
    xgfhxx: 'modify shipment information',
    cpxqxxg: 'product demand information modification',
    qyzcmc: 'enterprise registration name',
    jbrsj: 'operator\'s mobile phone',
    cpgyxx: 'product supply information',
    kcwd: 'Inventory (10000 tons)',
    xzmm: 'new password',
    ql: 'total sulfur (%)',
    cpxqxxxj: 'new product demand information',
    yx: 'mailbox',
    lxdh: 'contact phone',
    xgshxx: 'modify receipt information',
    qy: 'enterprise logo',
    hff: 'volatile matter (%)',
    txdz: 'communication address',
    zh: 'account number',
    qxz: 'please select',
    jgyd: 'price (yuan / ton)',
    qsrnr: 'please enter the content',
    qygwlj: 'enterprise official website link',
    jbr: 'handler',
    cmqy: 'coal production enterprise',
    fbsj: 'release time',
    jg: 'price',
    mtlx: 'coal type',
    scxgzj: 'upload relevant certificates:',
    sfzhm: 'ID number',
    js: 'role',
    tyfmc: 'shipper name',
    sc: 'delete',
    zcdd: 'loading place',
    sj: 'mobile phone',
    qyjj: 'enterprise profile',
    qsrmm: 'please enter the password',
    kyts: 'available days',
    ck: 'view',
    xgdsly: 'modify multimodal transport',
    jbrsfz: 'ID card of handler',
    qyyx: 'enterprise mailbox',
    ggsx: 'specification attribute',
    spfmc: 'name of drawee',
    tj: 'submit',
    cz: 'Operation',
    qsrshf: 'please enter the consignee',
    tp: 'picture',
    qylx: 'enterprise type',
    shfmc: 'ship to name',
    dh: 'telephone',
    xjdsly: 'new multimodal transport',
    hskmx: 'HA type grindability',
    khxmc: 'name of deposit bank',
    qsf: 'total moisture (%)',
    cptp: 'product picture',
    qydz: 'enterprise address',
    qymc: 'enterprise name',
    mhrrx: 'coal ash fusibility (℃)',
    ccbc: 'train / shift',
    qsr: 'please enter',
    xcdd: 'unloading place',
    zgjqzxsdhlw: 'up to two decimal places',
    dz: 'address',
    qydh: 'business phone',
    gdthl: 'fixed carbon content (%)',
    yhjbxx: 'user basic information',
    grsz: 'personal settings',
    fzfg: 'departure station / port',
    nsrsbh: 'taxpayer ID',
    shj: 'Audit Office',
    qrmm: 'confirm password',
    yxzh: 'bank account number',
    qyxcz: 'enterprise publicity photo',
    dzdg: 'arrival / arrival',
    rhwd: 'daily consumption (10000 tons)',
    khx: 'deposit bank',
    mmxg: 'password modification',
    fsxx: 'sending and receiving information',
    ssqy: 'affiliated enterprise',
    fh: 'return',
    kgdsd: 'available tonnage (ton)',
    qyjbxx: 'enterprise basic information',
    cpgxxx: 'product supply and demand information',
    fz: 'departure station',
    xjshxx: 'new receipt information',
    kgds: 'available tonnage',
    qsrdxyzm: 'please enter the SMS verification code',
    hmqy: 'coal consuming enterprise',
    Yhmc: 'user name',
    dxyzm: 'SMS verification code',
    cpgyxxxj: 'new product supply information',
    fplx: 'invoice type',
    xg: 'modify',
    xh: 'Serial number',
    lylb: 'combined transport category',
    xj: 'new',
    cpxqxx: 'product demand information',
    xm: 'name',
    zjxm: "Name on certificate",
    xgmm: 'modify password',
    gysj: 'supply time',
    xzrq: 'select date',
    hf: 'ash content (%)',
    xjfhxx: 'create shipment information',
    yyzz: 'business license',
    zzjgdmz: 'organization code certificate',
    swdjz: 'tax registration certificate',
    zzsxx: 'VAT information',
    message: 'your application has been submitted, please wait patiently for approval!',
    cyfhxx: 'common shipment information',
    xjcg: 'new successfully',
    xgcg: 'modification succeeded',
    cyshxx: 'common receipt information',
    cydsly: 'common multimodal transport',
    mm: 'password',
    hwggsx: 'cargo specification attribute',
    sctp: 'upload picture',
    cpgyxxg: 'product supply information modification',
    z: 'To ',
    yh: 'user',
    xx: 'information',
    sfzzmz: 'front photo of ID card',
    sfzbmz: 'back photo of ID card',
    qy1: 'enterprise',
    jbxx: 'base info',
    xyb: 'Next',
    fhdz: 'Delivery address',
    shouq: 'Retract',
    gduo: 'More',
    tiaoj: 'Condition',
    shdz: 'Receiving address',
    qtxxm: 'Please fill in your name',
    guoj: 'nationality',
    qxzgj: 'Please select nationality',
    hzhm: 'Passport ID',
    sfzyxq: 'Validity period of ID card',
    hzyxq: 'Passport\'s period of validity',
    qsrsfzhm: 'Please enter the ID number',
    qsrhzhm: 'Please enter your passport number',
    qxzsfzyxq: 'Please select the validity period of your ID card',
    qxzhzyxq: 'Please select the validity period of your passport',
    sfzzmzp: 'Front photo of ID card',
    sfzbmzp: 'Photo of the back of ID card',
    grscsfz: 'Handheld front photo of ID card',
    hzxxyzp: 'Passport information page photo',
    grschzxx: 'Handheld passport information page photo',
    sfzdq: 'My ID card is still valid for 10 days. Please update it promptly',
    hzdq: 'The passport is still valid for 10 days. Please update it in time',
    qsryzm: 'Please enter the verification code',
    qsrxsjh: 'Please enter a new phone number',
    yzmcw: 'Verification code error',
    xsjhyzc: 'New phone number registered',
    qysh: 'Enterprise tax number',
    yyzzbh: 'Business License number',
    zczj: 'Registered capital (RMB 10,000)',
    bz: 'currency',
    jp: 'kip',
    rmb: 'RMB',
    meij: 'dollar',
    qxzbz: 'Please select currency',
    sshy: 'Industry',
    jjxz: 'Economic nature',
    qyzh: 'Enterprise nature',
    jglx: 'Organization Type',
    qyyhzh: 'Corporate bank account',
    jyfw: 'Business scope',
    fddbr: 'Legal representative',
    frgj: 'corporate nationality',
    ffsfzhm: 'ID card number of legal person',
    ffsfzyxq: 'Validity period of corporate identity card',
    frhzhm: 'Corporate passport number',
    frhzyxq: 'Validity period of corporate passport',
    sjgs: 'Superior company',
    zjxx: 'Document information',
    zjxxts: 'It is recommended to upload a scanned ID document. Please minimize reflections when capturing photos. Ensure that all information presented in the picture is clearly visible, authentic, and valid without any modifications. The file size should not exceed 5MB, and the acceptable formats are .jpg, .jpeg, .bmp, and .png.',
    wtzm: 'Proof of Entrustment',
    yyzzyxq: 'Validity period of business license',
    wtzmyxq: 'Validity period of commission certificate',
    frsfzzmz: 'Front photo of corporate ID card',
    frsfzbmz: "Please upload the photo of the back of the legal person's ID card",
    frscsfzzmz: 'Legal representative holding front photo of ID card',
    zzzmcl: 'Qualification certification materials',
    syb: 'Back',
    ymzzzm: 'Coal transportation qualification certificate',
    tdzzws: 'Alternative planting documents',
    ymzzzmyxq: 'Validity period of coal transportation qualification certificate',
    tdzzwsyxq: 'Validity period of substitute planting documents',
    yksydzm: 'Iron ore movement certificate',
    yksydzmyxq: 'Validity period of iron ore movement certificate',
    jzxsyxy: 'Container utilization agreement',
    jzxsyxyyxq: 'Validity of the container utilization agreement',
    jzxsyxysy: 'Photo of the home page of the container use agreement',
    qscjzxsyxysy: 'Please upload the photo of the home page of the container use agreement',
    jzxsyxywy: "集装箱使用协议双方盖章页照片(en)",
    qscjzxsyxywy: "请上传集装箱使用协议双方盖章页照片(en)",
    qscyxdzbxxy:"Please upload a valid self-owned container agreement",
     zbxsyxy: 'Self-owned container use agreement',
    zbxsyxyyxq: 'Term of validity of self-owned container use agreement',
    zbxsyxysy: 'Photo of the home page of the self-owned container use agreement',
    qsczbxsyxysy: 'Please upload the photo of the home page of the self-owned container use agreement',
    zbxsyxywy: 'Photo of the last page of the self-owned container use agreement',
    qsczbxsyxywy: 'Please upload the photo of the last page of the self-owned container use agreement',
    qtcl: 'Other materials',
    qtclyxq: 'Validity period of other materials',
    jbrxx: 'Operator Information',
    jbrxxts: 'Due to the fact that you set the legal representative as the agent when filling in the basic information of the enterprise, the relevant information has been automatically displayed for you.',
    sjyzm: 'Mobile verification code',
    jsjhyzm: 'Old phone number verification code',
    xsjh: 'New phone number',
    xsjhyzm: 'New phone number verification code',
    ghsjh: 'Change phone number',
    qscsfzzmz: 'Please upload a photo of the front of your ID card',
    qscsfzbmz: '请上传身份证背面照片(en)',
    qscgrscsfzzmz: 'Please upload a photo of the front of the individual holding their ID card',
    qschuxxy: 'Please upload a photo of your passport information page',
    qscgrschzxxy: 'Please upload a photo of your personal passport holding information page',
    frhzxxy: 'Photo of legal person passport information page',
    frschzxxy: 'A photo of the legal representative holding the passport information page',
    yhqh: 'User switching',
    yhxxwh: 'User information maintenance',
    qhqy: 'Switching Enterprises',
    sskh: 'Belonging customers',
    khlx: 'Customer type',
    sskhxx: 'Customer information',
    khgx: 'Customer relationships',
    guanx: 'relationship',
    gjhdq: 'Country/Region',
    sqyw: 'Authorized business',
    qx: 'term',
    jlrq: 'creation date',
    baog: 'declare sth. at the customs',
    dl: 'agent',
    bdl: 'Being represented',
    zc: 'normal',
    stop: 'termination',
    gq: 'expire',
    slzt: 'Acceptance status',
    ysh: 'Audited',
    shlb: 'Review List',
    sqdl: 'Application Agent',
    ywfw: 'Business scope',
    dlkh: 'Proxy Client',
    sqqx: 'Authorization period',
    sm: 'illustrate',
    sqkh: 'Applying for clients',
    sqjl: 'Application record',
    sqrq: 'Application date',
    khxq: 'Customer details',
    zzf: 'Terminator',
    zzrq: 'End Date',
    zzsm: 'Termination instructions',
    yq: 'extension',
    bg: 'change',
    djckkhxq: 'Customer details, click to view',
    zjlx: 'ID type',
    zjh: 'ID Number',
    yyzzh: 'Business license number',
    jbrgl: 'Operator Management',
    jzrq: 'deadline',
    glqx: 'Related term',
    xzjbr: 'Add handler',
    bjjbr: 'Editor in charge',
    accept: 'accept',
    jbrsjh: 'Operator\'s mobile phone number',
    glzt: 'Association Status',
    tslx: 'Complaint type',
    clzt: 'Processing status',
    tjjs: 'Submission time',
    cx: 'revoke',
    xztsjy: 'Add complaint suggestions',
    bjtsjy: 'Editor\'s complaint suggestions',
    tppz: 'Image voucher',
    tjxx: 'submit information',
    slxx: 'Acceptance information',
    ddcx: 'Order inquiry',
    fhwt: 'Shipping issues',
    shwt: 'Receipt issue',
    slz: 'Accepting',
    ycx: 'revoked',
    qxzytsj: 'Please select a piece of data to confirm',
    zzyy: 'Reason for termination',
    qsrzzyy: 'Please enter the termination reason',
    qsrjjyy: 'Please enter the reason for rejection',
    qsrdlkh: 'Please enter the proxy customer',
    qzsxzyxywfw: 'Please select at least one business scope',
    qxzsqqx: 'Please select the authorization period',
    huz: 'Passport',
    qyxq: 'Enterprise details',
    ygl: 'Associated',
    yzz: 'Terminated',
    sjhgh: 'Change mobile phone number',
    yzmyfs: 'Verification code has been sent',
    dxssh: 'To be reviewed online',
    dxxqr: 'To be confirmed offline',
    dyhxg: 'To be modified by the user',
    shwb: 'Review completed',
    dgx: 'To be updated',
    yyq: 'Overdue',
    tsr: 'Complainant',
    mmxgcg: 'Password modification succeeded. Please log in again!',
    mrshxx: 'Setting of the default receipt information succeeded',
    mrfhxx: 'Setting of the default shipment information succeeded!',
    qgxyscdh: 'Please select the line to be deleted',
    qtxjbrsjh: 'Please enter the mobile phone number of the handler',
    sjhghcg: 'Mobile phone number has been changed successfully!',
    qxzglqx: 'Please select the associated period',
    qsrjbrxm: "Please enter the handler's name",
    xxshzt: 'Information review status',
    qsrysmm: 'Please enter the original password',
    qqrdlmm: 'Please confirm the login password',
    jmmcw: 'Incorrect old password',
    jxxz: 'Continue to add',
    tcbj: 'Exit editing',
    gxqr: 'Relationship confirmation',
    qyqz: 'Enterprise seal',
    jqsdsjgl: 'Management of pick-up and delivery drivers',
    qzlx: 'Seal type',
    qztsy: 'Seal pending review, the newly uploaded seal cannot be used for business for the time being/it has failed to pass the review. Please re-upload the seal.',
    qztsyShz: 'Seal pending review, the newly uploaded seal cannot be used for business for the time being',
    qztsyWtg: 'It has failed to pass the review. Please re-upload the seal',
    cxsc: 'Upload again',
    zwqzxx: 'No seal information available!',
    ljsc: 'Upload now',
    scqz: 'Upload seal',
    qscqztp: 'Please upload the seal picture',
    qxzqzlx: 'Please select the seal type',
    sjxm: 'Driver is name',
    csrq: 'Date of birth',
    zhuzhi: 'Address',
    jszzp: 'Driving license',
    xzsjxx: 'Add a driver',
    cksjxx: 'View the driver information',
    bjsjxx: 'Edit the driver information',
    qsrsjxm: 'Please input driver is name',
    qsrzjhm: 'Please enter the ID document No.',
    gjqh: 'International area code',
    qsrgjqh: 'Please enter the international area code',
    kchwh: 'Truck No. maintenance',
    hdzz: 'Rated loading capacity(t)',
    ztsy: 'Suspend of use',
    trsy: 'Put into use',
    jk20: '20ft container truck',
    jk40: '40ft container truck',
    fjk: 'Non-container truck',
  },
  transportConsultation: {
    fh: 'Return',
    dqwz: 'current position',
    xq: 'Details',
    jgcx: 'Price query',
    sy: 'Homepage',
    tbjdxq: 'reporting stage requirements',
    ywbllc: 'Business process',
    flfgjgfxwj: 'laws and regulations and normative documents',
    fwcszhxx: 'Comprehensive information of service places',
    zxfw: 'Consulting Services',
    jmjm: 'Bidding and bidding',
    clcs: 'Vehicle parameters',
    gdyd: 'Pending order should be ordered',
    hyblcjwt: 'Frequently Asked Questions about Freight Handling',
    gd: 'more >',
    cc: 'Gondola',
    tlzfsfxmhbz: 'Railway miscellaneous charges and standards',
    hwzzfjzflybjfv: 'Cargo handling fee base rate and insurance rate',
    hwyjl: 'Cargo freight rate',
    yyzfwxxcx: 'Service station service information query',
    yyzlstxzgg: 'Announcement of temporary suspension of business station and limited installation',
    gbjg: 'publish the results',
    qdht: 'Sign a contract',
    zjjs: 'Fund settlement',
    jj: 'bid',
    fqxm: 'Initiate project',
    fqjyd: 'Initiate a transaction order',
    qdjyd: 'Determine the transaction order',
    dxjy: 'Directed transaction',
    qryd: 'Confirm the order',
    gxyd: 'Purchase and sales order',
    gxgd: 'Buy and sell pending order',
    hwjf: 'goods delivery',
    hwzz: 'Cargo Tracking',
    yfzf: 'Freight payment',
    tbrxq: 'report daily requirements',
    ysfw: 'Shipping Service',
    smjy: 'business transaction'
  },
  legalDocument: {
    dqwz: 'current position',
    zxfw: 'Consulting Services',
    ffgjgfxwj: 'laws and regulations and normative documents',
    xq: 'details',
    xz: 'download',
    fh: 'return',
    t: 'bar',
    y: 'page'
  },
  stationinfo: {
    yyzlstxzgg: 'Announcement of temporary suspension of business station and limited installation',
    qsrfbdw: 'Please enter the publishing unit',
    zyxsx: 'Special line attribute',
    fsplpm: 'Send category/name',
    qsr: 'Please input',
    qc: 'full name',
    qznl: 'lifting capacity',
    bt: 'title',
    fz: 'Send station',
    fwcszhxx: 'Comprehensive information of service places',
    qxzs: 'Please select a province',
    dz: 'arrival',
    yyzfwxx: 'Business station service information',
    yyz: 'Business station:',
    shdw: 'Receiving unit',
    cc: 'Forklift',
    qxzyyz: 'Please select a business station',
    fbdw: 'Publishing unit:',
    ddplpm: 'arrival category/name',
    qxzq: 'Please select the area',
    tzsj: 'downtime',
    tzlyj: 'The reason for stopping the installation',
    yyzfwxxcx: 'Service station service information query',
    s: 'province:',
    shi: 'City',
    cx: 'Query',
    zxfw: 'Consulting Services',
    xq: 'County (district):',
    fbsj: 'Published time:',
    pm: 'product name',
    fh: 'Return',
  },
  containerDayDemand: {
    crumbs0: 'Container',
    crumbs1: 'Propose daily demand',
    tbrq: 'Date of submission',
    kssj: 'Start date',
    jssj: 'End date',
    jsrq: 'End date',
    tyr: 'Shipper',
    srdmhmcjzcx: 'Enter code or name to find exactly',
    faz: 'Departure station',
    ydh: 'Reservation number',
    ydxqh: 'Waybill demand No',
    shouhr: 'consignee',
    shouhf: 'Ship to',
    tuoyf: 'Shipper',
    daoz: 'Drrive at a station',
    qsr: 'Please enter',
    chax: 'Query',
    qink: 'empty',
    xuhao: 'Serial number',
    ydztbm: 'Waybill status code',
    ydlxbm: 'Waybill type code',
    ysfsbm: 'Transportation mode code',
    ysfs: 'type of shipping',
    wxpbsbm: 'Dangerous goods identification code',
    yxpbz: 'Dangerous goods sign',
    zyrq: 'Date of shipment',
    xqtcfs: 'Demand presentation method',
    jdxqh: 'Stage demand No',
    rxqzt: 'DemandStatus',
    pinm: 'Product Name',
    zdaoz: 'Terminal station',
    daoj: 'Arrival',
    ssqymc: 'Company name',
    xianh: 'Case No',
    biaoz: 'sign',
    zcdd: 'Loading place',
    xcdd: 'Unloading location',
    tcrxq: 'Propose daily demand',
    ydcx: 'Waybill query',
    yun: 'transport',
    ydxx: 'Waybill Information',
    hpiaoh: 'Cargo ticket No',
    ssqy: 'Affiliated enterprise',
    tbqy: 'Submission enterprise',
    tyrjzsx: 'Particulars recorded by the shipper',
    cyrjzsx: 'Particulars recorded by the carrier',
    ding: 'book',
    dcxx: 'Ordering information',
    ydcs: 'Number of scheduled vehicles',
    dcfs: 'How to order a car',
    checi: 'Train number',
    yuyueh: 'Appointment No',
    dczt: 'Subscription status',
    zcrq: 'Loading date',
    huo: 'goods',
    hwxx: 'Cargo information',
    xianx: 'Box type',
    xianl: 'Box type',
    kongz: 'Empty weight',
    shifh: 'Seal No',
    hwmc: 'Item name',
    hwpm: 'Name of goods',
    hwjg: 'Price of goods',
    tyrtbzl: 'Weight filled by shipper',
    cyrqdzl: 'Carrier determined weight',
    wu: 'matter',
    wulxx: 'Logistics information',
    wl_mdz: 'logistics - Door to station',
    lxrxm: 'Contact name',
    dianh: 'Telephone',
    qhdz: 'Pick up address',
    lic: 'mileage',
    xqsm: 'Requirements description',
    qtsm: 'Other instructions',
    guanb: 'close',
    xzjdxqh: 'Select stage demand No',
    qsrjdxqh: 'Please enter the stage demand number',
    yslx: 'Transport type',
    gjly: 'International combined transport',
    ptys: 'General transportation',
    ches: 'Number of cars',
    slcs: 'Number of accepted vehicles',
    caoz: 'Operation',
    xz: 'choice'
  },
  containerCartonNo: {
    crumbs0: 'Container',
    crumbs1: 'Refill box No',
    tbrq: 'Date of submission',
    to: 'to',
    ydxqh: 'Waybill demand No',
    yundh: 'Reservation number',
    xianx: 'Box type',
    qxr: 'Please select',
    xianl: 'Box type',
    xianh: 'Case No',
    chax: 'Query',
    qink: 'empty',
    xuhao: 'Serial number',
    ydId: 'book ID',
    ydhy: 'Reservation number(primary)',
    rxqh: 'Daily demand No',
    xh1: 'Case No1',
    xh2: 'Case No2',
    ydzztbm: 'Waybill status code',
    ydzt: 'Waybill status',
    rxqzt: 'DemandStatus',
    ydlxbm: 'Waybill type code',
    ydlx: 'Waybill type',
    ysfsbm: 'Transportation mode code',
    ysfs: 'type of shipping',
    wxpbsbm: 'Dangerous goods identification code',
    wxpbs: 'Dangerous goods identification',
    tjrq: 'Submission date',
    danx: 'Single box',
    xianshu: 'Box genus',
    shi: 'yes',
    sfwz: 'Whether it is complete',
    sfdx: 'Single box or not',
    sfzp: 'Whether to prepare ticket',
    tbkhm: 'Name of submitted customer',
    sskhmc: 'Customer name',
    ssqy: 'Affiliated enterprise',
    faz: 'Departure station',
    daoz: 'Drrive at a station',
    tyr: 'Shipper',
    shr: 'consignee',
    tbqymc: 'Name of submitting enterprise',
    tibqy: 'Reporting enterprise',
    yyh: 'Appointment No',
    zysj: 'Operation time',
    hwjs: 'Number of goods',
    caoz: 'Operation',
    ydcx: 'Waybill query',
    butxh: 'Refill box No',
    yun: 'transport',
    ydxx: 'Waybill Information',
    zzjgcl: 'Loading reinforcement materials',
    canchu: 'storage',
    lcbw: 'Cold storage (insulation)',
    bxys: 'Insurance transportation',
    hph: 'Cargo ticket No',
    zcdd: 'Loading place',
    xcdd: 'Unloading location',
    tyrjzsx: 'Particulars recorded by the shipper',
    cyrjzsx: 'Particulars recorded by the carrier',
    ding: 'book',
    dingcxx: 'Ordering information',
    ydcs: 'Number of scheduled vehicles',
    dcfs: 'How to order a car',
    chec: 'Train number',
    dczt: 'Subscription status',
    zcrq: 'Loading date',
    huo: 'goods',
    hwxx: 'Cargo information',
    kongz: 'Empty weight',
    sfh: 'Seal No',
    hwmc: 'Item name',
    hwjg: 'Price of goods',
    tyrtbzl: 'Weight filled by shipper',
    cyrqdzl: 'Carrier determined weight',
    qsrjdxqh: 'Please enter the stage demand number',
    guanb: 'close',
    btyd: 'Supplement the waybill',
    ke: 'passenger',
    kehxx: 'Customer information',
    fa: 'send',
    fhxx: 'Shipping Information',
    faj: 'Development Bureau',
    tlhc: 'Railway freight yard',
    yddh: 'Mobile phone',
    txdz: 'mailing address',
    jbr: 'Handled by',
    sfzh: 'ID number',
    lxrxm: 'Contact name',
    dianh: 'Telephone',
    dzyd: 'Electronic waybill',
    xzdzyd: 'Electronic waybill is selected, and the paper waybill does not need to be sealed, so the delivery is more convenient',
    yjxmh: 'Freight rate item No',
    jtxcd: 'Specific unloading point',
    jzsx: 'Recorded items',
    zhi: 'payment',
    zfsz: 'Payment settings',
    zffs: 'Payment method',
    yfk: 'advance charge',
    xianjin: 'cash',
    zhip: 'Check',
    yhk: 'bank card',
    hzzf: 'Summary payment',
    bizxz: 'Currency selection',
    jipu: 'Kip',
    rmb: 'RMB',
    myuan: 'dollar',
    pinl: 'category',
    cpchx: 'Go back to the box again',
    tyrtbzlqk: 'Weight filled by shipper(kg)',
    jiage: 'Price (yuan)',
    liang: 'two',
    ldwl: 'Logistics at both ends',
    msg1: 'According to your needs, you can select to enter the logistics service information such as receiving, delivery and warehousing at the departure and arrival stations.',
    mdz: 'Door to station',
    smqh: 'Door to door pickup',
    zdm: 'Stand to the door',
    qhdz: 'Pick up address',
    qianmi: 'Kilometer',
    licheng: 'mileage(km)',
    tyrqdjs: 'Number of pieces determined by the shipper',
    xuqsm: 'Requirements description',
    qhgsfy: 'Estimated pickup cost',
    smsh: 'Door to door delivery',
    shdz: 'Shipping address',
    tijiao: 'Submit',
    cywlxx: 'Common logistics information'
  },
  containerInvoice: {
    crumbs0: 'Container',
    crumbs1: 'Fill in the waybill',
    ke: 'passenger',
    kehxx: 'Customer information',
    ssqy: 'Affiliated enterprise',
    fa: 'send',
    fhxx: 'Shipping Information',
    faz: 'Departure station',
    tyr: 'Shipper',
    faj: 'Development Bureau',
    qsr: 'Please enter',
    zcdd: 'Loading place',
    qxz: 'Please select',
    txdz: 'mailing address',
    jbr: 'Handled by',
    sfzh: 'ID number',
    jbrsj: 'Mobile phone of handler',
    sou: 'collect',
    shxx: 'Receiving information',
    daoz: 'Drrive at a station',
    shr: 'consignee',
    zdaoz: 'Terminal station',
    daoj: 'Arrival',
    xcdd: 'Unloading location',
    bllx: 'Train type',
    blcc: 'Train number',
    zobl: 'China Europe train',
    zybl: 'Central Asia train',
    yun: 'transport',
    ysxx: 'Waybill Information',
    zzjgcl: 'Loading reinforcement materials',
    canchu: 'storage',
    lcbw: 'Refrigerate  (keep warm )',
    plky: 'Bulk Express',
    bxys: 'Insurance transportation',
    jtxcd: 'Specific unloading point',
    jzsx: 'Recorded items',
    zhi: 'Payment',
    zfsz: 'Payment settings',
    zffs: 'Payment method',
    yfk: 'advance charge',
    xianjin: 'cash',
    zhip: 'Check',
    yhk: 'bank card',
    hzzf: 'Summary payment',
    bizxz: 'Currency selection',
    jipu: 'Kip',
    rmb: 'RMB',
    myuan: 'dollar',
    huo: 'goods',
    hwxx: 'Cargo information',
    dxyd: 'Single container waybill',
    plzjxs: 'Increase the number of cases in batch',
    xzh: 'New row',
    sch: 'Delete row',
    xuhao: 'Serial number',
    xzhwmc: 'Select goods name',
    pinl: 'category',
    twbh: 'Iron hazard No',
    xianh: 'Case No',
    qsrxh: 'Please enter the case number',
    xianshu: 'Box genus',
    tielux: 'Railway box',
    zibeix: 'Self provided box',
    xianx: 'Box type',
    xianl: 'Box type',
    kongz: 'Empty weight',
    kong: 'empty',
    zhong: 'heavy',
    baozhuan: 'packing',
    cpchx: 'Go back to the box again',
    tielcdx: 'Railway open top box',
    tezx: 'Special case',
    cquch: 'Go back and forth',
    xiasch: 'Launching return',
    sfh: 'Seal No',
    zhognlqk: 'Weight (kg)',
    jiage: 'Price (yuan)',
    msg1: '*Description of goods name: if the corresponding name cannot be found in the goods name, fill in the name below and select the corresponding category. Please select self provided container (or container) for product name when sending self provided container and there is no goods in the container.',
    msg2: 'Fill in other product names (such as empty container, empty self-contained container, etc.), and the system will charge by heavy container.',
    ri: 'day',
    rysxq: 'Daily transportation demand',
    zyrq: 'Date of shipment',
    xzrq: 'Select date',
    xqtcfs: 'Demand presentation method',
    zjtcrxq: 'Direct daily demand',
    syjdxq: 'Use phase requirements',
    jdxqh: 'Stage demand No',
    qsrjdxqh: 'Please enter the stage demand number',
    ches: 'Number of cars',
    chec: 'Train number',
    liang: 'two',
    ldwl: 'Logistics at both ends',
    msg3: 'According to your needs, you can select to enter the logistics service information such as receiving, delivery and warehousing at the departure and arrival stations.',
    mdz: 'Door to station',
    smqh: 'Door to door pickup',
    zdm: 'Stand to the door',
    lxrxm: 'Contact name',
    dianh: 'Telephone',
    qhdz: 'Pick up address',
    qianmi: 'Kilometer',
    licheng: 'mileage(km)',
    tyrqdjs: 'Number of pieces determined by the shipper',
    xuqsm: 'Requirements description',
    qhgsfy: 'Estimated pickup cost',
    smsh: 'Door to door delivery',
    shdz: 'Shipping address',
    tijiao: 'Submit',
    qink: 'empty',
    chax: 'Query',
    yslx: 'Transport type',
    tuoyf: 'Shipper',
    souhf: 'Ship to',
    hwpm: 'Name of goods',
    slcs: 'Number of accepted vehicles',
    caoz: 'Operation',
    xuanzhe: 'choice',
    xzjdxqh: 'Select stage demand No',
    hwmc: 'Item name',
    fhrxx: 'Consignor information',
    zjh: 'ID document number',
    jbrsjh: "Handler's mobile phone number",
    zzzmwj: 'Qualification certificate',
    bzjs: 'Standard notes',
    zyjs: 'Free record',
    zmwjmc: 'Name of supporting document',
    hm: 'Number',
    fj: 'Annex',
    shrxx: 'Consignee information',
    fkxx: 'Payment information',
    fkr: 'Payer',
    dxys: 'Single container transport',
    ldwlts: 'Input logistics service information such as pick-up and delivery at the departure/arrival station according to your needs',
    xqsm: 'Demands description',
    lc: 'Mileage',
    dh: 'Tel.',
    qk: 'Clear',
    tj: 'Submit',
    jdxq: 'Phase demand',
    realHzmc: 'Cargo owner',
    xj: 'Cash',
    wlgs: 'Logistics company'
  },
  pathAnalysis: {
    crumbs0: 'transportation services',
    crumbs1: 'Transportation scheme selection',
    kaishi: 'beginning',
    jiesu: 'end',
    zss: 'Time saving',
    zsq: 'Most economical',
    huafei: 'spend',
    haoshiyue: 'It takes about',
  },
  industryInfo: {
    fbsj: 'Release time',
    xzsj: 'Select date',
    bt_nr: 'title / content',
    chax: 'Query',
    qink: 'empty',
    smjy: 'Trade transaction',
    hyzx: 'Industry information',
    sy: 'index',
    tzgg: 'Notice notice',
    tlxw: 'Railway news',
    dsly: 'Multimodal transport',
    fh: 'return',
  },
  newsDetail: {
    sy: 'index',
    smjy: 'Trade transaction',
    hyzx: 'Industry information',
    tzgg: 'Notice notice',
    tlxw: 'Railway news',
    dsly: 'Multimodal transport',
    hyzx2: 'Industry information',
    xq: 'details',
    xz: 'download',
    fh: 'return'
  },
  index_page: {
    ysxq: 'Transportation demand',
    zhenc: 'Complete vehicle',
    jzx: 'Container',
    guolian: 'League of Nations',
    yfcx: 'Freight query',
    qsrcfz: 'Please enter the departure station',
    qsrddz: 'Please enter the destination',
    qsrds: 'Please enter tonnage',
    chax: 'Query',
    faz: 'Departure station',
    daoz: 'Drrive at a station',
    duns: 'Tonnage',
    yunf: 'freight',
    yuan: 'element',
    qued: 'determine',
    hwzz: 'Cargo tracking',
    xqdh: 'Demand doc No',
    qsrxqdh: 'Please enter the demand doc No',
    ywjs: 'Business introduction of Laos China Railway',
    ysfw: 'Freight service',
    ysfw_msg: 'China Laos railway connects Kunming, China, and Vientiane, Laos. The railway has a total length of more than 1000 kilometers. It is an electrified mixed passenger and freight railway, with a total length of 508 main lines in China 53 km, a 414 km long ordinary speed railway with a design speed of 160 km / h in Laos, is a class I national railway electrified railway. ',
    jzx_msg: 'Container transportation has many advantages, such as fast shipping, convenient shipping, green environmental protection, low comprehensive transportation cost and so on. In 2021, the proportion of railway container transportation in Yunnan has reached more than 40%, ranking first in China; More than 23.71 million tons of goods were transported through containers, a year-on-year increase of 28 6%, with the growth rate ranking first in China.',
    gjly: 'International combined transport',
    gjly_msg: 'International Railway intermodal transport refers to a cargo transport organization mode that uses a unified international intermodal transport bill, the railway is responsible for the entire transport through two or more countries, and the railway of one country transfers the goods to the railway of another country, without the participation of the consignor and the consignee. The international freight train leaves the country through Mohan port in Yunnan, with a total journey of about 2400km. It is expected to arrive in Vientiane, the capital of Laos in 7 days, and deliver "made in China" local high-quality products to countries and regions along the "the Belt and Road". ',
    jqsd: 'Receiving and delivering',
    jqsdqr: 'Sign for pick-up and delivery',
    jqsd_msg: 'For short-distance or long-distance transportation of goods from the delivery place agreed by the shipper to the public loading and unloading place of the railway station or from the public loading and unloading place of the railway station to the receiving place agreed by the consignee, the receipt and delivery fee shall be charged. ',
    bjbx: 'Insured insurance',
    bjbx_msg: 'Railway insured transport refers to an economic security activity in which the shipper takes the value of the consigned goods and their related interests as the insurance subject. The owner or passenger participating in the insured transportation shall claim the actual value of the consigned goods, parcels and baggage to the carrier at the time of consignment, and pay the insurance fee as required. On the premise of full insurance coverage, in case of any carrier is liability loss, it will be fully compensated according to the actual loss. ',
    tzgg: 'Notice notice',
    tzgg_msg: 'Truthfulness · punctuality · completeness',
    gengduo: 'more',
    tlxw: 'Railway news',
    tlxw_msg: 'I knew what was happening',
    hyzx: 'Industry information',
    hyzx_msg: 'Control the latest freight information',
    zltllt: 'China Laos Railway Forum',
    jhwt: 'Essence question',
    hzhb: 'cooperative partner',
    bannertitle: "Transnational Logistics · Global Cargo Transport",
    zcwjgq: "The registration document has expired, submission is not allowed on this page",
    zhysd: "Your account has been locked. Please contact the company for assistance!",
    yxqbzygyjsgx: "The following certificates are valid for less than one month, please update them in time",
    yxzjygq: "The following certificates have expired, please update them in time"
  },
  jsLang: {
    zg: 'China',
    lw: 'Laos',
    tg: 'Thailand',
    zw: 'chinese',
    ew: 'Russian',
    yw: 'english'
  },
  hwydInfo: {
    xhsjy: 'Unloading time-MM-DD-HH arrival station charge bill No.',
    tzsjy: 'Notification time-MM-DD-HH consignee ID No.',
    yebzqq: 'Insufficient balance. Please recharge on the advance deposit management interface!',
    qqrxxw: 'Please confirm that the information is correct. Continue to pay or not?',
    yfkdyt: 'Advance payment credit (refund) voucher',
    lkdwkh: 'The payee opens an account to receive refund',
    lkdwkh1: 'The payee opens an account to receive refund',
    czjjhr: 'Signature and seal of the person receiving (delivering) the goods at the station',
    lcsrmm: 'Two passwords do not match.',
    zfcgcz: 'Payment succeeded/recharge succeeded',
    zfsbcz: 'Payment failed/recharge failed',
    qzsxzy3: 'Please select at least one bill',
    qhlckm: 'Pick-up mileage (km)',
    qxzyzf: 'Please select the paid bill',
    cyrqdzl: 'Carrier confirms weight',
    qsrtxj: 'Please enter withdrawal amount',
    zyxmcd: 'Private siding name code',
    zfzczz: 'Paying/recharging',
    qsrymm: 'Please input the original password.',
    qsrxmm: 'Please input the current password.',
    gpjhwz: 'This bill number has not been paid',
    gpjhyz: 'This bill number has been paid',
    qqrsft: 'Please confirm if you want to refund',
    khhjzh: 'Bank of deposit and account No.',
    nsrsbh: 'Taxpayer identification number',
    zzdjcl: 'Loading reinforcement materials',
    crpzbh: 'Deposit voucher No.',
    crpzbhColon: 'Deposit voucher No.:',
    dyth: 'Credit (refund)',
    yfkstj: 'Fill in for advance payment',
    jyjcsb: 'Transaction check failed',
    txshjj: 'Withdrawal review rejected',
    pjhbzq: 'Incorrect bill number',
    sfzhm: 'ID card No.',
    spfmc: 'Name of the receiver',
    xqdh: 'Demand order No.:',
    jey: 'Amount (RMB)',
    yfkdw: 'Advance payment unit',
    skdwh: 'Payee and',
    dyhth: 'Credit or refund',
    yxjzh: 'Bank and account number',
    lqpzr: 'Voucher receiver',
    jzxxx: 'Container type',
    yyspj: 'Original transport bill',
    jzxxh1: 'Container No.',
    cyrjs: 'Carrier note',
    tyrjs: 'Consignor note',
    czrqc: 'Station date stamp',
    shrqz: 'Signature and seal of consignee',
    yfkzf: 'Advance payment',
    yxkzf: 'Bank card payment',
    bczf: 'Amount paid this time:',
    txshz: 'Withdrawal review in progress',
    yqxzf: 'Payment canceled',
    bjys: 'Value-insured transport',
    blzb: 'Handling type',
    crumbs01: 'Consignment note',
    czcg: 'Operation succeeded',
    czch: 'Type of vehicles and number of vehicles',
    fplx: 'Invoice type',
    fymx: 'Details of costs',
    hwjg: 'Price of goods',
    hwmc: 'Item name',
    hwpm: 'Description of goods',
    hwzl: 'Item Weight',
    hzzf: 'Summary payments',
    lxdh: 'Tel.',
    qhdd: 'Pick-up address',
    shdd: 'Delivery address',
    smqh: 'Pick up from patron',
    smsh: 'Door-to-door delivery',
    smxc: 'Door-to-door unloading',
    smzc: 'Door-to-door loading',
    wxts: 'Tips',
    yfzf: 'Freight payment',
    zcrq: 'Loading date',
    zffs: 'Payment method',
    jjyy: 'Reason for rejection',
    bjpz: 'Edit voucher',
    lzgs: 'Laos-China Railway Co., Ltd.',
    skdw1: 'Payee',
    skdw1Colon: 'Payee:',
    pjmc: 'Bill name',
    dx: '(In words)',
    xjzf: 'Cash payment',
    tkcg: 'Refund succeeded',
    tksb: 'Refund failed',
    txcg: 'Withdrawal succeeded',
    txsb: 'Withdrawal failed',
    ptzc: 'Ordinary complete vehicle',
    zlyz: 'Self-propelled operation',
    lshw: 'Bulk cargo',
    plhw: 'Batch cargo',
    pmdm: 'Product name code',
    fffs: 'Payment method',
    lhfs: 'Picking mode',
    zzlh: 'Paper picking',
    dzlh: 'Electronic picking',
    ydqx: 'Transit period',
    fyhj: 'Total fee',
    jfzl: 'Chargeable weight',
    pjlx: 'Bill type',
    xxxl: 'Container type and category',
    sjhm: 'Mobile phone',
    xzfw: 'Select service',
    qtfw: 'Other services',
    zdrq: 'Prepared on',
    fkdw: 'Payment unit',
    ssbz: 'Paid-in currency',
    ssje: 'Paid-in amount',
    zpzf: 'Cheque payment',
    bjyf: 'Supplementary payment of freight',
    ztwm: 'Status unknown',
    crumbs02: 'Container',
    dzf: 'To be paid',
    jbr: 'Handled by',
    qsr: 'Please input',
    rmb: 'RMB',
    sfh: 'Sealing number',
    shouhr: 'Consignee',
    tuoyf: 'Consignor',
    tyr: 'Shipper',
    xqh: 'Demand number',
    ybg: 'Changed',
    yfk: 'Advance payment',
    yhk: 'Bank card',
    ywc: 'Completed',
    zyx: 'Dedicated line',
    zzs: 'Value-added tax',
    pjh: 'Bill No.',
    hgr: 'or individual',
    lkr: 'Payee',
    tkz: 'Refund in progress',
    txz1: 'Withdrawal in progress',
    yzf1: 'Paid',
    fkr: 'Payer',
    pbh1: 'Tarpaulin No.',
    ptp1: 'General invoice',
    zyp: 'Special invoice',
    hyy: 'Freight clerk',
    zdr: 'Prepared by',
    fy: 'Fee:',
    yck: 'Advance deposit',
    address: 'Address',
    back: 'Return',
    baozhuan: 'Packaging',
    bc: 'Save',
    beiz: 'Remarks',
    bz1: 'Indicated weight',
    canchu: 'Storage',
    ch: 'Train No.',
    chak: 'View',
    daoz: 'Arrival station',
    dh: 'Tel.',
    dy: 'Printing',
    faz: 'Departure station',
    huoq: 'Goods area',
    huow: 'Freight section',
    jianshu: 'Quantity',
    jipu: 'KIP',
    khhzh: 'Account No.',
    my: 'USD',
    name: 'Description',
    qd: 'Confirmed',
    qink: 'Clear',
    qr: 'Confirm',
    quxiao: 'Cancel',
    tiji: 'Volume',
    ts: 'Tips',
    xh3: 'Container No.',
    xianjin: 'Cash',
    zaf: 'Miscellaneous fees',
    zhip: 'Check',
    zhongliang: 'Weight',
    cz: 'Recharge',
    tx: 'Withdraw',
    bh: 'No.',
    qh: 'Start No.',
    zh: 'End No.',
    zs: 'Number of sheets',
    ke: 'Amount',
    dw: 'Unit',
    je: 'Amount',
    tk: 'Refund',
    hj: 'Total',
    fb: 'Fee category',
    fl: 'Rate',
    fj: 'Excursus',
    gs: 'Company',
    fm: 'Item',
    se: 'Tax amount',
    dx2: 'In words',
    qz1: 'Signature and seal',
    zf1: 'Payment',
    ri: 'Day',
    yuan: 'Yuan',
    y1: '100 million',
    q: 'Thousand',
    b: 'Hundred',
    s1: 'Ten',
    w1: '10 thousand',
    q1: 'Thousand',
    b1: 'Hundred',
    s2: 'Ten',
    j: 'Jiao',
    f: 'Fen',
    n: 'Year',
    y2: 'Month',
    shlc: 'Delivery mileage',
    jzxsfh: 'Container sealing No.',
    yjh: 'Freight No.',
    lcbw: 'Refrigeration (insulation)',
    zcf: 'Loading party',
    sff: 'Sealing party',
    qsrtyf: 'Please input consignor',
    sxfk: 'The above advance payment is',
    sxtk: 'The above refund is',
    rsdy: 'Full use',
    yxjzp: 'Full refund by cash/cheque',
    yh: 'Bank',
    sxyfkQ: 'The above advance payment is fully used on MM/DD',
    sxtkQ: 'The above refund is paid in full by cash/cheque on MM/DD',
  },
  stagedemand: {
    qxzdzqxzfz: 'Please select the arrival station. If the departure station is not selected, please select the departure station first',
    qxzhwpm: 'Please select the product name',
    qsrysrq: 'Please enter the transportation date',
    jdxqtb: 'The tonnage range submitted by phase demand is 100,000 tons to 500,000 tons',
    qdsfsc: 'This operation will delete the data permanently. Continue?',
    hwtzfr: 'Goods characteristics: calorific value (kcal/kg):',
    hwtz: 'Goods characteristics: calorific value (kcal/kg)',
    hwtzColon: 'Goods characteristics: calorific value (kcal/kg)',
    frlbnc: 'The calorific value cannot exceed 9999.99',
    qsrxcddszjy: 'Please input 2-400 places of unloading',
    qsrzcddszjy: 'Please input 2-400 places of loading',
    ghsjgsbzq: 'Fixed or mobile phone number format is incorrect',
    qnqdtb: 'The demand number is xxxxx. Please submit it in the “information to be submitted”.',
    qnqdtbxxtj: 'Please go to "Information to be submitted" to submit',
    qnqdtb1: 'Please submit it in the information to be submitted.',
    sctpjy5: ' files selected this time,  in total ',
    dbcgqd: 'Please wait for the acceptance of the report.',
    qsrnsrsbh: 'Please input taxpayer identification number',
    qsrspfmc: 'Please input the name of the receiver',
    qsrhwms: 'Please input description of goods',
    qsrxcdd: 'Please input the place of unloading',
    qsrzcdd: 'Please input the place of loading',
    qxzfplx: 'Please select invoice type',
    qxzhwm: 'Please select the goods name',
    qxzjzxx: 'Please select container type',
    qxzqsrq: 'Please select the start date',
    qxzzzrq: 'Please select the expiry date',
    qxztbf: 'Please select the submission method',
    frlbnw: 'The calorific value cannot be 0',
    qxzdbx: 'Please select information to be submitted',
    impLsxq: 'Import historical demand ',
    jdxqdb: 'Phased demand reporting ',
    jdxqlx: 'Type of phase demand',
    lsxqImp: 'Historical demand import',
    lsxqImpColon: 'Historical demand import:(en)',
    qsrkhh: 'Please input the bank of deposit',
    qsrshf: 'Please input consignee',
    qsrtyf1: 'Please input consignor',
    qsryhm: 'Please input username',
    qyzyhm: 'Please verify the user name',
    cyshf: 'Common consignee',
    jdqxh: 'Phase demand number',
    mdj: 'Boten (border)',
    qsrbz: 'Please input remarks',
    qsrcs: 'Please input number of vehicles',
    qsrcz: 'Please enter tonnage, please select model',
    qsrdh: 'Please input your phone number',
    qsrds: 'Please input tonnage',
    qsrdz: 'Please input the address',
    qsrdz1: 'Please input the arrival station',
    qsrfz: 'Please input departure station',
    qsrzh: 'Please input account number',
    sfzhm: 'ID card No.',
    yqxsc: 'Deletion cancelled',
    zzsxx: 'VAT information',
    cyfhf: 'Commonly used shipping parties',
    qsrsz: 'Please enter the number',
    bxwsz: 'Must be digital',
    ysyf: 'Transportation Month',
    qxzcz1: 'Please select type of vehicle',
    qsrcx: 'Please input model',
    dsd: 'Tonnage (tons)',
    sccg: 'Deleted successfully!',
    crumbs19: 'Phase demand',
    crumbs29: 'demand creation',
    czcg: 'Operation succeeded',
    drcg: 'Imported successfully',
    drwj: 'Import file',
    fhxx: 'Delivery information',
    fsdz: 'Non-bulk storage',
    gjly: 'International through traffic',
    hqhw: 'Freight area and freight section ',
    hwmc: 'Item name',
    hwms: 'Description of goods',
    hwmsColon: 'Description of goods:',
    hwpm1: 'Description of goods',
    hwxx: 'Goods information',
    lsxq: 'Historical demands',
    lxdh1: 'Tel.',
    ptys: 'General transport',
    qymc: 'Enterprise name',
    shxx: 'Receipt information',
    tjrq1: 'Date of submission',
    txdz1: 'Mailing address',
    wccs: 'Number of cars completed',
    wpmc: 'Item name',
    wpqd: 'List of items',
    wxts: 'Tips',
    xcdd1: 'Places of unloading',
    xgcg: 'Modified',
    xjcg: 'Created successfully',
    ysrq1: 'Date of transport',
    ysxx: 'Transport information',
    zcdd1: 'Places of loading',
    zyrq: 'Date of shipment',
    zyrqColon: 'Date of shipment:',
    jjyy1: 'Reasons for refusal',
    jjyy1Colon: 'Reasons for refusal:',
    tyf1: 'Consignor:',
    khx1: 'Bank of deposit:',
    crumbs02: 'Container',
    frl: 'Calorific value',
    gjz1: 'Frontier station',
    jwz: 'Overseas terminal',
    qhf: 'Consignee',
    qsr: 'Please enter',
    qxr: 'Please select',
    sctpjy6: ' files',
    tuoyf: 'Consignor',
    xqh: 'Demand number',
    yuyueh: 'Appointment number',
    anc: 'By car',
    anD: 'By ton',
    baozhuan: 'Packaging',
    beiz: 'Remarks',
    beizColon: 'Remarks:',
    caoz: 'Operation',
    chax: 'Query',
    congzhi: 'Reset',
    daochu: 'Export',
    daoz: 'Arrival station',
    faz: 'Departure station',
    guolian: 'League of Nations',
    jg: 'Price',
    jianshu: 'Quantity',
    liangshi: 'Food',
    qd: 'Confirmed',
    qink: 'Clear',
    quxiao: 'Cancel',
    sc: 'Delete',
    sl: 'Acceptance',
    tiji: 'Volume',
    tijiao: 'Submit',
    ts: 'Tips',
    xg: 'modify',
    xh: 'Serial number',
    xiazai: 'Download',
    xz1: 'Newly added',
    zhongliang: 'Weight',
    zt2: 'Status',
    sp: 'Approval',
    md: 'Boten',
    ty1: 'Agree',
    jj1: 'Rejected',
    chang: 'Open',
    collect: 'ReceInfo',
    goods: 'GoodsInfo',
    guan: 'Tank',
    peng: 'Shed',
    ping: 'Flat',
    to: 'To',
    w: 'None',
    y: 'Page',

    //
    tsqyby: 'Hint: Please report the NUJ waybill by the 19th of this month',
    lxdh_txdz: 'Contact number/mailing address',
    qsrfhrdh: 'Please input the phone number of consignor',
    qsrfhrdz: 'Please input the address of consignor',
    qsrkhhmc: 'Please input name of bank of deposit',
    qsrkhhzh: 'Please input name of bank of deposit account',
    dz_xcdd: 'Places of arrival/unloading',
    excelImp: 'Excel import',
    excelImpColon: 'Excel import:',
    fz_zcdd: 'Places of departure/loading',
    qsrjzsx: 'Please input the record',
    qsrlxdh: 'Please input the contact number',
    qsrtxdz: 'Please input the mailing address',
    qsrzcdd1: 'Please input registered address',
    qxzxqlx: 'Please select the demand type',
    qsrydd: 'Please enter your cell phone number',
    nsrsbh: 'Taxpayer identification number:',
    nsrsbh1: 'Taxpayer identification number:',
    qxzgjz: 'Please select frontier station',
    zzdjcl: 'Loading reinforcement materials',
    spfmc: 'Name of the receiver:',
    spfmc1: 'Name of the receiver:',
    dtbxx: 'Information to be submitted',
    qxzyf: 'Please select month',
    ysrq: 'Date of transport:',
    zdjzl: 'Maximum piece weight',
    // zdjzlColon:'最大件重量:(en)',
    zdjzlColon: 'Maximum piece weight (kg)',
    xqlx: 'Demand type:',
    tjrq: 'Submission date:',
    hwpm: 'Description of goods:',
    hwbz: 'Packaging:',
    jzsx: 'Record:',
    tbfs1: 'Mode of submission:',
    zcdd: 'Places of loading:',
    lxdh: 'Tel.:',
    txdz: 'Mailing address:',
    ddgj: 'Arrival country:',
    xcdd: 'Places of unloading:',
    fplx: 'Invoice type:',
    fplx1: 'Invoice type:',
    bxys: 'Insurance and transport',
    crumbs0: 'Transport service',
    ddgj1: 'Arrival country',
    gnbx: 'Domestic insurance',
    hwtz1: 'Goods characteristics',
    jsrq: 'End date',
    jzsx1: 'Record',
    ksrq: 'Start date',
    plsc: 'Delete in batch',
    ptfp: 'General invoice',
    qzrq: 'Start/End date',
    sltc: 'Accepted',
    tbcs: 'Number of vehicles submitted',
    tbds: 'Submitted tonnage',
    zyfp: 'Special invoice',
    gjz: 'Frontier station',
    shf: 'Consignee:',
    khx: 'Bank of deposit:',
    bps: 'Waterproof',
    ck: ' Export',
    dsl: 'To be accepted',
    sdz: 'Bulk storage',
    yjj: 'Rejected',
    zzs: 'Value-added tax',
    ds: 'Tonnage:',
    cz: 'Type of vehicle:',
    cs: 'Number of vehicles:',
    fz: 'Departure station:',
    fj: 'Dispatch company:',
    dz: 'Arrival station:',
    zh: 'Account No.:',
    dz1: 'Address:',
    dh: 'Telephone:',
    zh1: 'Account No.:',
    dh1: 'Tel.:',
    dz2: 'Address:',
    back: 'Return',
    bc: 'Save',
    canchu: 'Storage',
    ches: 'Number of vehicles',
    chesColon: 'Number of vehicles:',
    chez: 'Type of vehicle',
    chezColon: 'Type of vehicle:',
    chuk: 'Export',
    ds1: 'Tonnage',
    ds1Colon: 'Tonnage:',
    pashi: 'Keep dry',
    fa: 'DelivInfo',
    jie1: 'PhaseInfo',
    move: 'TransInfo',
    zen: 'VATInfo',

    //新增翻译
    fh: 'Delivery',
    sh: 'Receiving',
    myhwpm: 'Receiving',
    ch: 'China',
    //new页面
    tbr: 'Submitter',
    dbr: 'Submitter agent',
    shsj: 'Reviewed on',
    zcdz: 'Loading address',
    xcdz: 'Unloading address',
    ti: 'Submit',
    tbrxx: 'Submitter information',
    hwtzfhl: 'Goods characteristics: calorific value (kcal/kg):',
    tlhc: 'Railway freight yard',
    qxzblzb: 'Please select the handling type',
    xzxz1: 'It is currently limited to select 1 file.',
    xzxz2: 'You have selected   file(s) this time, and ',
    xzxz3: ' files',
    jdxqhw: 'The phase demand number is',
    qxzscnr: 'Please select the content to be deleted',
    scjg: 'This operation will delete the data permanently. Continue?',
    scsb: 'Failed to delete',
    yhxxcw: 'The user information is incorrect. Please check it before submitting.',
    qhdyhxx: 'Please import the historical demands after checking that the user information is correct.',
    zg: 'China',

    qsrysyf: 'input transportation month',
    qxzfkfs: 'Select payment method',
    qxzbz: 'Please select currency',
    qxzfkr: 'Select payer',
    qsrzjh: 'Input certificate No.',
    bxwzs: 'Must be an integer',
    bnw0: 'Cannot be 0',
    bncg9999: 'Cannot exceed 9999',
    bctip: ',please submit from "My Order" ASAP!',
    tjtip: 'Submitted successfully,Monthly demand No.:',
    tdtip: 'The number of cancels this month has reached/exceeded 5, and no new monthly demand is allowed!',
    xybtip: 'No further operation can be performed for this data!',
  },

  delivery: {
    sxtkyy: 'The above refund is refunded in cash/cheque on MM/DD.',
    xhsjy: 'Unloading time-MM-DD-HH arrival station charge bill No.',
    tzsjy: 'Notification time-MM-DD-HH consignee ID No.',
    yebzqq: 'Insufficient balance. Please recharge on the advance deposit management interface!',
    sxyfky: 'The above advance payment is credited on MM/DD.',
    ryxjzp: 'The above refund is refunded in cash/cheque on MM/DD.',
    gxqdhb: 'The order is not settled',
    yfkdyt: 'Advance payment credit (refund) voucher',
    lkdwkh: 'The payee opens an account to receive refund',
    sctpjy5: '  files selected this time,  in total ',
    lkdwkh1: 'Receiving unit to open an account to receive a refund',
    czjjhr: 'Signature and seal of the person receiving (delivering) the goods at the station',
    qzsxzy3: 'Please select at least one bill',
    qhlckm: 'Pick-up mileage (km)',
    gxqdhy: 'This order number has been delivered',
    qxzyjq: 'Please select the settled data',
    cyrqdzl: 'Carrier confirms weight',
    nsrsbh1: 'Taxpayer identification number:',
    qzxxzd: 'Please re-select the bill',
    khhjzh: 'Bank of deposit and account No.',
    zzdjcl: 'Loading reinforcement materials',
    crpzbh: 'Deposit voucher No.',
    crpzbhColon: 'Deposit voucher No.:',
    dyth: 'Offset (refund)',
    yfkstj: 'To be entered when prepayment is made',
    spfmc1: 'Name of the receiver:',
    jzxsfh: 'Container sealing No.',
    sxyfky2: 'The above advance payment is ',
    rrsdy: 'credited on MM/DD.',
    sfzhm: 'ID card No.',
    jey: 'Amount (yuan)',
    yfkdw: 'Prepayment Unit',
    skdwh: 'Receiving unit and',
    dyhth: 'Credit or refund',
    yxjzh: 'Bank and Account Number',
    lqpzr: 'Voucher recipient',
    cyrjs: 'Carrier Notes',
    tyrjs: 'Consignor note',
    czrqc: 'Station date stamp',
    shrqz: 'Signature and seal of consignee',
    bczf: 'Amount paid this time:',
    zffs: 'Payment method:',
    jfzt: 'Delivery status:',
    dybjd: 'Print supplementary payment bill',
    zhye: 'Account balance:',
    yjfxq: 'Payment details',
    fyje: 'Amount:',
    bjfxq: 'Supplementary payment details',
    sxtky: 'The above refund is ',
    bjys: 'Value-insured transport',
    ckxq: 'View details',
    crumbs01: 'Consignment note',
    czcg: 'Operation succeeded',
    czch: 'Type of vehicles and number of vehicles',
    fplx2: 'Please input invoice type',
    fymx: 'Details of costs',
    hwjg: 'Price of goods',
    hwmc: 'Item name',
    hwpm1: 'Description of goods',
    hzzf: 'Summary payments',
    jfrq: 'Delivery date',
    jfrqColon: 'Delivery date:',
    jsrq: 'End date',
    ksrq: 'Start date',
    lxdh1: 'Tel.',
    ptys: 'General transport',
    qhdd: 'Pick-up address',
    shdd: 'Delivery address',
    sltc: 'Accepted',
    smqh: 'Pick up from patron',
    smsh: 'Door-to-door delivery',
    smxc: 'Door-to-door unloading',
    smzc: 'Door-to-door loading',
    wxts: 'Tips',
    xqdh1: 'Demand order number',
    ysfs: 'Transport mode',
    yslx: 'Transport type',
    bjpz: 'Edit Voucher',
    lzgs: 'Lao Zhong Company',
    skdw1: 'Payee',
    skdw1Colon: 'Payee:',
    pjmc: 'Note Name',
    dx: '(capitalization)',
    bjzf: 'Retroactive payment of miscellaneous fees',
    fffs: 'Payment Method',
    lhfs: 'Collection method',
    zzlh: 'Paper pickup',
    dzlh: 'E-collection',
    ydqx: 'Arrival Period',
    fyhj: 'Total cost',
    jfzl: 'Billing weight',
    pjlx: 'Note Type',
    xxxl: 'Container type and category',
    sjhm: 'Mobile phone',
    xzfw: 'Select service',
    qtfw: 'Other services',
    zdrq: 'Prepared on',
    tyf1: 'Consignor:',
    shf: 'Consignee:',
    yyh: 'Appointment number:',
    bccg: 'Saved',
    jfz: 'In delivery:',
    jfsj: 'Delivery time',
    jfqr: 'Delivery confirmation',
    shlc: 'Delivery mileage',
    zfr: 'Payer:',
    crumbs02: 'Container',
    dsl: 'To be accepted',
    hph: 'Freight invoice number',
    jbr: 'Handled by',
    qhf: 'Consignee',
    qsr: 'Please input',
    rmb: 'RMB',
    sctpjy6: 'files',
    sfh: 'Sealing number',
    shouhr: 'Consignee',
    tuoyf: 'Consignor',
    tyr: 'Shipper',
    xqh: 'Demand number',
    ydd1: 'Arrived',
    ydh: 'Waybill number',
    yfc: 'Departed',
    yfk: 'Advance payment',
    yhk: 'Bank card',
    yjf: 'Delivered',
    yjj: 'Rejected',
    yxc: 'Unloaded',
    yzc: 'Loaded',
    zyx: 'Dedicated line',
    zzs: 'Value-added tax',
    pjh: 'Bill number',
    hgr: 'or individual',
    lkr: 'Payee',
    fkr: 'Payer',
    pbh1: 'Tarpaulin No.',
    ptp1: 'General invoice',
    zyp: 'Special invoice',
    hyy: 'Freight clerk',
    zdr: 'Prepared by',
    fy: 'Fee:',
    yck: 'Advance deposit',
    fz: 'Departure station:',
    dz: 'Arrival station:',
    dh1: 'Telephone:',
    djf: 'To be delivered',
    yjq: 'Settled',
    zj: 'Total:',
    yjf1: 'Paid',
    bjf: 'Supplementary payment',
    zcf: 'Loading party',
    sff: 'Sealing party',
    yjh: 'Freight No.',
    address: 'Address',
    back: 'Return',
    baozhuan: 'Packaging',
    bc: 'Save',
    beiz: 'Remarks',
    bz1: 'Indicated weight',
    canchu: 'Storage',
    chax: 'Query',
    daoz: 'Arrival station',
    dy: 'Printing',
    faz: 'Departure station',
    huoq: 'Goods area',
    huow: 'Freight section',
    jianshu: 'Quantity',
    jipu: 'KIP',
    khhzh: 'Account No.',
    my: 'USD',
    name: 'Description',
    qd: 'Confirmed',
    qink: 'Clear',
    tiji: 'Volume',
    xh3: 'Container No.',
    xianjin: 'Cash',
    yunf: 'Freight cost',
    zaf: 'Miscellaneous fees',
    zc: 'Carload',
    zhip: 'Check',
    zhongliang: 'Weight',
    zt2: 'Status',
    bh: 'Number',
    qh: 'Start number',
    zh2: 'Stop number',
    zs: 'Number of sheets',
    ke: 'Amount',
    dw: 'Unit',
    je: 'Amount',
    hj: 'Total',
    gs: 'Company',
    fm: 'Item',
    se: 'Tax amount',
    dx2: 'In words',
    qz1: 'Signature and seal',
    yt: 'Freight refund',
    zt3: 'Miscellaneous fee refund',
    jk1: 'Import',
    fc: 'Departure',
    ri: 'Day',
    t: 'Items',
    w: 'None',
    yuan: 'RMB',
    y1: 'Billion',
    q: 'Thousand',
    b: 'Hundred',
    s1: 'Ten',
    w1: 'Million',
    q1: 'Thousand',
    b1: 'Hundred',
    s2: 'Ten',
    j: 'Jiao',
    f: 'Fen',
    n: 'Year',
    y2: 'Month',
    sctpjy3: 'Size of file cannot exceed 20M',
    qxzfyj: 'Please select a non-settled waybill',
    gwjycz: 'File already exists',
    jfqrcg: 'Delivery confirmed',
    jfqrsb: 'Delivery confirmation failed',
    qxzyd: 'Please select the waybill',
    yd: 'Waybill:',
    //goodsOrder
    dwjfbz: 'has not yet been filled. Please fill in and submit!',
    zltlgf: 'China-Laos Railway Co., Ltd.',
    zyxmcd: 'Private siding name (code)',
    fkdwhx: 'Payment unit or personal name',
    jzxxx: 'Container box type',
    yyspj: 'Original shipping ticket',
    jzxhm: 'Container No.',
    qrcg: 'Confirmation successful!',
    blzb1: 'Category',
    hwzl: 'Item Weight',
    pmdm: 'Product Code',
    zprq: 'Ticket production date',
    zpr: 'Ticket maker',
    bjd: 'Supplementary payment bill',
    sbm: 'Identification code',
    dhw: 'The remark of the undelivered order number ',
    fb: 'Fee category',
    fl: 'Rates',
    fj1: 'Notes',
    dm: 'Code',
    //手动新增
    lcbw: 'Refrigeration (insulation)',
    qdyc: 'Sure to remove ',
    dqxzxz3: 'It is currently limited to select 3 files.You have selected XX file(s) this time',
    xqdh1Colon: 'Demand order number:',
    zyxmcdm: 'Private siding name (code)',
  },
  parrent: {
    qsrsjhm: 'Please input phone number',
    qxzjxxx: 'Please select container type',
    qsrhwms: 'Please input description of goods',
    qsryhm: 'Please input username',
    qyzyhm: 'Please verify the user name',
    qxzysrq: 'Please select date of transport',
    qxzhwpm: 'Please select the goods name',
    qsrcs: 'Please input number of vehicles',
    xqcsbnw0: 'The number of cars demanded cannot be 0',
    xqds0_99: 'Demand tonnage 0~9999999',
    xqdsbnw0: 'The number of cars demanded cannot be 0',
    xqdsbncg9999: 'Demand tonnage cannot exceed 9999',
    qsrtyf: 'Please input name of consignor',
    qxzfz: 'Please select departure station',
    qsrzcdd: 'Please input the place of loading',
    qsr2_400wzcdd: 'Please input 2-400 places of loading',
    qsrjbr: 'Please input handler',
    qsr15h18wsfzhm: 'Please input your 15- or 18-digit ID number',
    qsrshf: 'Please input consignee',
    qxzgjz: 'Please select frontier station',
    qxzdz: 'Please select arrival station',
    qsrxcdd: 'Please input the place of unloading',
    qsr2_400wxcdd: 'Please input 2-400 places of unloading',
    qsrdz: 'Please input the address',
    qsrmz: 'Please input name',
    qsrtyrqdjs: 'Please input the number of goods confirmed by the consignor',
    qsrqhfygs: 'Please input the estimated pick-up costs',
    qsrlc: 'Please input kilometrage',
    qsrds: 'Please input tonnage',
    dtblbzd: 'A maximum of 20 pieces of data can be saved in the list to be submitted. Please process the existing data before submitting',
    qnqdtbxxltj: 'Please submit it in the information to be submitted.',
    xgcg: 'Modified',
    xqdhw: 'The demand number is',
    xjcg: 'Created successfully',
    qd: 'Confirmed',
    qxdjyfss: 'Please click the freight trial calculation first',
    dqbzw: 'The current currency is',
    czcg: 'Operation succeeded！',
    wxts: 'Tips',
    qx: 'Cancel',
    ts: 'Tip',
    sfscckhxx: 'Delete this customer information or not',
    sccc: 'Deleted successfully!',
    yqxsc: 'Deletion cancelled',
    sfbdckhmc: 'Bind this customer name or not',
    bdcg: 'Binding succeeded',
    qxzycdsj: 'Please select the data to be removed',
    cczjyjscgwj: 'This operation will permanently delete the file. Are you sure you want to remove it?',
    yhxxbcz: 'User information does not exist',
    yhjs: 'User Role',
    js: 'Role',
    dqglydhw: 'The current national intermodal transport bill number is',
    qzsxzytsj: 'Please select at least one piece of data',
    sfscxzyd: 'Delete the selected waybill',
    qxztbnr: 'Please select the report content',
    tjkxydcg: 'Submission of empty container booking succeeded',
    tjtxydcg:'Waybill submission and filling succeeded',
    ydhw: 'The reservation number is',
    xxts: 'Information prompt',
    qrtjm: 'Are you sure to submit?',
    bcmbbxtxmbmc: 'Please fill in the template name to save the template',
    qxzybtxhdyd: 'Please select the waybill for which the supplementary container number has been provided',
    qrzfsxjlm: 'Are you sure to void the selected record?',
    zfcg: 'Voided successfully',
    zsxzytjl: 'Select at least one record',
    zdxz60tjl: 'Select up to 60 records',
    d: 'The',
    tzyrqbnwk: 'date of shipment in article X cannot be empty',
    ttcrxqfsbnwk: 'mode to propose a daily demand in article X cannot be empty',
    qxztcrxqfs: 'Please select the mode to propose a daily demand',
    tzdwgjz: ' arrival station in article X is a frontier station, please use phase demand!',
    qxzjdxq: 'Please select the phase demand',
    tjdxqhbkwk: ' phase demand number in article X cannot be empty',
    qxzjdxqh: 'Please select the phase demand number',
    qxzxt: "Please select the same type",
    drxqjxtj: 'Submit the daily demand of！',
    qxztyz: 'Please select the same type',
    xqtcfs: 'Mode to propose a demand',
    jxtj: 'Submit！',
    qxztyg: 'Please select the same one',
    tcbkwk: 'train number in article X cannot be empty!',
    qxzblcc: 'Please select the train number',
    dsjcssyrxq: 'actual number of vehicles of XXXX is less than the total number of vehicles in the selected daily demand submission! Please re-select the phase demand number',
    qdjxrxqtbm: 'Are you sure to submit the daily demand?',
    tcrxqcg: 'Daily demand proposed successfully',
    tcrxqsb: 'Failed to propose a daily demand',
    hgbgdwj: "Customs declaration documents",
    xghgbgd:'Modify customs declaration form',
    czsdbgwjsj:"Time when the station receives report documents",
    qxzzcdd: "Please select a loading location",
    qxzxcdd: 'Please select unloading location',
    dzbnyfzyz: 'The arrival station cannot be consistent with the departure station',
    zsytjythwxx: 'At least one piece of goods information shall be added',
    ycxdxsbndy120: 'The number of 20ft containers cannot be greater than 120',
    xsbndy60: 'The number of 40ft containers cannot be greater than 60',
    qxzfkxx: 'Please select payment information',
    qsrffhm: 'Please enter payment number',
    qxzbzxx: 'Please select currency information',
    cjxsxh: 'The container number cannot be empty for port station transit. Please fill in the container number.',
    qsryxqy: 'Please input the container user company',
    yxqyyw: 'The container user company is incorrect. There is no relevant container pick-up order number. Please re-input.',
    qxzxqtcfs: 'Please select the mode to propose a demand',
    hhwxxbwk: 'Goods information in line XX cannot be empty',
    zhwmc: 'The goods description, container number, container type, container category, container ownership and empty/loaded cannot be empty',
    zhwmckc: 'The goods description, container number, container type, container category, container ownership and empty/loaded, truck No. and driver information cannot be null',
    zy20yc: 'Single container waybill can be selected only for 20ft container type',
    bcmbbxtx: 'Please fill in the template name to save the template',
    txydbxyyxhsj: 'Container number data must be provided to fill in the waybill',
    gjzdz: 'Container number data must be provided at the frontier arrival station',
    gjzdzbxyxh: 'Container number data must be provided at the frontier arrival station',
    txzbnwk: 'Container pick-up station cannot be empty',
    qxztxrq: 'Please select container pick-up date',
    q5xyz: 'Please select the departure station, arrival station, cargo name, consignor, and consignee of the data. These 5 items should be consistent',
  },
  billTypesFile: {
    ptfp: 'General invoice',
    zyfp: 'Special invoice'
  },
  advancePayCustomer: {
    grmc: 'Individual name',
    qsrgrmc: 'Please enter individual name',
    yckje: 'Advance deposit amount (RMB)',

  },
  customer: {
    dzzh: 'Receipt account',
    skrxm: 'Payee name',
    ssyh: 'Associated bank',
    txyy: 'Withdrawal reason',
    jjyy: 'Reasons for refusal',
    sbyy: 'Failure cause',
    tg: 'adopt'
  },
  lp: {
    tpr: 'Claimant',
    hwsssl: 'Quantity of goods lost',
    tprq: 'Claim date',
    tpje: 'Claim amount',
    sjpcje: 'Actual compensation amount',
    ajh: 'File No',
    jlhm: 'Record No',
    bzrq: 'Preparation date',
    jlbzz: 'Record compilation station',
    hyjl: 'Freight Record',
    hwssfcs: 'Cargo Loss Inspection Reply',
    hwssdztzs: 'Notification of Liability Determination for Goods Loss',
    aj: 'file',
    fs: 'send out',
    hyjlh: 'Freight record No',
    dzrq: 'Deadline',
    zsz: 'Main delivery station',
    bzz: 'Compilation station',
    dsgs: 'Loss fixing company',
    z: 'station',
    tbr: 'Preparer',
    tzh: 'Notice No',
    clz: 'Processing station',
    sgdw: 'Acquisition unit',
    yjrq: 'Handover date',
    lcsj: 'Train time',
    fgs: 'Issuing company',
    dgs: 'To the company',
    djcz: 'Check in station',
    djrq: 'Registration date',
    zt: 'China Railway',
    lt: 'Laos Railway'
  },
  register: {
    md: 'Boten',
    nd: 'Na Teuy',
    lblb: 'Luang Prabang',
    wxn: 'Vientiane South',

    qyxx: 'Company information',
    qyzcmc: 'Registered name of enterprise',
    wljlqyda: 'In order to establish enterprise file and display enterprise on the trading platform, please enter the detailed enterprise profile.',
    xyb: 'Next',
    qy: 'Enterprise',
    gr: 'Individual',

    scsfz: 'Upload ID card',
    tjrmx: 'Add face picture',
    tjfrmx: 'Add non-face picture',
    dlmm: 'Login password',
    wsqyxxh: 'After completing the enterprise information, you may enjoy the following services:',
    gdxwzx: 'More news',
    tbysxq: 'Submit transport demand',
    ydyszy: 'Book transport resources',
    hwqcgz: 'Whole-process goods tracking',
    bjgt: 'Convenient communication and high-quality service',
    yhxx: 'User information',
    gly: 'Administrator',
    zhcy: 'Comprehensive enterprise',
    cmqy: 'Coal production enterprise',
    hmqy: 'Coal consuming enterprise',
    xjqyxx: 'New enterprise information',

    yhzc: 'User Registration',
    zcwtgxg: 'Registration not approved information modification',
    gryh: 'Individual users',
    qyyh: 'Enterprise users',
    zcshwtg: 'Registration review failed',
    ljxg: 'Modify Now',
    ckshwtgyy: 'View reasons for failed review',
    txqyjbxx: 'Fill in the basic information of the enterprise',
    sczjzl: 'Upload identification documents',
    txjbrxx: 'Fill in the information of the handling person',
    xzfwcz: 'Select service station',
    hz: 'Goods owner',
    hd: 'forwarder',
    frzjlx: 'Legal representative identification type',
    sfz: 'ID card',
    huzhao: 'passport',
    djsc: 'Click to upload',
    clsm: 'Material description',
    zjlx: 'ID type',
    fsyzm: 'Send verification code',
    fwcz: 'Service Station',
    fwcztext: 'Please select service station. After the online review is completed, bring relevant documents to the station for offline confirmation and review.',
    tj: 'Submit',
    txgrjbxx: 'Fill in personal basic information',
    cksl: 'View examples',
    zcxxtjcg: 'Submission of registration information succeeded',
    zcjg1: 'The online review results will be sent via SMS/e-mail within 48 hours to',
    zcjg2: 'Mobile phone/e-mail, please check!',
    zcsj: 'Registered mobile phone number',
    jbr: 'Handled by',
    qd: 'determine',
    apptext: 'Freight Comprehensive Service APP',
    apptext1: 'To enhance your experience in handling freight business, please scan the QR code above and download the Freight Comprehensive Service APP',
    qyxxxg: 'Enterprise information modification',
    jbrsjh: 'Operator\'s mobile phone number',
    zcmm: 'Registration password',
    yzm: 'Code',
    grxxxg: 'Personal registration information modification',
    khfwxy: 'Customer service agreement',
    ji: 'and',
    ysqzc: 'Privacy policy',
    sltp: 'Sample photo',
    qxzyxgdyhlx: 'Please select the user type you want to modify',
    qtxqymc: 'Please fill in the company name',
    qtxtyshxydm: 'Please fill in the unified social credit code',
    qtxqyyyzzhm: 'Please fill in the enterprise business license number',
    qtxzczj: 'Please fill in the registered capital',
    qxzzczjbz: 'Please select the currency of the registered capital',
    qxzsshy: 'Please select your industry',
    qxzjjxz: 'Please select economic nature',
    qtxjjxzms: 'Please provide a description of the economic nature',
    qxzqyxz: 'Please select the nature of the enterprise',
    qxzjglx: 'Please select the type of institution',
    qtxjyfw: 'Please fill in the business scope',
    qtxfddbr: 'Please fill in the legal representative',
    qxzfrzjlx: 'Please select the type of legal representative\'s identification document',
    qxzfrgj: 'Please select the nationality of the legal entity',
    qtxfrsfzhm: 'Please fill in the ID card number of the legal person',
    qxzfrsfzyxq: 'Please select the validity period of the legal representative\'s ID card',
    qtxfrhzhm: 'Please fill in the legal representative\'s passport number',
    qxzfrhzyxq: 'Please select the validity period of the legal representative\'s passport',
    sshy1: 'agriculture, forestry, animal husbandry and fishery',
    sshy2: 'mining',
    sshy3: 'manufacturing industry',
    sshy4: 'Production and supply of electricity, gas, and water',
    sshy5: 'construction',
    sshy6: 'transportation, storage and postal services',
    sshy7: 'Information transmission, computer services, and software industry',
    sshy8: 'wholesale and retail',
    sshy9: 'Accommodation and catering',
    sshy10: 'Financial',
    sshy11: 'Real estate',
    sshy12: 'Rental and business service',
    sshy13: 'Scientific research, technical services, and geological exploration ',
    sshy14: 'Water conservancy, environment, and public facility management',
    sshy15: 'Resident and other services',
    sshy16: 'Education',
    sshy17: 'Health care, social insurance and public welfare',
    sshy18: 'Culture, sports and entertainment',
    jjxz1: 'Private enterprise',
    jjxz2: 'State-owned enterprise',
    jjxz3: 'Mixed-ownership enterprise',
    jjxz4: 'Collective enterprise',
    jjxz5: 'Other',
    jjlx1: 'Incorporated enterprise',
    jjlx2: 'Unincorporated enterprise',
    jjlx3: 'Incorporated public institution',
    jjlx4: 'Unincorporated public institution',
    jjlx5: 'Incorporated association',
    jjlx6: 'Unincorporated association',
    jjlx7: 'Incorporated government units',
    jjlx8: 'Unincorporated government units',
    jjlx9: 'Individual',
    jjlx10: 'Incorporated labor union',
    jjlx11: 'Private non-enterprise organization',
    jjlx12: 'Other types',
    qscyyzz: 'Please upload business license',
    qscwtzm: 'Please upload letter of authorization',
    qxzyzzzyxq: 'Select validity period of business license',
    qscfrsfzzmzp: "Upload the photo of the legal person\'s ID card",
    qscfrsfzbmzp: "Please upload the photo of the back of the legal person's ID card",
    qscfrscsfzzp: 'Upload the photo of the legal person holding the ID card',
    qscfrhzxxyzp: 'Upload the photo of the information page of the legal person\'s passport',
    qscfrschzxxyzp: 'Upload the photo of the legal person holding the passport information page',
    qxzymzzzmyxq: 'Select validity period of the coal transportation certificate',
    qxztdzzwsyxq: 'select validity period of the alternative planting certificate',
    qxztksydzmyxq: 'Select validity period of the iron ore movement certificate',
    qxjzxxxyxq: 'Please select the validity period of the container agreement',
    qxzscclyxq: 'Select validity period of uploaded materials',
    qtxscclms: 'Fill in the description of uploaded materials',
    qtxxm: 'Fill in name',
    qxzgj: 'Select nationality',
    qxzzjlx: 'Select certificate type',
    qtxsfzhm: 'Please fill in the ID card number',
    qxzsfzyxq: 'Please select validity period of ID card',
    qtxhzhm: 'Please fill in your passport number',
    qxzhzyxq: 'Please select validity period of your passport',
    qtxdlmm: 'Please fill in the login password',
    qtxqrmm: 'Please fill in the confirm password',
    lcsrdmmbyz: 'Passwords input are inconsistent',
    qxzdhgjqh: 'Please select international dialing code',
    qsrsjh: 'Enter mobile phone number',
    sjhyzc: 'The mobile phone number has been registered',
    qsryzm: 'Please enter the verification code',
    qscsfzzmzp: 'Please upload the front view of the ID card',
    qscgrscsfzzmzp: 'Please upload the front view of the individual with ID card in hand',
    qschzxxyzp: 'Please upload the photo of passport information page',
    qscgrschzxxyzp: 'Please upload the photo of the individual holding the passport information page in hand',
    qxzfwcz: 'Please select service station',
    qtxzcmm: 'Please enter the registration password',
    tis0: 'No registration information is found for the account, check the information filled in again.',
    tis1: 'The uploaded pictures can only be in JPG, JPEG, BMP and PNG formats',
    tis3: 'The uploaded pictures can only be in JPG、JPEG、BMP、PNG、DOC/DOCX、TXT、PDF formats!',
    tis2: 'The size of the uploaded picture shall not exceed 5MB',
    frdbsfzzmzp: 'Front view of the legal person\'s ID card',
    frdbsfzbmzp: 'Photo of the back of the legal representative’s ID card',
    frdbscsfzzm: 'Front view of the legal person with the ID card in hand',
    frdbhzzp: 'Photo of the information page of the legal person\'s passport',
    frdbschzzp: 'Photo of the legal person with the passport information page in hand',
    text1: 'Welcome to register!',
    text2: 'Please select the user type to be registered',
    text3: 'Registration',
    text4: 'Enterprise',
    text5: 'That person',
    text6: 'Go to register',
    yzx: 'Informed already',
    ycxzdtj5wj: 'Up to 5 files can be added one time',
    cksltip1: 'Please upload a photo or a scanned photo of the original and ensure it is clearly visible',
    cksltip2: 'Download and print the template for letter of authorization, affix the official seal of the enterprise, then scan or take a photo of the letter and upload it',
    sfjbr: 'Handler or not',
    zccghts: 'After successful registration, the handler is responsible for managing enterprise information, applying for and reviewing the service agent, and adding other handlers.',
  },
  jkck: {
    jjsj: 'Handover date',
    gd: 'Track',
    hybx: 'Freight insurance',
    hccljjd: 'Freight vehicle handover list',
    cxdh: 'Inquiry No.',
    be: 'Insured amount',
    bf: 'Insurance premium',
    zc: 'Normal',
  },
  reg: {
    qsrqymc: 'Please enter 2-50 digit enterprise name',
    qxzshj: 'Please select review bureau',
    qydz: 'Please enter 4-100 digit enterprise address',
    qylx: 'Please check enterprise type',
    qyjj: 'Please enter enterprise profile',
    qsrzqsz: 'Please enter correct 1-20 digit number',
    qsrmc: 'Please enter 4-50 digit name',
    qsrljdz: 'Please enter 1-50 digit link address',
    qsrqydh: 'Please enter enterprise phone number',
    qsryx: 'Please enter correct email address ending with com or com.cn',
    qsrzh: 'Please enter 2-20 digit pure letter or pure number or combination of number and letter',
    qxzssqy: 'Please select enterprise',
    qxzyhjs: 'Please select user role',
    qsrxm: 'Please enter 2-20 digit name',
    qxzjglx: 'Please select organization type',
    qzcsrmm: 'Please enter password again',
    qscyyzz: 'Please upload  business license',
    qscjg: 'Please upload organization code certificate',
    qscsw: 'Please upload tax registration certificate',
    qsclogo: 'Please upload enterprise LOGO',
    qsctp: 'Please upload picture smaller than 2M',
  },
  header: {
    xxzx: 'Information center',
    yjjc: 'Early warning and decision making',
    ngxt: 'Internal management system',
    czsc: 'Operating manual',
    sz: 'Setting',
    tc: 'Log out',
    zc: 'Registration',
  },
  consultation: {
    chengshi: 'City',
    zm: 'Station name',
    czjj: 'Station introduction',
    yyzdz: 'Business station',
    slfwdh: 'Acceptance service phone number',
    bllbmc: 'Name of handling category',
    jij1: 'Basic price 1',
    jij2: 'Basic price 2',
    bz: 'Standard ',
    hwzxjzfl1: 'Base rate of cargo loading and unloading charge (RMB/t)',
    czzxfl: 'Rate of station loading and unloading charge',
    smzxfl: 'Rate of door-to-door loading and unloading charge',
    bjfl: 'Premium rate% ',
    xh: 'Serial number',
    sfbz: 'Charging standards',
    sfxm: 'Charging items',
    sfyj: 'Basis for charging',
    czcx: 'Model/type of car: ',
    qxzczcx: 'Please select the car type and model',
    zz: 'Dead weight(t): ',
    qtxzz: 'Please enter the tare weight',
    zaiz: 'Loading capacity(t):',
    qtxzaiz: 'Please enter the load (EN)',
    czdm: 'Car type code',
    zs: 'Number of axles',
    syyxsd: 'Commercial operation speed(km/h) (EN)',
    yxrj: 'Effective volume(m³) (EN)',
    clzdkg: 'Vehicle maximum (width × height)(mm) (EN)',
    cnckg: 'Interior (L×W×H)(mm)',
    ctcz: 'Carbody material'
  },
  trackStateQuery: {
    wlgs_wpdMsg: 'The pickup & delivery order is undispatched. Dispatch first before printing container pickup order!',
    wpdMsg: 'No order dispatched by logistics company. Please contact them first!',
    dqwz: 'current position',
    track: 'Nationwide railway tracking',
    blztcx: 'Handling status query',
    qsr: 'Please input',
    qxz: '==Please select==',
    xqh: 'Demand number',
    qsrxqh: 'Please input demand number',
    zcrq: 'Loading date',
    ksrq: 'Start date',
    zhi: 'To',
    jsrq: 'End date',
    hwmc: 'Item name',
    qsrhwmc: 'Please input name of goods',
    tyr: 'Shipper',
    fz: 'Departure station',
    zcdd: 'Places of loading',
    zyx: 'Dedicated line',
    tlhc: 'Railway freight yard',
    shr: 'Consignee',
    dz: 'Arrival station',
    xcdd: 'Places of unloading',
    ch: 'Train No.',
    xh: 'Serial number',
    fkfs: 'Payment method',
    yck: 'Advance deposit',
    xj: 'Cash',
    zhip: 'Check',
    yhk: 'Bank card',
    hzzf: 'Summary payments',
    ydh: 'Waybill number',
    zdsj: 'Note preparation time',
    kssj: 'Start time',
    jssj: 'End time',
    ydlx: 'Type of waybill',
    gjly: 'International through traffic',
    ptys: 'General transport',
    zfzt: 'Payment status',
    dzf: 'To be paid',
    yzhif: 'Paid',
    zfz: 'Paying',
    yjs: 'Settlement has been completed',
    ydzt: 'Waybill status',
    dsl: 'To be accepted',
    dddsl: 'To be dispatched',
    sltg: 'Accepted',
    slwtg: 'Acceptance failed',
    yzc: 'Loaded',
    yzd: 'The note has been prepared',
    yfc: 'Departed',
    ydd: 'Arrived',
    yxc: 'Unloaded',
    hwyjf: 'Cargo delivery has been completed',
    yzuof: 'Cancelled',
    chax: 'Query',
    qingk: 'Clear',
    syrxqcx: 'Use daily demand inquiry',
    zhank: 'Unfold',
    shouq: 'Retract',
    zj: 'Total',
    t: 'Items',
    ckxq: 'View details',
    ybg: 'Changed',
    chak: 'View',
    bgdz: 'Change of destination station',
    pldy: 'Print in batches',
    daochu: 'Export',
    yyh: 'Appointment number',
    ddmlh: 'Dispatching order No.',
    bgyqr: 'Change demander',
    xshr: 'New consignee',
    xdaoz: 'New arrival station',
    bgyy: 'Reason for change',
    sctp: 'Upload picture',
    qd: 'Confirmed',
    zdsctp3: 'Upload up to three pictures',
    ydxx: 'Waybill information',
    bllb: 'Handling type',
    yslx: 'Transport type',
    fhxx: 'Delivery information',
    tuoyf: 'Consignor',
    txdz: 'Mailing address',
    dianh: 'Tel.',
    fj: 'Dispatch company',
    rxsjz: 'Track-in time (loading)',
    kzsj: 'Loading time ',
    zwsj: 'Time for completing loading',
    cxsjz: 'Track-out time (loading)',
    shxx: 'Receipt information',
    shouhf: 'Consignee',
    daoj: 'Arrival Local Group Company',
    rxsjx: 'Track-in time (unloading)',
    kxsj: 'Unloading time',
    xwsj: 'ເວລາການຂົນສິນຄ້າລົງສຳເລັດ',
    cxsjx: 'Track-out time (unloading)',
    jfsjx: 'Delivery time (unloading)',
    hwxx: 'Goods information',
    hwjs: 'Number of freight items',
    hwtz: 'Goods characteristics',
    sfh: 'Sealing number',
    pbh: 'Tarpaulin number',
    hwms: 'Description of goods',
    ysxx: 'Transport information',
    chez: 'Type of vehicle',
    chengz: 'Group',
    dzbg: 'Electronic change',
    jzsx: 'Record',
    bx: 'Insurance',
    zffs: 'Payment method',
    bz: 'Currency',
    dzzfyhfzf: 'Who will pay the arrival miscellaneous fees',
    back: 'Return',
    zt: 'Status',
    ytb: 'Submitted',
    dccg: 'Car booking succeeded',
    dcwcg: 'Car booking failed',
    qcfs: 'Car request method',
    crxq: 'Next-day demand',
    bcxq: 'Supplementary demand',
    yunf: 'Freight cost',
    fksj: 'Payment time',
    fccc: 'Departure train No.',
    fcsj: 'Departure time',
    dzsj: 'Arrival time',
    jfsj: 'Delivery time',
    ddmlm: 'Dispatching command code',
    cyrqdzl: 'Carrier confirms weight (kg)',
    cyjs: 'Number of items accepted for transport',
    slh: 'Acceptance No.',
    hwpl: 'Cargo category',
    xqcs: 'Demand number of vehicles',
    xqds: 'Demand tonnage',
    dccgs: 'Number of cars successfully booked',
    dccgds: 'Tonnage of cars successfully booked',
    wccs: 'Number of cars completed',
    ystz: 'Transportation characteristics',
    tbsj: 'Reporting time',
    tbqy: 'Submission enterprise',
    quanx: 'Select all',
    zhanwusj: 'No data available',
    caoz: 'Operation',
    qxzyd: 'Please select the waybill',
  },
  trackGlyd: {
    ytblb:"Submitted list",
    wdyxq:"My monthly demand",
    // fzdm:"发站代码(en)",
    // ddldm:"到达路代码(en)",
    // dzdm:"到站代码(en)",
    // cyrjc:"承运人简称(en)",
    // ffdm:"付费代码(en)",
    // zfrmc:"支付人名称(en)",
    // jianc:"简称(en)",
    // qidian:"起点(en)",
    // zhongdian:"终点(en)",
    // daima:"代码(en)",
    // wjlx:"文件类型(en)",
    // fenshu:"份数(en)",
    // wwmc:"外文名称(en)",
    // wjhm:"文件号码(en)",
    // bzrq:"编制日期(en)",
    // djyshtdrq:"缔结运输合同的日期(en)",
    glhwzz: 'International through freight tracking',
    ckyd: 'Export waybill',
    jkyd: 'Import waybill',
    chax: 'Query',
    qingk: 'Clear',
    zhank: 'Unfold',
    shouq: 'Retract',
    ckgj: 'View the trajectory',
    hwgj: 'Cargo trajectory',
    hwjz: 'Goods entering the station',
    zche: 'Loading',
    fche: 'Departure',
    zait: 'In transit',
    dz: 'Arrival station',
    xche: 'Unloading',
    xqh: 'Demand number',
    fz: 'Departure station',
    tuoyf: 'Consignor',
    ch: 'Train No.',
    ydh: 'Waybill number',
    shouhf: 'Consignee',
    hwmc: 'Item name',
    chuj: 'Exit',
    yjddsj: 'Estimated arrival time',
    yjsylc: 'Estimated remaining mileage',
    back: 'Return',
    pjlx: 'Note Type',
    dzpj: 'Electronic document',
    dzhp: 'Electronic freight receipt',
    dzyzf: 'Electronic bill of freight and miscellaneous fee',
    glyd: 'International through rail waybill',
    ydhbcz: 'Waybill No. does not exist',
    qb: 'All',
    dy1: 'First copy',
    dy2: 'Second copy',
    dy3: 'Third copy',
    dy4: 'Fourth copy',
    dy5: 'Fifth copy',
    dy6: 'Sixth copy',
    dy7: 'Seventh copy',
    dy: 'Printing',
    zprq: 'Ticket production date',
    ksrq: 'Start date',
    zhi: 'To',
    jsrq: 'End date',
    gjz: 'Frontier station',
    bllx: 'Train type',
    qsr: 'Please input',
    qxz: '==Please select==',
    zhengc: 'Carload',
    jzx: 'Container',
    xh: 'Serial number',
    mdj: 'Boten (border)',
    qxzzprq: 'Please select the date of bill printing',
    qxzgjz: 'Please enter the frontier station',
    xh1: 'Container No.:',
    xx: 'Container model:',
    xl: 'Container type:',
    ziz: 'Dead weight:',
    yyh: 'Appointment number',
    xqdh: 'Demand doc No',
    tbrq: 'Date of submission',
    ph: 'Batch No.',
    ydzt: 'Waybill status',
    dsl: 'To be accepted',
    dddsl: 'To be dispatched',
    sltg: 'Accepted',
    slwtg: 'Acceptance failed',
    yzc: 'Loaded',
    yzp: 'Ticket printed',
    zjf: 'Delivered',
    yzd: 'Waybill prepared',
    yfc: 'Departed',
    ydd: 'Arrived',
    yddkaz: 'Arrived at the port station',
    ycj: 'Departed',
    mdrj: 'Entry via Boten',
    yxc: 'Unloaded',
    hwyjf: 'Cargo delivery has been completed',
    yzuof: 'Cancelled',
    bllb: 'Handling type',
    fhr: 'Consignor',
    daoj: 'Arrival Local Group Company',
    tbqy: 'Submission enterprise',
    jzxxx: 'Container information',
    slbtgyy: 'Reason for acceptance failure',
    hggj: 'Customs transit',
    kadl: 'Port agents',
    jianshu: 'Quantity',
    hwzl: 'Item Weight',
    hth: 'Contract No.',
    tyfjs: 'Consignor notes',
    xcdd: 'Places of unloading',
    lxfs: 'Contact',
    md: 'Boten',

    yrj: 'Entry already',
    fzw: 'Departure station:',
    ccw: 'Train number:',
    hwjg: 'Passage of cargo',
    dzw: 'Arrival station:',
    xqdhbcz: 'The demand list No. does not exist',
  },
  trackGoods: {
    hwddyc: 'Forecast of cargo arrival',
    fdlx: 'Departure and arrival type',
    fh: 'Delivery',
    shouh: 'Receiving',
    dz: 'Arrival station',
    shouhf: 'Consignee',
    xcdd: 'Places of unloading',
    ydsj: 'Estimated arrival time',
    hwmc: 'Item name',
    chez: 'Type of vehicle',
    ksrq: 'Start date',
    qsr: 'Please input',
    qxz: '==Please select==',
    zyx: 'Dedicated line',
    tlhc: 'Railway freight yard',
    guanc: 'Tank car',
    pengc: 'Box car',
    changc: 'Gondola car',
    pingc: 'Flat car',
    lengcc: 'Refrigerator car',
    jzxc: 'Container car',
    kuangsc: 'Ore car',
    changhdwc: 'Oversized commodity car',
    dupc: 'Poisonous goods wagon',
    jiacc: 'Stock car',
    sanzlsc: 'Bulk grain car',
    tezc: 'Special car',
    qit: 'Others',
    qsrdz: 'Please input the arrival station',
    qsrshf: 'Please input consignee',
    fz: 'Departure station',
    tuoyf: 'Consignor',
    zcdd: 'Places of loading',
    qsrfz: 'Please input departure station',
    qsrfhf: 'Please enter the consigner ',
    hwpl: 'Cargo category',
    ches: 'Number of vehicles',
    hwyjddqk1: 'Station',
    hwyjddqk: 'Estimated cargo arrival at the station',
    nengy: 'Energy',
    kuangs: 'Ore',
    gcqx: 'Steel and equipment',
    jzx: 'Container',
    lsnf: 'Grain and agricultural and sideline products',
    shyp: 'Daily necessities',
    qthzhw: 'Other mixed goods',
    chax: 'Query',
    qingk: 'Clear',
    zhank: 'Unfold',
    shouq: 'Retract',
    ckdt: 'View map',
  },
  myMessage: {
    xxxq: 'Information details',
    qbxx: 'All messages',
    ysfw: 'Transport service',
    daib: 'To be handled',
    qb: 'All',
    yd: 'Read',
    wd: 'Unread',
    back: 'Return',
    title: 'Title',
    sous: 'Search',
    plyd: 'Batch read',
    plsc: 'Delete in batch',
    sj: 'Time',
    lx: 'Type',
    title1: 'This operation will delete the data permanently. Continue?',
    title2: 'Information prompt',
    yes: 'Yes',
    no: 'No',
    yqxsc: 'Deletion cancelled',
    czcg: 'Operation succeeded',
    sccg: 'Deleted',
  },
  jzxwork: {
    qscwj:"Please upload the file",
    dqscxz:"Uploading maximum limit: 10 files",
    cftpsc:"Duplicate image upload",
    qsczdgs: "Please upload photos in .jpg, .bmp, .jpeg, .png and other image formats",
    dytxd: "Print the container pick-up list",
    txd: "Pick-up list",
    tip61: 'Arrival date',
    gdmc: 'Track',
    tip380: 'Please input the track name',
    tip37: 'All cars',
    swh: 'Sequence number',
    czch: 'Train type/No.',
    tip492: 'Demand order No. 1',
    tip493: 'Demand order No. 2',
    tip494: 'Demand order No.3',
    tip431: 'Train No./train',
    ddsj: 'Arrival time',
    xh3: 'Container No.3',
    tip343: 'Loading plan',
    rxsj: 'On-track time',
    xzrxsj: 'Select on-track time',
    xzkzsj: 'Select loading time',
    xzzwsj: 'Select the loading completion time',
    rxbnzydd: 'On-track time cannot be earlier than arrival time',
    kzbnzyrx: 'Loading start time cannot be earlier than On-track time',
    zwbnzykz: 'The loading completion time cannot be earlier than the loading start time',
    rxsjbnwk: 'On-track time cannot be empty',
    kzsjbnwk: 'Loading start time cannot be empty',
    zwsjbnwk: 'Loading completion time cannot be empty',
    qxzgd: 'Please select the track',
    qdtjgxx: 'Submit the information?',
    tip163: 'Submission succeeded. Please perform "off-track confirmation" in time',
    tip5: 'The plan data of loaded goods cannot be submitted repeatedly!!!',
    tip544: 'Delivery application approved',
    tip545: 'Delivery application not approved',
    tip200: 'Data not selected!',
    tip272: 'Container information missing!',
    tip351: 'Please do not select unapproved demand list!',
    qbyxcfxh: 'Please do not select repeated container number!',
    tip378: 'Please input the container number 1!',
    tip211: 'The remaining space of this vehicle is insufficient to load this container!',
    tip209: 'This container arrives at [',
    tip2: '] is inconsistent with the arrival station for container 1!',
    tip210: 'This container number is the same as container 1!',
    tip212: 'Insufficient space left!',
    qxzzsyt: 'Please select at least one record',
    tip4: 'Unsubmitted data irrevocable!!!',
    qdcxm: 'Cancel?',
    yqxcx: 'Revocation cancelled',
    tip489: 'Loading plan of container',
    tip486: 'Unloading plan of container',
    tip416: 'Dispatch-in date',
    tip501: 'Pre-receiving',
    ydh: 'Waybill number',
    tip155: 'Carrying weight',
    tip398: 'Please select the start time',
    tip410: 'Please select the end time',
    cxsj: 'Off-track time',
    tip395: 'Please select off-track time',
    tip17: 'Operation category',
    tip308: 'Category 1',
    tip393: 'Please select operation category',
    tip14: 'Operation mode',
    tip186: 'Method 1',
    tip392: 'Please select operation mode',
    tip328: 'Loader',
    tip381: 'Please input the loader',
    tip230: 'Loading and unloading supervisor',
    tip231: 'Loading and unloading supervisor cannot be empty',
    tip375: 'Please input the loading and unloading supervisor',
    tip331: 'Loading and unloading team',
    tip332: 'Loading and unloading team cannot be empty',
    tip383: 'Please input the loading and unloading team',
    tip66: 'Unloading',
    tip127: 'The start time cannot be earlier than the on-track time',
    tip314: 'End time cannot be earlier than start time',
    tip46: 'Off-track time cannot be earlier than the end time',
    tip63: 'Arrival time cannot be empty',
    tip126: 'Start time cannot be empty',
    tip313: 'End time cannot be empty',
    tip45: 'Off-track time cannot be empty',
    tip329: 'Loader cannot be empty',
    tip405: 'Please select a container space!',
    tip240: 'Unload?',
    tip48: 'Off-track status',
    tip498: 'Sequence',
    xzcxsj: 'Select off-track time',
    lx: 'Type',
    tip10: 'Quantity',
    tip44: 'Off-track time cannot be earlier than the loading completion time',
    tip239: 'Confirm the off-track?',
    tip115: 'Operation cancelled',
    tip113: 'Off-track data cannot be submitted repeatedly! ! !',
    tip49: 'Off-track confirmation',
    tip82: 'Pick up ticket',
    tip568: 'On-track',
    tip569: 'Off-track',
    tip318: 'Track information',
    ch: 'Train No.',
    tip502: 'Pre-receiving mark',
    tip438: 'Waybill number 3',
    tip427: 'Model/type/No.',
    tip418: 'Goods weight',
    tip35: 'On-track confirmation',
    tip197: 'Loading and unloading list not matched',
    tip140: 'Selected container number is repeated',
    tip56: 'Arrival and departure station',
    tip396: 'Please select arrival/departure',
    tip104: 'Departure at originating station',
    tip310: 'Destination',
    tip467: 'Notification for vehicle pick-up',
    wtz: 'Not notified',
    ytz: 'Notified',
    tip468: 'Notification of pick-up status',
    tip522: 'Station',
    tip327: 'Loading/unloading time',
    tip413: 'Please select the record to be notified',
    tip354: 'Please select arrival/departure',
    tip214: 'List',
    tip121: 'Already notified, no need to repeat!',
    tip134: 'Current container',
    tip348: 'The record lacks the list number, and the vehicle cannot be picked up!',
    tip470: 'Notification succeeded',
    tip135: 'The current record has been notified to pick up the vehicle, and no need to repeat!',
    tip136: 'The current record lacks the list number, and the pick-up operation cannot be performed!',
    tip469: 'Notification failed',
    lhrq: 'Collection date ',
    jssj: 'End time',
    dxtzbz: 'SMS notification mark',
    cz: 'Reset',
    lhid: 'Freight collection ID',
    xxdh: 'Demand order number',
    shjbr: 'Receiving agent',
    shjbrdh: 'Telephone number of receiving agent',
    fhjbr: 'Delivery agent',
    fhjbrdh: 'Telephone number of delivery agent',
    tznr: 'Notification content',
    tzfs: 'Notification method',
    lhdh: 'Collection phone number ',
    xcsj: 'Unloading time',
    zsxzytjl: 'Select at least one record',
    qxzwtzsj: 'Please select unnotified data for submission',
    ts: 'Tips',
    czcg: 'Operation succeeded',
    jflx: 'Delivery type',
    xsxh: 'Container ownership number',
    txfs: 'Unstuffing method',
    sfhm: 'Sealing No.',
    pszt: 'Damage status',
    qxztxdd: 'Please select unstuffing location!',
    qxzwjf: 'Please select undelivered records',
    hyid: 'Freight ID',
    yudh: 'Reservation No.',
    ydxs: 'Number of containers booked',
    hsxs: 'Number of containers verified',
    pxs: 'Quantity of container allocated',
    tdxs: 'Number of unordered containers',
    ytxs: 'Number of containers picked up',
    apkx: 'Arrange empty containers',
    pxsj: 'Allocation time',
    lkzr: 'Responsibility of empty container',
    lkyy: 'Reason of empty container',
    tx: 'Container return',
    hx: 'Container change',
    zxdd: 'Place of packing',
    tuid: 'Reservation cancellation',
    khtxhx: 'Customer container pick up-change',
    khtxtx: 'Customer container pick-up-return',
    ddh: 'Order No.',
    jzsj: 'Arrival time',
    yxxx: 'Original container information',
    xxxx: 'New container information',
    qdtjtxd: 'Submit the pick-up list information?',
    xzxhyw: 'The selected container number is incorrect, please select again',
    xzxhbcz: 'The selected container number does not exist, please select again',
    xhbncf: 'Container number cannot be repeated',
    xtdxsbx: 'The number of unordered 20-foot containers must be even',
    xtdxsbx1: 'The 20ft container type quantity must be an even number',
    qdtdcz: 'Confirm unsubscription?',
    qdtxm: 'Confirm return of container?',
    xxhbncf: 'The new container number cannot be the same as that of the original container',
    qdhxm: 'Confirm change of container?',
    qsrxqdh: 'Please input the demand order number',
    cyrzl: 'Weight ascertained by the carrier (kg)',
    tyrzl: 'Weight ascertained by the consignor (kg)',
    qsrxhzz: 'Please input the total weight of container load',
    qsrtyrzl: 'Please input consignor weight',
    qsrcyrzl: 'Please input carrier weight',
    qsrsfh: 'Please input the sealing number',
    jyyxc: 'Unloading inspection',
    qrtj: 'Confirm submission?',
    qrxg: 'Confirm modification?',
    xhzlbnwk: 'Total weight of container load cannot be empty',
    tyrzlts: 'The weight ascertained by the consignor cannot be empty',
    cyrzlts: 'The weight ascertained by the carrier cannot be empty',
    xhzzts: 'The total weight of container load cannot be less than the carrier weight',
    sfhts: 'Sealing number cannot be empty',
    kzxxlb: 'List of loading information',
    yznzxlb: 'List of containerized goods in station',
    fhdwmc: 'Consignor name',
    shdwmc: 'Name of consignee',
    fzmc: 'Departure station name',
    dzmc: 'Arrival station name',
    xlmc: 'Container category name',
    xsmc: 'Container ownership name',
    xxmc: 'Container type name',
    tip122: 'List already containerized, no need to repeat',
    tip190: 'Submit?',
    zc: 'Loading',
    qxzxh1: 'Please select container number 1',
    qxzxh2: 'Please select container number 2',
    qxzxh3: 'Please select container number 3',
    jg: 'Within CR regional group operation scope',
    fjg: 'Not within operation scope of CR regional group company',
    cxbnzyzw: 'Off-track time cannot be earlier than the loading completion time',
    dzmcbcz: 'The arrival station name does not exist. Please select again',
    dzbnwk: 'Arrival station cannot be empty',
    dlhbnwk: 'Dispatching order number cannot be empty',
    qdzcm: 'Load?',
    qdcxdqhs: 'Cancel the current return loading record?',
    tip221: 'The container number 1 of xx is the same as container number 2',
    tip222: 'The container number 1 of xx is the same as container number 3',
    tip223: 'The container number 1 of xx and sequence number',
    tip224: 'The container number 1 of xx is the same',
    tip225: 'The container number 2 of xx is the same as container number 3',
    tip226: 'The container number 2 of xx and sequence number',
    tip227: 'The container number 2 of xx is the same',
    tip228: 'The container number 3 of xx and sequence number',
    tip229: 'The container number 3 of xx is the same',
    tip199: 'No container number created',
    xhbcz: 'Container number does not exist, please add again',
    wei: 'in case of',
    wzcbktj: 'In case of loaded car, the data cannot be submitted! ! !',
    tip323: 'Foot universal container, cannot be with',
    tip322: 'Foot universal container',
    tip334: 'Loading together',
    tip92: 'Only 2 universal 20-foot containers can be loaded on the same vehicle',
    clwls: 'Vehicles are not confirmed and cannot be loaded',
    tip3: 'On-track data irrevocable!!!',
    tip120: 'Unloaded, irrevocable! ! !',
    tip564: 'Weighing pending',
    tip565: 'Weighed',
    tip566: 'To be delivered externally',
    tip567: 'Delivered externally',
    jzxwjf: 'Delivery outside the container',
    zntx: 'Unstuffing in the station',
    tzqh: 'Notification for goods pick-up',
    kxhs: 'Return of empty container',
    jjyh: 'Weighing and goods inspection',
    znzx: 'Loading in the station',
    txlr: 'Entry of pick-up',
    tip196: 'Off-track operation is not allowed without ticket printing',
    xhzz: 'Container number tracking',
    xq: 'details',
    yianpai: 'Arranged already',
    sbxhw: 'The pick-up and delivery company has dispatched orders for some containers, and it is not allowed to cancel the reservation for station entry of these containers'
  },
  confirmationBill: {
    qrzt: 'Confirm status',
    dqr: 'To be confirmed',
    yqr: 'Confirmed',
    qrpj: 'Confirm bills',
    qztitle: 'After confirmation, it will be automatically signed and sealed for you. Please confirm',
  },
  jqsd: {
    yssl: 'Transport volume',
    dh: 'Order No',
    dpd: 'Order to be allocated',
    ypd: 'Dispatched',
    pdsj: 'Order allocation time',
    pdzt: 'Order allocation status',
    jqsdxq: 'Pick-up and delivery details',
    cxpd: 'Re-allocation of order',
    jqsdqrzt: 'Signature status',
    yqr: 'Endorsed',
    wqr: 'Unendorsed',
    qianren: 'Endorsement',
    qrsj: 'Signing time',
    yxzt: 'Validity status',
    wxnj: 'Vientiane South (border)',
    hscl: 'Cargo damage handling',
    plzf: 'Batch invalidation',
    slzx: 'Acceptance center',
    qxzslcz: 'Please select the acceptance station',
    slcztext: 'Please select the acceptance station. After the online review is completed, bring relevant documents to the station for offline confirmation and review.',
    q7tndlxt: 'Please log in to the system within 7 days to check the review progress',
    qxdzzwjjxsh: "Please bring paper documents of all attachments uploaded during registration to the acceptance center for review",
    shjd: 'Review progress',
    wcsj: 'Completion time',
    jg: 'Result',
    sjzt: 'Data status',
    czry: 'Operator',
    wwc: 'Uncompleted',
    ygx: 'Updated',
    zjygx: 'ID document updated',
    qxg: 'Modify',
    scxy: "Upload protocol",
    frsfz: 'ID card of the legal person',
    frhz: 'Passport of the legal person',
    jbrhz: 'Handler’s passport',
    yfkxy: 'Advance payment agreement',
    yfkxysy: 'Photo of the home page of the advance payment agreement',
    qscyfkxysy: 'Please upload a photo of the home page of the advance payment agreement',
    yfkxywy: '预付款协议双方盖章页照片(en)',
    qscyfkxywy: '请上传预付款协议双方盖章页照片(en)',
    yfkxyyxq: 'Term of validity of advance payment agreement',
    qxzyfkxyyxq: 'Please select the term of validity of advance payment agreement',
    cxtb: "Re-submit",
    xgrqyyrqyz: "The modified date is consistent with the original date",
    tddjj: "Report to the dispatcher for rejection",
    jjnr: "Rejected content",
    xgnr: "Revised content",
    jsrqdayksrq: "The ending date must be later than the start date",
    gwjbspdf: "This file is not in pdf format and does not support preview",
    xglc: "Modify kilometerage",
    wlgsjjzt: "Logistics company rejection status"
  },
  wtlh: {
     qxzqh:"Please select area code",
    qh:"Area code",
    czslzt:"Station acceptance status",
    wtlh: 'Entrusted pick-up',
    lhcz: 'Pick-up station',
    cxdlhw: 'Inquiry and collection of goods',
    lhphone: 'Pick-up mobile phone number',
    jbrzjz: 'ID photo of the handler',
    dlhw: "Goods to be collected",
    qsc: 'Please upload',
    qtwj: 'Other documents',
    benren: 'In person',
    weituo: 'Entrusted',
    dqxzsc1: 'Current restriction on uploading 1 file',
    zhuxiao: "delete account",
    qdzxdqzhm: "Are you sure you want to delete the current account?",
    zcqrzxdqzh: 'Logging out will delete the current enterprise user and prevent further login. Are you sure?',
    cgnzfbxyfydsj: "This function invalidates the container booking data that does not need to be shipped, please confirm again!",
    czyxglyd: "Valid international intermodal transport waybills are not allowed to be voided",
    zuid8ws: "Minimum 8 digits",
    zdtj: "Folding conditions",
    gdtj: "More conditions",
    dl: "login"
  },
  guide :{
    czsdbgwjsj:"Time when the station receives report documents",
    jsqOnly:"Handle JSQ only",
    gccyOnly:"Only handle diesel arriving at 20-foot tank containers for shipment"
  },
  jqsdtj:{
       yilian:'Coupon B',
       binglian:'Coupon C',
      dywlpsd:'Print logistics delivery order',
       wlpsd: "Logistics delivery order",
        pddw: "Dispatching unit",
        pdr: "Dispatcher",
        pdsj: "Order allocation time",
        jhsj: "Delivery date",
        khdw: "Customer unit",
        sqhxxdz: "Detailed delivery (pick-up) address",
        gls: "Kilometrage",
        cxch: "Model and train ID No.",
        gbdd: "Weighing location",
        qhshwzk: "Goods condition at the time of pick-up",
        jhshwzk: "Goods condition at the time of delivery",
        zxap: "Loading and unloading arrangement",
        hwysyq: "Goods transportation requirements",
        wtqcysgs: "Entrust automobile transportation company",
        khdfwzlpj: "Customer evaluation of service quality",
        fcmy: "Very satisfied",
        my: "Satisfied",
        bmy: "Dissatisfied",
        yr: "Combustible",
        yb: "Explosive",
        ys: "Fragile",
        ps: "Keep dry",
        yw: "Odor",
        yc: "Dust",
        jzfg: "Do not cover ",
        jzzy: "No heavy pressure",
        zzfx: "Loading direction",
        fzhd: "Anti-slide",
        fzpz: "Anti-collision",
        hwjfr: "Cargo deliverer",
        jsy: "Driver",
        fwlgs: 'Depart for the logistics company',
        dwlgs: 'Arrive at the logistics company',
        tks:"Iron ore",
        tks1:"Iron ore lumps",
        tkf:"Iron ore fines",
        tjk:"Iron ore concentrate",
			  tjkf:"Iron concentrate fines",
			  qttks:"Other iron ore"
  },
  zcxz: {
    zcxz1: "Notice on Registration for the Laos-China Railway International Logistics Platform",
    zcxz2: "Welcome to register as a user of the Laos-China Railway International Logistics Platform! Before you begin the registration process, please carefully read the following content to understand our services and user rights and obligations.",
    zcxz3: "User registration and login",
    zcxz4: "You must be at least 19 years old or reach legal age according to the laws of your country/region in order to register as a user. You need to provide accurate, complete, and truthful business or personal information, and ensure timely updates to maintain the accuracy of the information.",
    zcxz5: "Materials required for registration：",
    zcxz6: "Individual users: Name, nationality, mailing address, ID card/passport number and expiration date, mobile phone number, email, photo of the front of the ID card/passport information page, photo of the front of the ID card/passport information page held by the individual.",
    zcxz7: "Enterprise users: enterprise name, enterprise tax number, business license number, registered capital, industry, economic nature, enterprise nature, institution type, enterprise bank account, account opening bank, enterprise phone number, enterprise email, business scope, enterprise address, legal person name, legal person nationality, legal person ID card/passport number and validity period, superior company name, superior company tax number, superior company business license number, business license image and validity period, legal person ID card front/passport information page photo, legal person holding legal person ID card front/passport information page photo, qualification front material image and validity period, authorization certificate image and validity period (to be submitted when the legal person is not the operator), operator name, operator nationality, operator communication address, operator ID card Passport number and expiration date Operator's mobile phone number, operator's email, operator's ID card front/passport information page photo, operator holding ID card front/passport information page photo.",
    zcxz8: "Registration process: ",
    zcxz9: "Individual users: 1. Fill in personal basic information; 2. Choose a service station; 3. Through online review; 4. Bring registration materials to complete offline confirmation.",
    zcxz10: "Enterprise users: 1. Fill in the basic information of the enterprise; 2. Upload identification documents; 3. Fill in the information of the handling person; 4. Choose a service station; 3. Through online review; 4. Carry registration materials and company seal to complete offline confirmation. For enterprise users, you need to provide unique agent information. Once registered successfully, the agent has full authority to handle the enterprise's freight business.",
    zcxz11: "Login process: ",
    zcxz12: "Individual user: Enter the registered phone number and password on the login interface to complete the first login.",
    zcxz13: "Enterprise users: Enter the operator's phone number and registration password on the login interface to complete the first login.",
    zcxz14: "Account security",
    zcxz15: "You are responsible for protecting the security of your account. Please set a password with a length of 8-15 characters, including numbers and uppercase and lowercase letters, and change the password regularly.",
    zcxz16: "Please keep your account information safe and do not share or disclose it with others. If any abnormalities or suspected unauthorized use of your account are found, please contact the official phone number immediately.",
    zcxz17: "User Rights",
    zcxz18: "As a registered user, you have the right to handle freight services within the validity period of relevant documents and certificates. For more details, please refer to the 'Customer Service Agreement of Laos-China Railway International Logistics Platform '.",
    zcxz19: "We will strictly protect your personal information and comply with applicable privacy policies and legal regulations.",
    zcxz20: "User Responsibility",
    zcxz21: "You are responsible for all activities conducted using your account.",
    zcxz22: "You are not allowed to use your account to engage in any illegal, irregular or infringing behavior on the rights and interests of others.",
    zcxz23: "Please comply with the platform's usage standards and code of conduct, and maintain the normal operation of the platform.",
    zcxz24: "Privacy Policy",
    zcxz25: "Our Privacy Policy provides detailed instructions on how we collect, use, store, and protect your personal information. Please read the Privacy Policy to understand how your personal information is processed and used.",
    zcxz26: "Contact Information",
    zcxz27: "If you have any other opinions or suggestions, please contact 856-2026887846.",
    cyjbr:"Commonly used handlers",
        sfblzcyw:"Whether to handle the complete vehicle business",
sfbljzxyw:"Whether to handle container business",
sfswxp:"Dangerous goods or not",
lfm:"m³",
dun:"Ton",
xj:"Rubber",
lseahf:"Diammonium phosphate (fertilizer)",
sf:"Potato flour",
ms:"Cassava",
tks:"Iron ore",
tksha:"Iron ore sand",
dg:"Strip steel",
xsg:"Fresh fruit",
ly:"Longan",
xsc:"Fresh vegetables",
lwg:"Thread steel",
scwj:"Upload files",
spxs:'审批箱数(en)',
hyz:'货运站(en)',
zdqznl:"最大起重能力(en)",
ccqznl:"叉车起重能力(en)",
jzxqznl20:"20英尺集装箱起重能力(en)",
jzxqznl40:"40(45)英尺集装箱起重能力(en)",
hwzzxdbjzz:"箱货总重必须小于等于标记总重(en)",
blfw:"办理范围(en)",
zcblfw:'整车办理范围(en)',
blfspl:"办理发送品类(en)",
blddpl:"办理到达品类(en)",
bblfspl:"不办理发送品类(en)",
bblddpl:"不办理到达品类(en)",
blhwtz:'办理货物特征(en)',
cz:"超重(en)",
cx:'超限(en)',
jzxblfw:"集装箱办理范围(en)",
ycx20:"20英尺箱(en)",
ycx40:"40(45)英尺箱(en)",
gsx20:'20英尺干散箱(en)',
sng20:"20英尺水泥罐式箱(en)",
ytg20:'20英尺液体罐式箱(en)',
lqg20:'20英尺石油沥青罐式箱(en)',
jgx20:'20英尺台架式卷钢箱(en)',
tcd35:"20英尺35t敞顶箱(en)",
wxpblfw:'危险品办理范围(en)',
fspm:"发送品名(en)",
ddpm:"到达品名(en)",
xxxx:'详细信息(en)',
yidao:'已到(en)',
cong:'从(en)',
dao:'到(en)',
dydy0dzs:"请输入大于等于0的整数(en)",
yty:"已同意(en)",
ysx:'已失效(en)',
qxmr:'取消默认(en)',
ddmfzf:"等待买方支付(en)",
qrsh:'确认收货(en)',
ddmfqrsh:"等待买方确认收货(en)",
jiaofu:'交付(en)',
ckjgd:'查看交割单(en)',
smzx:'上门装箱(en)',
wl_zdm:'物流-站到门(en)',
smtx:'上门掏箱(en)',
max40000:'最大值限制为40000kg(en)',
ydyjtjbnxg:'运单一经提交，不能修改，您确认提交？(en)',
ydgxcg:"运单更新成功(en)",
qxzybgdsj:"请选择要变更到站的数据!(en)",
lpxx:"理赔信息(en)",
pctzs:'赔偿通知书(en)',
tpcg:"提赔成功(en)",
myd:'满意度(en)',
jicha:"极差(en)",
shiwang:"失望(en)",
yiban:"一般(en)",
chaozan:"超赞(en)",
wstpxz:"网上提赔须知(en)",
cxhyjl:"查询货运记录(en)",
tjlpsqs:"提交理赔申请书(en)",
tpsqcg:'提赔申请成功(en)',
hyjlbzzjhm:"货运记录编制站及号码：(en)",
kuche:'库车，王家营192839，1929384(en)',
tpr:"提赔人(单位或姓名)(en)",
yqpcke:"要求赔偿款额(元)(en)",
xxtxdz:"详细通信地址(en)",
lkfs:"领款方式(en)",
yhzzzf:'银行转账支付(en)',
czlqxj:"车站领取现金(en)",
skr:"收款人(单位或姓名)(en)",
skyh:"收款银行(en)",
skzh:"收款账号(en)",
qxzslz:"请选择受理站(en)",
zysx:"注意事项(en)",
zysx1:"填写内容应清楚、准确。(en)",
zysx2:"提赔单位、姓名必须与货物运单或快运货票记载的收货方或托运方相符。(en)",
zysx3:"领款方式选择“银行转账支付”，收款人（单位或姓名）、收款银行、收款账号信息必须填写完整。(en)",
zysx4:"建议您上传理赔的相关资料，并确保资料真实、有效，网上提交资料将加快理赔办理进度。(en)",
zysx5:"您提交的相关资料仅用于本次理赔办理，我们承诺不会向第三方提供。(en)",
dlm:"动力煤(en)",
ljm:"炼焦煤(en)",
wym:"无烟煤(en)",
pcm:"喷吹煤(en)",
kmei:"块煤(en)",
lant:"兰炭(en)",
lplc:"理赔流程(en)",
spxz:"索赔须知(en)",
spxz1:'尊敬的客户：(en)',
spxz2:"在铁路运输过程中，货物发生灭失、短少或者损坏，您可自领到货运记录的次日起180日内，向到站或发站提出赔偿要求。 如果货物超过运到期限，经过30日铁路部门仍不能向您交付货物时，您可以按货物灭失向到站或发站提出赔偿要求。 下列原因造成的货物损失,铁路不承担赔偿责任:(en)",
spxz3:"1.不可抗力;(en)",
spxz4:"2.货物本身的自然属性或者合理损耗;(en)",
spxz5:"3.托运方、收货方或押运人的过错。(en)",
spxz6:"您向铁路提出赔偿要求时，请准确、清楚填写《理赔申请书》，其中提赔单位、姓名必须与货物运单记载的收货方或托运方相符。需转账的，提供的开户行、户名和账号信息必须一致。同时，还需提供以下证明材料：",
spxz7:"1.货运记录（货主页）原件;(en)",
spxz8:"2.货物运单原件;(en)",
spxz9:"3.物品清单（发站没有填制的除外);(en)",
spxz10:"4.其他必要的证明材料。(en)",
spxz11:'如委托他人代理时，还须提供委托书、委托人和被委托人的身份证明复印件。(en)',
spxz12:'办理保价运输的货物，全批货物损失时，赔偿金额最高不超过保价金额；部分损失时，赔偿金额按损失货物占全批货物的比例乘以保价金额赔偿。(en)',
spxz13:"未办理保价运输的货物，按照实际损失赔偿，但最高不超过规定的赔偿限额。(en)",
spxz14:'办理保险运输的货物，您可凭车站出具的货运记录，按照保险合同的约定，到保险公司办理赔偿。(en)',
spxz15:"您在网上提出赔偿要求时，如您已在到站领取货运记录，请您提供货运记录货主页原件的清晰扫描件或照片。(en)",
spxz16:"如您委托他人代理时，还须提供委托书、委托人和被委托人的身份证明原件的清晰扫描件或照片。(en)",
spxz17:"您所提交的资料应真实有效。铁路部门将对您提供的资料进行审核。(en)",
spxz18:'如您需要详细了解有关货物损失赔偿方面的具体事宜，请与车站联系。(en)',
bty:"不同意(en)",
hao:"号(en)",
guanyu:"关于(en)",
you:"由(en)",
zcyd:"站承运到(en)",
hydh:"货运单号(en)",
fasheng:'发生(en)',
hwsspcyqry:'货物损失，赔偿要求人于(en)',
yqtlpc:"要求铁路赔偿(en)",
yiche:"一车，(en)",
yu:"于(en)",
sljshtypc:"受理，经审核同意赔偿(en)",
lqcz:"领取车站(en)",
skrdwhxm:"收款人（单位或姓名）(en)",
bclpdmyd:"本次理赔的满意度(en)",
sfyjtzs:'是否邮寄通知书(en)',
youji:"邮寄(en)",
buyouji:"不邮寄(en)",
jinyi:"建议(en)",
qtcchdl:"请退出重新登录(en)",
yhzz:"银行转账(en)",
czlxj:"车站领现金(en)",
buchong:"补充(en)",
sbd:"所编第(en)",
jilu:"记录(en)",
yshm:"运输号码(en)",
chengyun:"承运(en)",
zcdw:'装车单位(en)',
xcdw:'卸车单位(en)',
chezlx:"车种类型(en)",
clcdd:"次列车到达(en)",
ksxc:'开始卸车(en)',
xiewan:'卸完(en)',
fysfdw:"封印：施封单位(en)",
sfbh:"施封编号(en)",
pbpbhm:'篷布：篷布号码(en)',
baojia:"保价(en)",
xiangmu:"项目(en)",
cyf:"承运方(en)",
pjyjz:'票据原记载按照实际货物损失详细情况(en)',
gcrxhjh:"该车入线货检好，封施有效，开启车门卸见上货码7-9个高，实卸1153件，较王家营站2015年2月9日编1545101号货运记录实装1160件不足7件，车容未满，能容少件，全车卸空无残。(en)",
cjrqz:"参加人签章(en)",
czfzr:"车站负责人(en)",
bzr:"编制人(en)",
gary:"公安人员(en)",
qtry:"其他人员(en)",
zhuangxie:"装卸(en)",
fengyin:'封印(en)',
jfhwsshryj:"交付货物时收货人意见(en)",
yijian:"意见(en)",
kmtlj:"昆明铁路局(en)",
bianzhi:"编制(en)",
qsrzqcxtj:"请输入正确的查询条件(en)",
lingtan:"零摊(en)",
qxzxthwmcsh:'请选择相同货物名称数据(en)',
qxzxthwfwsh:'请选择相同货物范围数据(en)',
jzxyjhz:"集装箱押金回执(en)",
jzxyjhzzp:"集装箱押金回执照片(en)",
jzxyjhzyxq:"集装箱押金回执有效期(en)",
xzdqxqdjxywqqhdsj:"选择当前需求单进行月需求切换的数据有：(en)",
xytcbqwczjjzt:'已提出并且为车站拒绝状态的日需求数据：(en)',
wtcrxqdxqdsj:'未提出日需求的需求单数据有：(en)',
zdksr300:"(最多可输入300字)(en)",
htqsrq:'合同起始日期(en)',
htjzrq:"合同截止日期(en)",
ydlcxqsctxzm:"预订冷藏箱，请上传提箱证明(en)",
gjhgyqydhbtfpbl:"According to customs requirements, goods with different reservation numbers should be processed for customs clearance in batches",
xgyxqh:"修改月需求号(en)",
zbxxx:"自备箱信息(en)",
lwbg:"老挝报关:(en)",
mhbggs:"磨憨报关公司:(en)"
  }
};
